const calculateWorkbookValues = ({
  odds = [],
  totalGoals = [],
  bothTeams = [],
}) => {
  const domacin1 = parseInputNumber(odds[0]) ?? ''
  const neresenoX = parseInputNumber(odds[1]) ?? ''
  const gost2 = parseInputNumber(odds[2]) ?? ''
  const golovi0Do2 = parseInputNumber(totalGoals[0]) ?? ''
  const golovi3Plus = parseInputNumber(totalGoals[1]) ?? ''
  const obaDajuGol = parseInputNumber(bothTeams[0]) ?? ''
  const neObaDajuGol = parseInputNumber(bothTeams[1]) ?? ''

  let B3 = domacin1
  let D3 = neresenoX
  let F3 = gost2
  let H3 = golovi0Do2
  let J3 = golovi3Plus
  let L3 = obaDajuGol
  let N3 = neObaDajuGol

  let BT3 = 0,
    BU3 = 0,
    J7 = '',
    K7 = '',
    L7 = '',
    M7 = '',
    N7 = '',
    O7 = '',
    P7 = '',
    Q7 = '',
    R7 = '',
    S7 = '',
    T7 = '',
    U7 = '',
    V7 = '',
    W7 = '',
    X7 = '',
    Y7 = '',
    Z7 = '',
    AA7 = '',
    AB7 = '',
    AC7 = '',
    AD7 = '',
    AE7 = '',
    AF7 = '',
    AG7 = '',
    AH7 = '',
    AI7 = '',
    AJ7 = '',
    AK7 = '',
    AL7 = '',
    AM7 = '',
    AN7 = '',
    AO7 = '',
    AP7 = '',
    AQ7 = '',
    AR7 = '',
    AS7 = '',
    AT7 = '',
    AU7 = '',
    AV7 = '',
    AW7 = '',
    AX7 = '',
    AY7 = '',
    AZ7 = '',
    BA7 = '',
    BB7 = '',
    BC7 = '',
    BD7 = '',
    BE7 = '',
    BF7 = '',
    BG7 = '',
    BH7 = '',
    BI7 = '',
    BJ7 = '',
    BK7 = '',
    BL7 = '',
    BM7 = '',
    BN7 = '',
    BO7 = '',
    BP7 = '',
    BQ7 = '',
    BR7 = '',
    BS7 = '',
    BT7 = '',
    BU7 = '',
    BV7 = '',
    BW7 = '',
    BX7 = '',
    BY7 = '',
    BZ7 = '',
    CA7 = '',
    CB7 = '',
    CC7 = '',
    CD7 = '',
    CE7 = '',
    CF7 = '',
    B8 = '',
    D8 = '',
    F8 = '',
    BT11 = '',
    BU11 = '',
    BV11 = '',
    BW11 = '',
    BX11 = '',
    BY11 = '',
    BZ11 = '',
    Z12 = '',
    AB12 = '',
    AD12 = '',
    AF12 = '',
    AH12 = '',
    AJ12 = '',
    AP12 = '',
    AT12 = '',
    BA12 = '',
    BB12 = '',
    BC12 = '',
    BD12 = '',
    BE12 = '',
    BT12 = '',
    BU12 = '',
    BV12 = '',
    BW12 = '',
    BX12 = '',
    BY12 = '',
    BZ12 = '',
    CA12 = '',
    CB12 = '',
    CE12 = '',
    BA13 = '',
    BB13 = '',
    BT13 = '',
    BU13 = '',
    BV13 = '',
    BW13 = '',
    BX13 = '',
    BY13 = '',
    BZ13 = '',
    CA13 = '',
    CB13 = '',
    CE13 = '',
    AJ14 = '',
    AP14 = '',
    AT14 = '',
    BA14 = '',
    BT14 = '',
    BU14 = '',
    BV14 = '',
    BW14 = '',
    BX14 = '',
    BY14 = '',
    BZ14 = '',
    CA14 = '',
    CH14 = '',
    AJ15 = '',
    B16 = '',
    D16 = '',
    F16 = '',
    H16 = '',
    J16 = '',
    L16 = '',
    N16 = '',
    P16 = '',
    R16 = '',
    T16 = '',
    V16 = '',
    X16 = '',
    AJ16 = '',
    AP16 = '',
    AT16 = '',
    BT16 = '',
    BU16 = '',
    BV16 = '',
    BW16 = '',
    BX16 = '',
    BY16 = '',
    BZ16 = '',
    CA16 = '',
    CB16 = '',
    CE16 = '',
    CH16 = '',
    BT17 = '',
    BU17 = '',
    BV17 = '',
    BW17 = '',
    BX17 = '',
    BY17 = '',
    BZ17 = '',
    CB17 = '',
    BC19 = '',
    BD19 = '',
    BE19 = '',
    BF19 = '',
    BG19 = '',
    BH19 = '',
    BI19 = '',
    BJ19 = '',
    BK19 = '',
    BL19 = '',
    BM19 = '',
    BN19 = '',
    BO19 = '',
    BP19 = '',
    BQ19 = '',
    BT19 = 0,
    BU19 = 1,
    BV19 = 2,
    BW19 = 3,
    BX19 = 4,
    BY19 = 5,
    BZ19 = 6,
    CE19 = '',
    BT20 = '',
    BU20 = '',
    BV20 = '',
    BW20 = '',
    BX20 = '',
    BY20 = '',
    BZ20 = '',
    CB20 = '',
    CE21 = '',
    BT22 = '',
    BU22 = '',
    BV22 = '',
    BW22 = '',
    BX22 = '',
    BY22 = '',
    BZ22 = '',
    CA22 = '',
    CE22 = '',
    BH23 = '',
    CH23 = '',
    BI24 = '',
    H25 = '',
    J25 = '',
    L25 = '',
    R25 = '',
    T25 = '',
    V25 = '',
    X25 = '',
    Z25 = '',
    AB25 = '',
    AD25 = '',
    AI25 = '',
    AJ25 = '',
    AL25 = '',
    AN25 = '',
    AP25 = '',
    AR25 = '',
    AT25 = '',
    AV25 = '',
    AX25 = '',
    CE25 = '',
    CH25 = '',
    H27 = '',
    J27 = '',
    L27 = '',
    Z27 = '',
    AB27 = '',
    AD27 = '',
    AR27 = '',
    AT27 = '',
    AV27 = '',
    BT28 = '',
    BU28 = '',
    BV28 = '',
    BW28 = '',
    BX28 = '',
    CE28 = '',
    BT30 = '',
    BU30 = '',
    H31 = '',
    J31 = '',
    L31 = '',
    Z31 = '',
    AB31 = '',
    AD31 = '',
    AR31 = '',
    AT31 = '',
    AV31 = '',
    H33 = '',
    J33 = '',
    L33 = '',
    Z33 = '',
    AB33 = '',
    AD33 = '',
    AR33 = '',
    AT33 = '',
    AV33 = '',
    BT36 = '',
    BU36 = '',
    BV36 = '',
    H37 = '',
    J37 = '',
    L37 = '',
    N37 = '',
    Z37 = '',
    AB37 = '',
    AR37 = '',
    AT37 = '',
    BT37 = '',
    BU37 = '',
    BV37 = '',
    BW37 = '',
    BX37 = '',
    H39 = '',
    J39 = '',
    L39 = '',
    N39 = '',
    Z39 = '',
    AB39 = '',
    AR39 = '',
    AT39 = '',
    BT39 = '',
    BU39 = '',
    BV39 = '',
    BW39 = '',
    BY39 = '',
    BT42 = '',
    H43 = '',
    J43 = '',
    L43 = '',
    AR43 = '',
    AT43 = '',
    H45 = '',
    J45 = '',
    L45 = '',
    AR45 = '',
    AT45 = '',
    BT45 = '',
    BU45 = '',
    H49 = '',
    J49 = '',
    L49 = '',
    N49 = '',
    P49 = '',
    R49 = '',
    AR49 = '',
    AT49 = '',
    BT49 = '',
    BU49 = '',
    BT50 = '',
    BU50 = '',
    H51 = '',
    J51 = '',
    L51 = '',
    N51 = '',
    P51 = '',
    R51 = '',
    AR51 = '',
    AT51 = '',
    BT52 = '',
    H57 = '',
    J57 = '',
    L57 = '',
    N57 = '',
    P57 = '',
    R57 = '',
    T57 = '',
    V57 = '',
    X57 = '',
    Z57 = '',
    AB57 = '',
    AD57 = '',
    AF57 = '',
    AH57 = '',
    AJ57 = '',
    AL57 = '',
    AN57 = '',
    AP57 = '',
    AR57 = '',
    AT57 = '',
    AV57 = '',
    AX57 = '',
    H59 = '',
    J59 = '',
    L59 = '',
    N59 = '',
    P59 = '',
    R59 = '',
    T59 = '',
    V59 = '',
    X59 = '',
    Z59 = '',
    AB59 = '',
    AD59 = '',
    AF59 = '',
    AH59 = '',
    AJ59 = '',
    AL59 = '',
    AN59 = '',
    AP59 = '',
    AR59 = '',
    AT59 = '',
    AV59 = '',
    AX59 = '',
    H63 = '',
    J63 = '',
    N63 = '',
    P63 = '',
    R63 = '',
    T63 = '',
    V63 = '',
    X63 = '',
    Z63 = '',
    H65 = '',
    J65 = '',
    N65 = '',
    P65 = '',
    R65 = '',
    T65 = '',
    V65 = '',
    X65 = '',
    Z65 = '',
    BT65 = '',
    BU65 = '',
    BT67 = '',
    BU67 = '',
    BT68 = '',
    BU68 = '',
    H69 = '',
    J69 = '',
    L69 = '',
    N69 = '',
    P69 = '',
    R69 = '',
    BT70 = '',
    BU70 = '',
    H71 = '',
    J71 = '',
    L71 = '',
    N71 = '',
    P71 = '',
    R71 = '',
    BT71 = '',
    BU71 = '',
    H75 = '',
    J75 = '',
    L75 = '',
    N75 = '',
    R75 = '',
    V75 = '',
    X75 = '',
    Z75 = '',
    AB75 = '',
    H77 = '',
    J77 = '',
    L77 = '',
    N77 = '',
    R77 = '',
    V77 = '',
    X77 = '',
    Z77 = '',
    AB77 = '',
    H81 = '',
    J81 = '',
    H83 = '',
    J83 = '',
    H87 = '',
    J87 = '',
    L87 = '',
    N87 = '',
    P87 = '',
    R87 = '',
    T87 = '',
    V87 = '',
    X87 = '',
    Z87 = '',
    AB87 = '',
    AD87 = '',
    AF87 = '',
    AH87 = '',
    AJ87 = '',
    AL87 = '',
    AN87 = '',
    H89 = '',
    J89 = '',
    L89 = '',
    N89 = '',
    P89 = '',
    R89 = '',
    T89 = '',
    V89 = '',
    X89 = '',
    Z89 = '',
    AB89 = '',
    AD89 = '',
    AF89 = '',
    AH89 = '',
    AJ89 = '',
    AL89 = '',
    H93 = '',
    J93 = '',
    L93 = '',
    N93 = '',
    P93 = '',
    R93 = '',
    T93 = '',
    V93 = '',
    X93 = '',
    Z93 = '',
    AB93 = '',
    AD93 = '',
    AF93 = '',
    AH93 = '',
    AJ93 = '',
    AL93 = '',
    AN93 = '',
    H94 = '',
    J94 = '',
    L94 = '',
    N94 = '',
    P94 = '',
    R94 = '',
    T94 = '',
    V94 = '',
    X94 = '',
    Z94 = '',
    AB94 = '',
    AD94 = '',
    AF94 = '',
    AH94 = '',
    AJ94 = '',
    AL94 = '',
    H96 = '',
    J96 = '',
    L96 = '',
    N96 = '',
    P96 = '',
    R96 = '',
    T96 = '',
    V96 = '',
    X96 = '',
    Z96 = '',
    AB96 = '',
    AD96 = '',
    AF96 = '',
    AH96 = '',
    AJ96 = '',
    AL96 = '',
    H100 = '',
    J100 = '',
    L100 = '',
    P100 = '',
    T100 = '',
    X100 = '',
    AB100 = '',
    AF100 = '',
    AJ100 = '',
    AN100 = '',
    AR100 = '',
    AV100 = '',
    H102 = '',
    J102 = '',
    L102 = '',
    P102 = '',
    T102 = '',
    X102 = '',
    AB102 = '',
    AF102 = '',
    AJ102 = '',
    AN102 = '',
    AR102 = '',
    AV102 = '',
    H106 = '',
    L106 = '',
    P106 = '',
    T106 = '',
    X106 = '',
    AB106 = '',
    AF106 = '',
    AJ106 = '',
    AN106 = '',
    AR106 = '',
    AV106 = '',
    H108 = '',
    L108 = '',
    P108 = '',
    T108 = '',
    X108 = '',
    AB108 = '',
    AF108 = '',
    AJ108 = '',
    AN108 = '',
    AR108 = '',
    AV108 = '',
    H112 = '',
    L112 = '',
    P112 = '',
    T112 = '',
    X112 = '',
    AB112 = '',
    AF112 = '',
    AJ112 = '',
    AN112 = '',
    AR112 = '',
    AV112 = '',
    H114 = '',
    L114 = '',
    P114 = '',
    T114 = '',
    X114 = '',
    AB114 = '',
    AF114 = '',
    AJ114 = '',
    AN114 = '',
    AR114 = '',
    AV114 = '',
    H118 = '',
    L118 = '',
    P118 = '',
    T118 = '',
    X118 = '',
    AB118 = '',
    AF118 = '',
    AJ118 = '',
    AN118 = '',
    AR118 = '',
    AV118 = '',
    H120 = '',
    L120 = '',
    P120 = '',
    T120 = '',
    X120 = '',
    AB120 = '',
    AF120 = '',
    AJ120 = '',
    AN120 = '',
    AR120 = '',
    AV120 = '',
    H124 = '',
    L124 = '',
    P124 = '',
    T124 = '',
    X124 = '',
    AB124 = '',
    AF124 = '',
    AJ124 = '',
    H126 = '',
    L126 = '',
    P126 = '',
    T126 = '',
    X126 = '',
    AB126 = '',
    AF126 = '',
    AJ126 = '',
    H130 = '',
    J130 = '',
    L130 = '',
    N130 = '',
    P130 = '',
    R130 = '',
    T130 = '',
    V130 = '',
    X130 = '',
    Z130 = '',
    AB130 = '',
    AD130 = '',
    AF130 = '',
    AH130 = '',
    AJ130 = '',
    AL130 = '',
    AN130 = '',
    AP130 = '',
    AR130 = '',
    AT130 = '',
    AV130 = '',
    AX130 = '',
    H132 = '',
    J132 = '',
    L132 = '',
    N132 = '',
    P132 = '',
    R132 = '',
    T132 = '',
    V132 = '',
    X132 = '',
    Z132 = '',
    AB132 = '',
    AD132 = '',
    AF132 = '',
    AH132 = '',
    AJ132 = '',
    AL132 = '',
    AN132 = '',
    AP132 = '',
    AR132 = '',
    AT132 = '',
    AV132 = '',
    AX132 = '',
    AJ134 = '',
    AL134 = '',
    AN134 = '',
    AP134 = '',
    AR134 = '',
    AT134 = '',
    H136 = '',
    J136 = '',
    L136 = '',
    N136 = '',
    J138 = '',
    L138 = '',
    N138 = '',
    AF142 = '',
    H144 = '',
    J144 = '',
    L144 = '',
    N144 = '',
    P144 = '',
    R144 = '',
    T144 = '',
    V144 = '',
    X144 = '',
    Z144 = '',
    AB144 = '',
    AD144 = '',
    H146 = '',
    J146 = '',
    L146 = '',
    N146 = '',
    P146 = '',
    R146 = '',
    T146 = '',
    V146 = '',
    X146 = '',
    Z146 = '',
    AB146 = '',
    AD146 = '',
    AF148 = '',
    H150 = '',
    J150 = '',
    L150 = '',
    N150 = '',
    P150 = '',
    R150 = '',
    T150 = '',
    V150 = '',
    X150 = '',
    Z150 = '',
    AB150 = '',
    AD150 = '',
    H152 = '',
    J152 = '',
    L152 = '',
    N152 = '',
    P152 = '',
    R152 = '',
    T152 = '',
    V152 = '',
    X152 = '',
    Z152 = '',
    AB152 = '',
    AD152 = '',
    H156 = '',
    L156 = '',
    P156 = '',
    T156 = '',
    X156 = '',
    AB156 = '',
    AF156 = '',
    AJ156 = '',
    AN156 = '',
    AR156 = '',
    H158 = '',
    L158 = '',
    P158 = '',
    T158 = '',
    X158 = '',
    AB158 = '',
    AF158 = '',
    AJ158 = '',
    AN158 = '',
    AR158 = '',
    H162 = '',
    J162 = '',
    L162 = '',
    N162 = '',
    P162 = '',
    R162 = '',
    T162 = '',
    V162 = '',
    X162 = '',
    Z162 = '',
    AB162 = '',
    AD162 = '',
    AF162 = '',
    AH162 = '',
    AJ162 = '',
    AL162 = '',
    AN162 = '',
    AP162 = '',
    AR162 = '',
    AT162 = '',
    AV162 = '',
    AX162 = '',
    H164 = '',
    J164 = '',
    L164 = '',
    N164 = '',
    P164 = '',
    R164 = '',
    T164 = '',
    V164 = '',
    X164 = '',
    Z164 = '',
    AB164 = '',
    AD164 = '',
    AF164 = '',
    AH164 = '',
    AJ164 = '',
    AL164 = '',
    AN164 = '',
    AP164 = '',
    AR164 = '',
    AT164 = '',
    AV164 = '',
    AX164 = '',
    AJ166 = '',
    AL166 = '',
    AN166 = '',
    AP166 = '',
    AR166 = '',
    AT166 = '',
    H168 = '',
    J168 = '',
    L168 = '',
    N168 = '',
    J170 = '',
    L170 = '',
    N170 = '',
    AF172 = '',
    H174 = '',
    J174 = '',
    L174 = '',
    N174 = '',
    P174 = '',
    R174 = '',
    T174 = '',
    V174 = '',
    X174 = '',
    Z174 = '',
    AB174 = '',
    AD174 = '',
    H176 = '',
    J176 = '',
    L176 = '',
    N176 = '',
    P176 = '',
    R176 = '',
    T176 = '',
    V176 = '',
    X176 = '',
    Z176 = '',
    AB176 = '',
    AD176 = '',
    AF178 = '',
    H180 = '',
    J180 = '',
    L180 = '',
    N180 = '',
    P180 = '',
    R180 = '',
    T180 = '',
    V180 = '',
    X180 = '',
    Z180 = '',
    AB180 = '',
    AD180 = '',
    H182 = '',
    J182 = '',
    L182 = '',
    N182 = '',
    P182 = '',
    R182 = '',
    T182 = '',
    V182 = '',
    X182 = '',
    Z182 = '',
    AB182 = '',
    AD182 = '',
    H186 = '',
    L186 = '',
    P186 = '',
    T186 = '',
    X186 = '',
    AB186 = '',
    AF186 = '',
    AJ186 = '',
    AN186 = '',
    AR186 = '',
    H188 = '',
    L188 = '',
    P188 = '',
    T188 = '',
    X188 = '',
    AB188 = '',
    AF188 = '',
    AJ188 = '',
    AN188 = '',
    AR188 = '',
    H192 = '',
    J192 = '',
    L192 = '',
    N192 = '',
    P192 = '',
    R192 = '',
    T192 = '',
    H194 = '',
    J194 = '',
    L194 = '',
    N194 = '',
    P194 = '',
    R194 = '',
    T194 = '',
    H198 = '',
    J198 = '',
    H200 = '',
    J200 = '',
    H204 = '',
    J204 = '',
    H206 = '',
    J206 = '',
    H210 = '',
    J210 = '',
    L210 = '',
    H212 = '',
    J212 = '',
    L212 = '',
    J215 = '',
    L215 = '',
    T215 = '',
    V215 = '',
    H218 = '',
    J218 = '',
    L218 = '',
    N218 = '',
    P218 = '',
    R218 = '',
    T218 = '',
    V218 = '',
    X218 = '',
    H220 = '',
    J220 = '',
    L220 = '',
    N220 = '',
    P220 = '',
    R220 = '',
    T220 = '',
    V220 = '',
    X220 = '',
    H224 = '',
    J224 = '',
    L224 = '',
    N224 = '',
    P224 = '',
    R224 = '',
    T224 = '',
    V224 = '',
    X224 = '',
    Z224 = '',
    AB224 = '',
    AD224 = '',
    AF224 = '',
    AH224 = '',
    AJ224 = '',
    AL224 = '',
    AN224 = '',
    AP224 = '',
    AR224 = '',
    AT224 = '',
    AV224 = '',
    AX224 = '',
    H226 = '',
    J226 = '',
    L226 = '',
    N226 = '',
    P226 = '',
    R226 = '',
    T226 = '',
    V226 = '',
    X226 = '',
    Z226 = '',
    AB226 = '',
    AD226 = '',
    AF226 = '',
    AH226 = '',
    AJ226 = '',
    AL226 = '',
    AN226 = '',
    AP226 = '',
    AR226 = '',
    AT226 = '',
    AV226 = '',
    AX226 = '',
    H230 = '',
    J230 = '',
    L230 = '',
    N230 = '',
    P230 = '',
    H232 = '',
    J232 = '',
    L232 = '',
    N232 = '',
    P232 = '',
    H238 = '',
    J238 = '',
    L238 = '',
    H240 = '',
    J240 = '',
    L240 = '',
    H244 = '',
    J244 = '',
    L244 = '',
    H246 = '',
    J246 = '',
    L246 = '',
    H252 = '',
    J252 = '',
    L252 = '',
    N252 = '',
    P252 = '',
    R252 = '',
    T252 = '',
    V252 = '',
    X252 = '',
    Z252 = '',
    AD252 = '',
    AF252 = '',
    AH252 = '',
    AJ252 = '',
    AL252 = '',
    AN252 = '',
    AP252 = '',
    AR252 = '',
    AT252 = '',
    AV252 = '',
    AX252 = '',
    H254 = '',
    J254 = '',
    L254 = '',
    N254 = '',
    P254 = '',
    R254 = '',
    T254 = '',
    V254 = '',
    X254 = '',
    Z254 = '',
    AD254 = '',
    AF254 = '',
    AH254 = '',
    AJ254 = '',
    AL254 = '',
    AN254 = '',
    AP254 = '',
    AR254 = '',
    AT254 = '',
    AV254 = '',
    AX254 = '',
    H258 = '',
    J258 = '',
    L258 = '',
    N258 = '',
    P258 = '',
    R258 = '',
    T258 = '',
    V258 = '',
    X258 = '',
    Z258 = '',
    AD258 = '',
    AF258 = '',
    AH258 = '',
    AJ258 = '',
    AL258 = '',
    AN258 = '',
    AP258 = '',
    AR258 = '',
    AT258 = '',
    AV258 = '',
    AX258 = '',
    H260 = '',
    J260 = '',
    L260 = '',
    N260 = '',
    P260 = '',
    R260 = '',
    T260 = '',
    V260 = '',
    X260 = '',
    Z260 = '',
    AD260 = '',
    AF260 = '',
    AH260 = '',
    AJ260 = '',
    AL260 = '',
    AN260 = '',
    AP260 = '',
    AR260 = '',
    AT260 = '',
    AV260 = '',
    AX260 = '',
    H264 = '',
    J264 = '',
    N264 = '',
    P264 = '',
    R264 = '',
    T264 = '',
    V264 = '',
    X264 = '',
    Z264 = '',
    AB264 = '',
    H266 = '',
    J266 = '',
    N266 = '',
    P266 = '',
    R266 = '',
    T266 = '',
    V266 = '',
    X266 = '',
    Z266 = '',
    AB266 = '',
    H270 = '',
    J270 = '',
    L270 = '',
    H272 = '',
    J272 = '',
    L272 = '',
    H276 = '',
    J276 = '',
    L276 = '',
    N276 = '',
    P276 = '',
    R276 = '',
    T276 = '',
    V276 = '',
    X276 = '',
    Z276 = '',
    AB276 = '',
    AD276 = '',
    AF276 = '',
    AH276 = '',
    AJ276 = '',
    AL276 = '',
    AN276 = '',
    AP276 = '',
    AR276 = '',
    AS276 = '',
    AT276 = '',
    AV276 = '',
    AX276 = '',
    H278 = '',
    J278 = '',
    L278 = '',
    N278 = '',
    P278 = '',
    R278 = '',
    T278 = '',
    V278 = '',
    X278 = '',
    Z278 = '',
    AB278 = '',
    AD278 = '',
    AF278 = '',
    AH278 = '',
    AJ278 = '',
    AL278 = '',
    AN278 = '',
    AP278 = '',
    AR278 = '',
    AT278 = '',
    AV278 = '',
    AX278 = '',
    H282 = '',
    J282 = '',
    L282 = '',
    P282 = '',
    R282 = '',
    T282 = '',
    V282 = '',
    X282 = '',
    Z282 = '',
    AB282 = '',
    AD282 = '',
    AF282 = '',
    AH282 = '',
    AJ282 = '',
    AL282 = '',
    AN282 = '',
    AP282 = '',
    AR282 = '',
    AT282 = '',
    AV282 = '',
    AX282 = '',
    H284 = '',
    J284 = '',
    L284 = '',
    P284 = '',
    R284 = '',
    T284 = '',
    V284 = '',
    X284 = '',
    Z284 = '',
    AB284 = '',
    AD284 = '',
    AF284 = '',
    AH284 = '',
    AJ284 = '',
    AL284 = '',
    AN284 = '',
    AP284 = '',
    AR284 = '',
    AT284 = '',
    AV284 = '',
    AX284 = '',
    H288 = '',
    J288 = '',
    L288 = '',
    N288 = '',
    P288 = '',
    R288 = '',
    T288 = '',
    V288 = '',
    X288 = '',
    Z288 = '',
    AB288 = '',
    AD288 = '',
    AF288 = '',
    H290 = '',
    J290 = '',
    L290 = '',
    N290 = '',
    P290 = '',
    R290 = '',
    T290 = '',
    V290 = '',
    X290 = '',
    Z290 = '',
    AB290 = '',
    AD290 = '',
    AF290 = '',
    H294 = '',
    J294 = '',
    L294 = '',
    N294 = '',
    P294 = '',
    R294 = '',
    T294 = '',
    V294 = '',
    X294 = '',
    Z294 = '',
    AB294 = '',
    AD294 = '',
    AF294 = '',
    AJ294 = '',
    AL294 = '',
    AN294 = '',
    H296 = '',
    J296 = '',
    L296 = '',
    N296 = '',
    P296 = '',
    R296 = '',
    T296 = '',
    V296 = '',
    X296 = '',
    Z296 = '',
    AB296 = '',
    AD296 = '',
    AF296 = '',
    AJ296 = '',
    AL296 = '',
    AN296 = '',
    H300 = '',
    J300 = '',
    L300 = '',
    N300 = '',
    P300 = '',
    R300 = '',
    T300 = '',
    X300 = '',
    Z300 = '',
    AB300 = '',
    AD300 = '',
    AF300 = '',
    AH300 = '',
    AJ300 = '',
    AN300 = '',
    AP300 = '',
    AR300 = '',
    AT300 = '',
    AV300 = '',
    H302 = '',
    J302 = '',
    L302 = '',
    N302 = '',
    P302 = '',
    R302 = '',
    T302 = '',
    X302 = '',
    Z302 = '',
    AB302 = '',
    AD302 = '',
    AF302 = '',
    AH302 = '',
    AJ302 = '',
    AN302 = '',
    AP302 = '',
    AR302 = '',
    AT302 = '',
    AV302 = '',
    H306 = '',
    J306 = '',
    L306 = '',
    N306 = '',
    P306 = '',
    R306 = '',
    T306 = '',
    V306 = '',
    X306 = '',
    Z306 = '',
    AB306 = '',
    AD306 = '',
    AF306 = '',
    AH306 = '',
    AJ306 = '',
    AL306 = '',
    AN306 = '',
    AP306 = '',
    AR306 = '',
    AT306 = '',
    AV306 = '',
    AX306 = '',
    H308 = '',
    J308 = '',
    L308 = '',
    N308 = '',
    P308 = '',
    R308 = '',
    T308 = '',
    V308 = '',
    X308 = '',
    Z308 = '',
    AB308 = '',
    AD308 = '',
    AF308 = '',
    AH308 = '',
    AJ308 = '',
    AL308 = '',
    AN308 = '',
    AP308 = '',
    AR308 = '',
    AT308 = '',
    AV308 = '',
    AX308 = '',
    H312 = '',
    J312 = '',
    L312 = '',
    N312 = '',
    P312 = '',
    R312 = '',
    T312 = '',
    V312 = '',
    X312 = '',
    Z312 = '',
    AB312 = '',
    AD312 = '',
    AF312 = '',
    AH312 = '',
    AJ312 = '',
    AL312 = '',
    AN312 = '',
    AP312 = '',
    AR312 = '',
    AT312 = '',
    AV312 = '',
    AX312 = '',
    H314 = '',
    J314 = '',
    L314 = '',
    N314 = '',
    P314 = '',
    R314 = '',
    T314 = '',
    V314 = '',
    X314 = '',
    Z314 = '',
    AB314 = '',
    AD314 = '',
    AF314 = '',
    AH314 = '',
    AJ314 = '',
    AL314 = '',
    AN314 = '',
    AP314 = '',
    AR314 = '',
    AT314 = '',
    AV314 = '',
    AX314 = '',
    H318 = '',
    J318 = '',
    L318 = '',
    N318 = '',
    P318 = '',
    R318 = '',
    T318 = '',
    V318 = '',
    X318 = '',
    Z318 = '',
    AB318 = '',
    AD318 = '',
    AH318 = '',
    AJ318 = '',
    AL318 = '',
    AN318 = '',
    AP318 = '',
    AR318 = '',
    AT318 = '',
    AV318 = '',
    AX318 = '',
    H320 = '',
    J320 = '',
    L320 = '',
    N320 = '',
    P320 = '',
    R320 = '',
    T320 = '',
    V320 = '',
    X320 = '',
    Z320 = '',
    AB320 = '',
    AH320 = '',
    AJ320 = '',
    AL320 = '',
    AN320 = '',
    AP320 = '',
    AR320 = '',
    AT320 = '',
    AV320 = '',
    AX320 = '',
    H324 = '',
    J324 = '',
    L324 = '',
    N324 = '',
    P324 = '',
    R324 = '',
    H326 = '',
    J326 = '',
    L326 = '',
    N326 = '',
    P326 = '',
    R326 = '',
    H332 = '',
    I332 = '',
    J332 = '',
    K332 = '',
    L332 = '',
    M332 = '',
    N332 = '',
    O332 = '',
    P332 = '',
    Q332 = '',
    R332 = '',
    S332 = '',
    T332 = '',
    U332 = '',
    V332 = '',
    W332 = '',
    X332 = '',
    Y332 = '',
    Z332 = '',
    AA332 = '',
    AB332 = '',
    AC332 = '',
    AD332 = '',
    AE332 = '',
    AF332 = '',
    AG332 = '',
    AH332 = '',
    AI332 = '',
    AJ332 = '',
    AK332 = '',
    AL332 = '',
    AM332 = '',
    AN332 = '',
    AO332 = '',
    AP332 = '',
    AQ332 = '',
    AR332 = '',
    AS332 = '',
    AT332 = '',
    AU332 = '',
    AV332 = '',
    AW332 = '',
    AX332 = '',
    H334 = '',
    J334 = '',
    L334 = '',
    N334 = '',
    P334 = '',
    R334 = '',
    T334 = '',
    V334 = '',
    X334 = '',
    Z334 = '',
    AB334 = '',
    AD334 = '',
    AF334 = '',
    AH334 = '',
    AJ334 = '',
    AL334 = '',
    AN334 = '',
    AP334 = '',
    AR334 = '',
    AT334 = '',
    AV334 = '',
    AX334 = '',
    AH336 = '',
    AJ336 = '',
    AL336 = '',
    AN336 = '',
    AP336 = '',
    AR336 = '',
    AH337 = '',
    AJ337 = '',
    AL337 = '',
    AN337 = '',
    AP337 = '',
    AR337 = '',
    H338 = '',
    I338 = '',
    J338 = '',
    K338 = '',
    L338 = '',
    M338 = '',
    N338 = '',
    O338 = '',
    P338 = '',
    Q338 = '',
    R338 = '',
    T338 = '',
    AH338 = '',
    AJ338 = '',
    AL338 = '',
    AN338 = '',
    AP338 = '',
    AR338 = '',
    AH339 = '',
    AJ339 = '',
    AL339 = '',
    AN339 = '',
    AP339 = '',
    AR339 = '',
    H340 = '',
    J340 = '',
    L340 = '',
    N340 = '',
    P340 = '',
    R340 = '',
    T340 = '',
    AH340 = '',
    AJ340 = '',
    AL340 = '',
    AN340 = '',
    AP340 = '',
    AR340 = '',
    H344 = '',
    I344 = '',
    J344 = '',
    K344 = '',
    L344 = '',
    M344 = '',
    N344 = '',
    O344 = '',
    P344 = '',
    Q344 = '',
    R344 = '',
    S344 = '',
    T344 = '',
    U344 = '',
    V344 = '',
    W344 = '',
    X344 = '',
    Y344 = '',
    Z344 = '',
    AA344 = '',
    AB344 = '',
    AC344 = '',
    AD344 = '',
    AE344 = '',
    AF344 = '',
    AG344 = '',
    AH344 = '',
    AI344 = '',
    AJ344 = '',
    AK344 = '',
    AL344 = '',
    AN344 = '',
    H346 = '',
    J346 = '',
    L346 = '',
    N346 = '',
    P346 = '',
    R346 = '',
    T346 = '',
    V346 = '',
    X346 = '',
    Z346 = '',
    AB346 = '',
    AD346 = '',
    AF346 = '',
    AH346 = '',
    AJ346 = '',
    AL346 = '',
    AN346 = '',
    H348 = '',
    J348 = '',
    L348 = '',
    N348 = '',
    AF348 = '',
    AH348 = '',
    H349 = '',
    J349 = '',
    L349 = '',
    N349 = '',
    AF349 = '',
    AH349 = '',
    H350 = '',
    J350 = '',
    L350 = '',
    N350 = '',
    AF350 = '',
    AH350 = '',
    H351 = '',
    J351 = '',
    L351 = '',
    N351 = '',
    AF351 = '',
    AH351 = '',
    H352 = '',
    J352 = '',
    L352 = '',
    N352 = '',
    AF352 = '',
    AH352 = ''

  J7 = cellValue(() => IF(B3 === '', '-', B3))
  K7 = cellValue(() => IF(D3 === '', '-', D3))
  L7 = cellValue(() => IF(F3 === '', '-', F3))
  M7 = cellValue(() => IF(H3 === '', '-', H3))
  N7 = cellValue(() => IF(J3 === '', '-', J3))
  O7 = cellValue(() => IF(L3 === '', '-', L3))
  P7 = cellValue(() => IF(N3 === '', '-', N3))
  Q7 = cellValue(() => IFERROR(IF(J7 === '', '', 1 / J7), '-'))
  R7 = cellValue(() => IFERROR(IF(K7 === '', '', 1 / K7), '-'))
  S7 = cellValue(() => IFERROR(IF(L7 === '', '', 1 / L7), '-'))
  T7 = cellValue(() => IFERROR(IF(M7 === '', '', 1 / M7), '-'))
  U7 = cellValue(() => IFERROR(IF(N7 === '', '', 1 / N7), '-'))
  V7 = cellValue(() => IFERROR(IF(O7 === '', '', 1 / O7), '-'))
  W7 = cellValue(() => IFERROR(IF(P7 === '', '', 1 / P7), '-'))
  X7 = cellValue(() => IFERROR(IF(Q7 === '', '', Q7 + R7 + S7), '-'))
  Y7 = cellValue(() => IF(X7 === '', '', X7 - 1))
  Z7 = cellValue(() => IFERROR(IF(J7 === '', '', Q7 / X7), '-'))
  AA7 = cellValue(() => IFERROR(IF(K7 === '', '', R7 / X7), '-'))
  AB7 = cellValue(() => IFERROR(IF(AA7 === '', '', S7 / X7), '-'))
  AC7 = cellValue(() => IFERROR(IF(T7 === '', '', T7 + U7), '-'))
  AD7 = cellValue(() => IFERROR(IF(AC7 === '', '', AC7 - 1), '-'))
  AE7 = cellValue(() => IFERROR(IF(AD7 === '', '', AD7 / 2), '-'))
  AF7 = cellValue(() => IFERROR(IF(T7 === '', '', T7 / AC7), '-'))
  AG7 = cellValue(() => IFERROR(IF(U7 === '', '', U7 / AC7), '-'))
  AH7 = cellValue(() => IFERROR(IF(V7 === '', '', V7 + W7), '-'))
  AI7 = cellValue(() => IFERROR(IF(AH7 === '', '', AH7 - 1), '-'))
  AJ7 = cellValue(() => IFERROR(IF(AI7 === '', '', AI7 / 2), '-'))
  AK7 = cellValue(() => IFERROR(IF(V7 === '', '', V7 / AH7), '-'))
  AL7 = cellValue(() => IFERROR(IF(W7 === '', '', W7 / AH7), '-'))
  AM7 = cellValue(() => IFERROR(IF(Z7 === '', '', 1 / Z7), '-'))
  AN7 = cellValue(() => IFERROR(IF(AA7 === '', '', 1 / AA7), '-'))
  AO7 = cellValue(() => IFERROR(IF(AB7 === '', '', 1 / AB7), '-'))
  AP7 = cellValue(() => IFERROR(IF(AF7 === '', '', 1 / AF7), '-'))
  AQ7 = cellValue(() => IFERROR(IF(AG7 === '', '', 1 / AG7), '-'))
  AR7 = cellValue(() => IFERROR((AF7 / 10) * 2.1 * 2, '-'))
  AS7 = cellValue(() => IFERROR((AF7 / 10) * 2.3 * 2, '-'))
  AT7 = cellValue(() => IFERROR((AG7 / 10) * 2.2 * 2, '-'))
  AU7 = cellValue(() => IFERROR((AG7 / 10) * 1.3 * 2, '-'))
  AV7 = cellValue(() => IFERROR((AG7 / 10) * 0.7 * 2, '-'))
  AW7 = cellValue(() => IFERROR((AG7 / 10) * 0.3 * 2, '-'))
  AX7 = cellValue(() => IFERROR((AG7 / 10) * 0.2 * 2, '-'))
  AY7 = cellValue(() =>
    IFERROR(
      IF(AR7 === '', '', 1 - SUM([AR7, AS7, AT7, AU7, AV7, AW7, AX7])),
      '-'
    )
  )
  AZ7 = cellValue(() =>
    IFERROR(SUM([AR7, AS7, AT7, AU7, AV7, AW7, AX7, AY7]), '-')
  )
  BA7 = cellValue(() => IFERROR(IF(AW7 === '', '', AW7 + AX7), '-'))
  BB7 = cellValue(() => IF(AM7 === '', '', AM7))
  BC7 = cellValue(() => IF(AN7 === '', '', AN7))
  BD7 = cellValue(() => IF(AO7 === '', '', AO7))
  BE7 = cellValue(() => IF(AP7 === '', '', AP7))
  BF7 = cellValue(() => IF(AQ7 === '', '', AQ7))
  BG7 = cellValue(() => IFERROR(IF(AK7 === '', '', 1 / AK7), '-'))
  BH7 = cellValue(() => IFERROR(IF(AL7 === '', '', 1 / AL7), '-'))
  BI7 = cellValue(() => IFERROR(IF(AY7 === '', '', 1 / AY7), '-'))
  BJ7 = cellValue(() => IFERROR(IF(AR7 === '', '', 1 / AR7), '-'))
  BK7 = cellValue(() => IFERROR(IF(AS7 === '', '', 1 / AS7), '-'))
  BL7 = cellValue(() => IFERROR(IF(AT7 === '', '', 1 / AT7), '-'))
  BM7 = cellValue(() => IFERROR(IF(AU7 === '', '', 1 / AU7), '-'))
  BN7 = cellValue(() => IFERROR(IF(AV7 === '', '', 1 / AV7), '-'))
  BO7 = cellValue(() => IFERROR(IF(BA7 === '', '', 1 / BA7), '-'))
  BP7 = cellValue(() => IFERROR(IF(BB7 === '', '', 1 / BB7), '-'))
  BQ7 = cellValue(() => IFERROR(IF(BC7 === '', '', 1 / BC7), '-'))
  BR7 = cellValue(() => IFERROR(IF(BD7 === '', '', 1 / BD7), '-'))
  BS7 = cellValue(() => IFERROR(IF(BE7 === '', '', 1 / BE7), '-'))
  BT7 = cellValue(() => IFERROR(IF(BF7 === '', '', 1 / BF7), '-'))
  BU7 = cellValue(() => IFERROR(IF(BG7 === '', '', 1 / BG7), '-'))
  BV7 = cellValue(() => IFERROR(IF(BH7 === '', '', 1 / BH7), '-'))
  BW7 = cellValue(() => IFERROR(IF(BI7 === '', '', 1 / BI7), '-'))
  BX7 = cellValue(() => IFERROR(IF(BJ7 === '', '', 1 / BJ7), '-'))
  BY7 = cellValue(() => IFERROR(IF(BK7 === '', '', 1 / BK7), '-'))
  BZ7 = cellValue(() => IFERROR(IF(BL7 === '', '', 1 / BL7), '-'))
  CA7 = cellValue(() => IFERROR(IF(BM7 === '', '', 1 / BM7), '-'))
  CB7 = cellValue(() => IFERROR(IF(BN7 === '', '', 1 / BN7), '-'))
  CC7 = cellValue(() => IFERROR(IF(BO7 === '', '', 1 / BO7), '-'))
  CD7 = cellValue(() => IFERROR(SUM([BW7, BX7, BY7, BZ7, CA7, CB7, CC7]), '-'))
  CE7 = cellValue(() =>
    IF(OR(BP7 === '', BP7 === '-'), '-', (BQ7 * BP7) / (BP7 + BR7) + BP7)
  )
  CF7 = cellValue(() =>
    IF(OR(BR7 === '', BR7 === '-'), '-', (BQ7 * BR7) / (BP7 + BR7) + BR7)
  )
  B8 = cellValue(() => IFERROR(BP7 + BQ7 + BR7, '-'))
  D8 = cellValue(() => IFERROR(CD7, '-'))
  F8 = cellValue(() => IFERROR(BU7 + BV7, '-'))
  BT11 = cellValue(() => BI7)
  BU11 = cellValue(() => BJ7)
  BV11 = cellValue(() => BK7)
  BW11 = cellValue(() => BL7)
  BX11 = cellValue(() => BM7)
  BY11 = cellValue(() => BN7)
  BZ11 = cellValue(() => BO7)
  Z12 = cellValue(() => IFERROR(BP7, '-'))
  AB12 = cellValue(() => IFERROR(BQ7, '-'))
  AD12 = cellValue(() => IFERROR(BR7, '-'))
  AF12 = cellValue(() => IFERROR(BS7, '-'))
  AH12 = cellValue(() => IFERROR(BT7, '-'))
  BT12 = cellValue(() => IFERROR(1 / BT11, '-'))
  BU12 = cellValue(() => IFERROR(1 / BU11, '-'))
  BV12 = cellValue(() => IFERROR(1 / BV11, '-'))
  BW12 = cellValue(() => IFERROR(1 / BW11, '-'))
  BX12 = cellValue(() => IFERROR(1 / BX11, '-'))
  BY12 = cellValue(() => IFERROR(1 / BY11, '-'))
  BZ12 = cellValue(() => IFERROR(1 / BZ11, '-'))
  CA12 = cellValue(() =>
    IFERROR(SUM([BT12, BU12, BV12, BW12, BX12, BY12, BZ12]), '-')
  )
  CB12 = cellValue(() => IFERROR(CA12 - 100 / 100, '-'))
  BT13 = cellValue(() => IFERROR(CB12 * (8 / 100), '-'))
  BT14 = cellValue(() => IFERROR(IF(BT3 > BU3, BT13 - BT3, BT13 + BU3), '-'))
  BT16 = cellValue(() => IFERROR(BT12 - BT14, '-'))
  BT22 = cellValue(() =>
    IFERROR(IF(BH23 > 100 / 100, BI24 - BT16, BT16 + BI24), '-')
  )
  BT20 = cellValue(() => IFERROR(BT22 * BT19, '-'))
  BU13 = cellValue(() => IFERROR(CB12 * (22 / 100), '-'))
  BU14 = cellValue(() => IFERROR(IF(BT3 > BU3, BU13 - BT3, BU13 + BU3), '-'))
  BU16 = cellValue(() => IFERROR(BU12 - BU14, '-'))
  BU22 = cellValue(() =>
    IFERROR(IF(BH23 > 100 / 100, BI24 - BU16, BU16 + BI24), '-')
  )
  BU20 = cellValue(() => IFERROR(BU22 * BU19, '-'))
  BV13 = cellValue(() => IFERROR(CB12 * (22 / 100), '-'))
  BV14 = cellValue(() => IFERROR(IF(BT3 > BU3, BV13 - BT3, BV13 + BU3), '-'))
  BV16 = cellValue(() => IFERROR(BV12 - BV14, '-'))
  BV22 = cellValue(() =>
    IFERROR(IF(BH23 > 100 / 100, BI24 - BV16, BV16 + BI24), '-')
  )
  BV20 = cellValue(() => IFERROR(BV22 * BV19, '-'))
  BW13 = cellValue(() => IFERROR(BW12 * (22 / 100), '-'))
  BW14 = cellValue(() => IFERROR(IF(BT3 > BU3, BW13 - BT3, BW13 + BU3), '-'))
  BW16 = cellValue(() => IFERROR(BW12 - BW14, '-'))
  BW22 = cellValue(() =>
    IFERROR(IF(BH23 > 100 / 100, BI24 - BW16, BW16 + BI24), '-')
  )
  BW20 = cellValue(() => IFERROR(BW22 * BW19, '-'))
  BX13 = cellValue(() => IFERROR(BX12 * (13 / 100), '-'))
  BX14 = cellValue(() => IFERROR(IF(BT3 > BU3, BX13 - BT3, BX13 + BU3), '-'))
  BX16 = cellValue(() => IFERROR(BX12 - BX14, '-'))
  BX22 = cellValue(() =>
    IFERROR(IF(BH23 > 100 / 100, BI24 - BX16, BX16 + BI24), '-')
  )
  BX20 = cellValue(() => IFERROR(BX22 * BX19, '-'))
  BY13 = cellValue(() => IFERROR(CB12 * (7 / 100), '-'))
  BY14 = cellValue(() => IFERROR(IF(BT3 > BU3, BY13 - BT3, BY13 + BU3), '-'))
  BY16 = cellValue(() => IFERROR(BY12 - BY14, '-'))
  BY22 = cellValue(() =>
    IFERROR(IF(BH23 > 100 / 100, BI24 - BY16, BY16 + BI24), '-')
  )
  BY20 = cellValue(() => IFERROR(BY22 * BY19, '-'))
  BZ13 = cellValue(() => IFERROR(BZ12 * (5 / 100), '-'))
  BZ14 = cellValue(() => IFERROR(IF(BT3 > BU3, BZ13 - BT3, BZ13 + BU3), '-'))
  BZ16 = cellValue(() => IFERROR(BZ12 - BZ14, '-'))
  BZ22 = cellValue(() =>
    IFERROR(IF(BH23 > 100 / 100, BI24 - BZ16, BZ16 + BI24), '-')
  )
  BZ20 = cellValue(() => IFERROR(BZ22 * BZ19, '-'))
  BT42 = cellValue(() =>
    IFERROR(BT20 + BU20 + BV20 + BW20 + BX20 + BY20 + BZ20, '-')
  )
  BT36 = cellValue(() => BB7)
  BT37 = cellValue(() => IFERROR(1 / BT36, '-'))
  BU36 = cellValue(() => BC7)
  BU37 = cellValue(() => IFERROR(1 / BU36, '-'))
  BV36 = cellValue(() => BD7)
  BV37 = cellValue(() => IFERROR(1 / BV36, '-'))
  BW37 = cellValue(() => IFERROR(BV37 + BU37 + BT37, '-'))
  BX37 = cellValue(() => IFERROR((BW37 - 100 / 100) / 3, '-'))
  BT39 = cellValue(() => IFERROR(BT37 - BX37, '-'))
  BT45 = cellValue(() => IFERROR(BT39 + BY39, '-'))
  BT49 = cellValue(() => IFERROR(BT42 * BT45, '-'))
  BV39 = cellValue(() => IFERROR(BV37 - BX37, '-'))
  BU45 = cellValue(() => IFERROR(BV39 + BY39, '-'))
  BU49 = cellValue(() => IFERROR(BT42 * BU45, '-'))
  BT52 = cellValue(() =>
    IFERROR(IF(BT49 > BU49, BT49 - BU49, BU49 - BT49), '-')
  )
  BT65 = cellValue(() => IFERROR(BT42 - BT52, '-'))
  AJ12 = cellValue(() => IFERROR(BT65, '-'))
  CE12 = cellValue(() => IFERROR(AJ12 * CE7, '-'))
  CE21 = cellValue(() => IFERROR(ROUND(CE12, 0), '-'))
  CE13 = cellValue(() => IFERROR(AJ12 * CF7, '-'))
  CE22 = cellValue(() => IFERROR(ROUND(CE13, 0), '-'))
  AP12 = cellValue(() => IFERROR(LEFT(CE21, 1) + ' : ' + LEFT(CE22, 1), ''))
  AT12 = cellValue(() => IFERROR(ROUND(CE12, 2) + ' : ' + ROUND(CE13, 2), '-'))
  B16 = cellValue(() => IF(!EQUALS(B8, 100 / 100), '-', IFERROR(BP7, '-')))
  D16 = cellValue(() => IF(!EQUALS(B8, 100 / 100), '-', IFERROR(BQ7, '-')))
  BA12 = cellValue(() => IFERROR(IF(B16 === '', '', B16 + D16), '-'))
  F16 = cellValue(() =>
    IF(
      !EQUALS(D8, 100 / 100),
      '-',
      IF(!EQUALS(B8, 100 / 100), '-', IFERROR(BR7, '-'))
    )
  )
  BB12 = cellValue(() => IFERROR(IF(D16 === '', '', D16 + F16), '-'))
  BC12 = cellValue(() => IFERROR(IF(BA12 === '', '', BA12 + BB12), '-'))
  BD12 = cellValue(() =>
    IFERROR(IF(OR(BA12 === '', BB12 === ''), '', BC12 - 1), '-')
  )
  BA13 = cellValue(() => IFERROR(IF(BA12 === '', '', BA12 - BD12), '-'))
  BB13 = cellValue(() => IFERROR(IF(BB12 === '', '', BB12 - BE12), '-'))
  CA13 = cellValue(() =>
    IFERROR(SUM([BT13, BU13, BV13, BW13, BX13, BY13, BZ13]), '-')
  )
  CB13 = cellValue(() => IFERROR((CA13 - CB12) / 7, '-'))
  BU65 = cellValue(() => IFERROR(BT42 + BT52, '-'))
  AJ15 = cellValue(() => IFERROR(BU65, '-'))
  AJ14 = cellValue(() => IFERROR(AVERAGE(AJ12, AJ15), '-'))
  CH14 = cellValue(() => IFERROR(AJ14 * CE7, '-'))
  CH23 = cellValue(() => IFERROR(ROUND(CH14, 0), '-'))
  CH16 = cellValue(() => IFERROR(AJ14 * CF7, '-'))
  CH25 = cellValue(() => IFERROR(ROUND(CH16, 0), '-'))
  AP14 = cellValue(() => IFERROR(LEFT(CH23, 1) + ' : ' + LEFT(CH25, 1), ''))
  AT14 = cellValue(() => IFERROR(ROUND(CH14, 2) + ' : ' + ROUND(CH16, 2), '-'))
  BA14 = cellValue(() => IFERROR(BA13 + BB13, '-'))
  CA14 = cellValue(() => IFERROR(IF(BT3 > BU3, CA13 - BT3, CA13 + BU3), '-'))
  H16 = cellValue(() => IF(!EQUALS(D8, 100 / 100), '-', IFERROR(BW7, '-')))
  J16 = cellValue(() => IF(!EQUALS(D8, 100 / 100), '-', IFERROR(BX7, '-')))
  L16 = cellValue(() => IF(!EQUALS(D8, 100 / 100), '-', IFERROR(BY7, '-')))
  N16 = cellValue(() => IF(!EQUALS(D8, 100 / 100), '-', IFERROR(BZ7, '-')))
  P16 = cellValue(() => IF(!EQUALS(D8, 100 / 100), '-', IFERROR(CA7, '-')))
  R16 = cellValue(() => IF(!EQUALS(D8, 100 / 100), '-', IFERROR(CB7, '-')))
  T16 = cellValue(() => IF(!EQUALS(D8, 100 / 100), '-', IFERROR(CC7, '-')))
  V16 = cellValue(() => IF(!EQUALS(F8, 100 / 100), '-', IFERROR(BU7, '-')))
  X16 = cellValue(() => IF(!EQUALS(F8, 100 / 100), '-', IFERROR(BV7, '-')))
  AJ16 = cellValue(() => IFERROR(BU65, '-'))
  CE16 = cellValue(() => IFERROR(AJ15 * CE7, '-'))
  CE25 = cellValue(() => IFERROR(ROUND(CE16, 0), '-'))
  CE19 = cellValue(() => IFERROR(AJ15 * CF7, '-'))
  CE28 = cellValue(() => IFERROR(ROUND(CE19, 0), '-'))
  AP16 = cellValue(() => IFERROR(LEFT(CE25, 1) + ' : ' + LEFT(CE28, 1), ''))
  AT16 = cellValue(() => IFERROR(ROUND(CE16, 2) + ' : ' + ROUND(CE19, 2), '-'))
  CA16 = cellValue(() =>
    IFERROR(SUM([BT16, BU16, BV16, BW16, BX16, BY16, BZ16]), '-')
  )
  CB16 = cellValue(() =>
    IFERROR(IF(CA16 > 100 / 100, CA16 - 100 / 100, 100 / 100 - CA16), '-')
  )
  BT17 = cellValue(() => IFERROR(1 / BT16, '-'))
  BU17 = cellValue(() => IFERROR(1 / BU16, '-'))
  BV17 = cellValue(() => IFERROR(1 / BV16, '-'))
  BW17 = cellValue(() => IFERROR(1 / BW16, '-'))
  BX17 = cellValue(() => IFERROR(1 / BX16, '-'))
  BY17 = cellValue(() => IFERROR(1 / BY16, '-'))
  BZ17 = cellValue(() => IFERROR(1 / BZ16, '-'))
  CB17 = cellValue(() => IFERROR(CB16 / 7, '-'))
  BC19 = cellValue(() => IFERROR(IF(BA13 === '', '', BA13 * H16), '-'))
  BD19 = cellValue(() => IFERROR(IF(BB13 === '', '', BB13 * H16), '-'))
  BE19 = cellValue(() => IFERROR(IF(BA13 === '', '', BA13 * J16), '-'))
  BF19 = cellValue(() => IFERROR(IF(BB13 === '', '', BB13 * J16), '-'))
  BG19 = cellValue(() => IFERROR(IF(BA13 === '', '', BA13 * L16), '-'))
  BH19 = cellValue(() => IFERROR(IF(BB13 === '', '', BB13 * L16), '-'))
  BI19 = cellValue(() => IFERROR(IF(BA13 === '', '', BA13 * N16), '-'))
  BJ19 = cellValue(() => IFERROR(IF(BB13 === '', '', BB13 * N16), '-'))
  BK19 = cellValue(() => IFERROR(IF(BA13 === '', '', BA13 * P16), '-'))
  BL19 = cellValue(() => IFERROR(IF(BB13 === '', '', BB13 * P16), '-'))
  BM19 = cellValue(() => IFERROR(IF(BA13 === '', '', BA13 * R16), '-'))
  BN19 = cellValue(() => IFERROR(IF(BB13 === '', '', BB13 * R16), '-'))
  BO19 = cellValue(() => IFERROR(IF(BA13 === '', '', BA13 * T16), '-'))
  BP19 = cellValue(() => IFERROR(IF(BB13 === '', '', BB13 * T16), '-'))
  BQ19 = cellValue(() =>
    SUM([
      BC19,
      BD19,
      BE19,
      BF19,
      BG19,
      BH19,
      BI19,
      BJ19,
      BK19,
      BL19,
      BM19,
      BN19,
      BO19,
      BP19,
    ])
  )
  CB20 = cellValue(() =>
    IFERROR(SUM([BU20, BV20, BW20, BX20, BY20, BZ20]), '-')
  )
  CA22 = cellValue(() =>
    IFERROR(SUM([BT22, BU22, BV22, BW22, BX22, BY22, BZ22]), '-')
  )
  H25 = cellValue(() => IF(OR(B16 < 0 / 100, B16 > 100 / 100), '-', B16))
  J25 = cellValue(() => D16)
  L25 = cellValue(() => F16)
  R25 = cellValue(() =>
    IF(H25 === '-', '-', IF(H25 > L25, H25 * (77.5 / 100), H25 * (83.5 / 100)))
  )
  T25 = cellValue(() => IFERROR(J25 + 15 / 100, '-'))
  V25 = cellValue(() =>
    IF(L25 === '-', '-', IF(L25 > H25, L25 * (77.5 / 100), L25 * (83.5 / 100)))
  )
  X25 = cellValue(() =>
    IF(
      N(R25) + N(T25) + N(V25) === '',
      '',
      IF(
        N(R25) + N(T25) + N(V25) > 1,
        (N(R25) + N(T25) + N(V25) - 1) / 3,
        (1 - N(R25) - N(T25) - N(V25)) / 3
      )
    )
  )
  Z25 = cellValue(() =>
    IF(
      H25 === '-',
      '-',
      IF(N(R25) + N(T25) + N(V25) > 1, N(R25) - N(X25), N(R25) + N(X25))
    )
  )
  AB25 = cellValue(() =>
    IF(
      J25 === '-',
      '-',
      IF(N(R25) + N(T25) + N(V25) > 1, N(T25) - N(X25), N(T25) + N(X25))
    )
  )
  AD25 = cellValue(() =>
    IF(
      L25 === '-',
      '-',
      IF(N(R25) + N(T25) + N(V25) > 1, N(V25) - N(X25), N(V25) + N(X25))
    )
  )
  AI25 = cellValue(() =>
    IF(Z25 === '-', '-', IF(H25 > L25, H25 * (115.8 / 100), L25 * (92.8 / 100)))
  )
  AJ25 = cellValue(() => IF(Z25 === '-', '-', R25 + R25 / 10))
  AL25 = cellValue(() => IFERROR(T25 === '-' ? NaN : T25 + T25 / 10, '-'))
  AN25 = cellValue(() => IF(AD25 === '-', '-', V25 + V25 / 10))
  AP25 = cellValue(() =>
    IF(
      N(AJ25) + N(AL25) + N(AN25) === '',
      '',
      IF(
        N(AJ25) + N(AL25) + N(AN25) > 1,
        (N(AJ25) + N(AL25) + N(AN25) - 1) / 3,
        (1 - N(AJ25) - N(AL25) - N(AN25)) / 3
      )
    )
  )
  AR25 = cellValue(() =>
    IF(
      Z25 === '-',
      '-',
      IF(N(AJ25) + N(AL25) + N(AN25) >= 1, N(AJ25) - N(AP25), N(AJ25) + N(AP25))
    )
  )
  AT25 = cellValue(() =>
    IF(
      !EQUALS(B8, 100 / 100),
      '-',
      IF(N(AJ25) + N(AL25) + N(AN25) >= 1, N(AL25) - N(AP25), N(AL25) + N(AP25))
    )
  )
  AV25 = cellValue(() =>
    IF(
      AD25 === '-',
      '-',
      IF(N(AJ25) + N(AL25) + N(AN25) >= 1, N(AN25) - N(AP25), N(AN25) + N(AP25))
    )
  )
  AX25 = cellValue(() => SUM(AR25, AT25, AV25))
  H27 = cellValue(() => IF(H25 === '-', '-', 1 - H25))
  J27 = cellValue(() => IF(J25 === '-', '-', 1 - J25))
  L27 = cellValue(() => IF(L25 === '-', '-', 1 - L25))
  Z27 = cellValue(() => IF(Z25 === '-', '-', 1 - Z25))
  AB27 = cellValue(() => IF(AB25 === '-', '-', 1 - AB25))
  AD27 = cellValue(() => IF(AD25 === '-', '-', 1 - AD25))
  AR27 = cellValue(() => IF(AR25 === '-', '-', 1 - AR25))
  AT27 = cellValue(() => IF(AT25 === '-', '-', 1 - AT25))
  AV27 = cellValue(() => IF(AV25 === '-', '-', 1 - AV25))
  BT28 = cellValue(() => IFERROR(1 / BG7, '-'))
  BU28 = cellValue(() => IFERROR(1 / BH7, '-'))
  BV28 = cellValue(() => IFERROR(BT28 + BU28, '-'))
  BW28 = cellValue(() => IFERROR(BV28 - 1, '-'))
  BX28 = cellValue(() => IFERROR(BW28 / 2, '-'))
  BT30 = cellValue(() => IFERROR(BT28 - BX28, '-'))
  BU30 = cellValue(() => IFERROR(BU28 - BX28, '-'))
  H31 = cellValue(() => IFERROR(H25 + J25, '-'))
  J31 = cellValue(() => IFERROR(H25 + L25, '-'))
  L31 = cellValue(() => IFERROR(J25 + L25, '-'))
  Z31 = cellValue(() => IFERROR(Z25 + AB25, '-'))
  AB31 = cellValue(() => IFERROR(Z25 + AD25, '-'))
  AD31 = cellValue(() => IFERROR(AB25 + AD25, '-'))
  AR31 = cellValue(() => IFERROR(AR25 + AT25, '-'))
  AT31 = cellValue(() => IFERROR(AR25 + AV25, '-'))
  AV31 = cellValue(() => IFERROR(AT25 + AV25, '-'))
  H33 = cellValue(() => IF(H31 === '-', '-', 1 - H31))
  J33 = cellValue(() => IF(J31 === '-', '-', 1 - J31))
  L33 = cellValue(() => IF(L31 === '-', '-', 1 - L31))
  Z33 = cellValue(() => IF(Z31 === '-', '-', 1 - Z31))
  AB33 = cellValue(() => IF(AB31 === '-', '-', 1 - AB31))
  AD33 = cellValue(() => IF(AD31 === '-', '-', 1 - AD31))
  AR33 = cellValue(() => IF(AR31 === '-', '-', 1 - AR31))
  AT33 = cellValue(() => IF(AT31 === '-', '-', 1 - AT31))
  AV33 = cellValue(() => IF(AV31 === '-', '-', 1 - AV31))
  H37 = cellValue(() => IFERROR(Z25 * AR25, '-'))
  J37 = cellValue(() => IFERROR(AD25 * AV25, '-'))
  L37 = cellValue(() => IFERROR(H25 * X16, '-'))
  N37 = cellValue(() => IFERROR(L25 * X16, '-'))
  Z37 = cellValue(() => IFERROR(Z25 * AR25, '-'))
  AB37 = cellValue(() => IFERROR(AD25 * AV25, '-'))
  AR37 = cellValue(() => H31)
  AT37 = cellValue(() => L31)
  H39 = cellValue(() => IF(H37 === '-', '-', 1 - H37))
  J39 = cellValue(() => IF(J37 === '-', '-', 1 - J37))
  L39 = cellValue(() => IF(L37 === '-', '-', 1 - L37))
  N39 = cellValue(() => IF(N37 === '-', '-', 1 - N37))
  Z39 = cellValue(() => IF(Z37 === '-', '-', 1 - Z37))
  AB39 = cellValue(() => IF(AB37 === '-', '-', 1 - AB37))
  AR39 = cellValue(() => IF(AR37 === '-', '-', 1 - AR37))
  AT39 = cellValue(() => IF(AT37 === '-', '-', 1 - AT37))
  BU39 = cellValue(() => IFERROR(BU37 - BX37, '-'))
  BW39 = cellValue(() => IFERROR(BV39 + BU39 + BT39, '-'))
  H43 = cellValue(() => IFERROR((H25 + Z25) / 2, '-'))
  J43 = cellValue(() => IFERROR((J25 + AB25) / 2, '-'))
  L43 = cellValue(() => IFERROR((L25 + AD25) / 2, '-'))
  AR43 = cellValue(() => Z31)
  AT43 = cellValue(() => AD31)
  H45 = cellValue(() => IF(H43 === '-', '-', 1 - H43))
  J45 = cellValue(() => IF(J43 === '-', '-', 1 - J43))
  L45 = cellValue(() => IF(L43 === '-', '-', 1 - L43))
  AR45 = cellValue(() => IF(AR43 === '-', '-', 1 - AR43))
  AT45 = cellValue(() => IF(AT43 === '-', '-', 1 - AT43))
  H130 = cellValue(() => {
    const rawHomeGoals = H31 * 1.2
    const X134 = 100 / 100
    const X135 = rawHomeGoals - 100 / 100
    return IFERROR(
      IF(rawHomeGoals >= 100 / 100, X134 - X135 * 2, rawHomeGoals),
      '-'
    )
  })
  X130 = cellValue(() => IFERROR(H130 / 2.33, '-'))
  H162 = cellValue(() => {
    const rawGuestGoals = L31 * 1.2
    const excessOverOne = rawGuestGoals - 100 / 100
    return IFERROR(
      IF(rawGuestGoals >= 100 / 100, 100 / 100 - excessOverOne, rawGuestGoals),
      '-'
    )
  })
  V162 = cellValue(() => IFERROR(1 - H162, '-'))
  J332 = cellValue(() => IFERROR(X130 * V162, '-'))
  Z130 = cellValue(() => IFERROR(X130 / 1.5, '-'))
  X162 = cellValue(() => IFERROR(H162 / 2.33, '-'))
  T332 = cellValue(() => IFERROR(Z130 * X162, '-'))
  V130 = cellValue(() => IFERROR(1 - H130, '-'))
  R130 = cellValue(() => IFERROR(V130 + X130 + Z130, '-'))
  L130 = cellValue(() => IFERROR(1 - R130, '-'))
  N130 = cellValue(() => IFERROR(L130 / 1.95, '-'))
  AB130 = cellValue(() => IFERROR(1 - (N130 + V130 + X130 + Z130), '-'))
  Z162 = cellValue(() => IFERROR(X162 / 1.5, '-'))
  AL332 = cellValue(() => IFERROR(AB130 * Z162, '-'))
  H49 = cellValue(() =>
    IF(
      !EQUALS(B8, 100 / 100),
      '-',
      IF(
        OR(J332 + T332 + AL332 < 0 / 100, J332 + T332 + AL332 > 100 / 100),
        '-',
        IFERROR(J332 + T332 + AL332, '-')
      )
    )
  )
  P332 = cellValue(() => IFERROR(Z130 * V162, '-'))
  AH332 = cellValue(() => IFERROR(AB130 * X162, '-'))
  AV130 = cellValue(() => IFERROR(AB130 / 2, '-'))
  H338 = cellValue(() => IFERROR(AV130 * Z162, '-'))
  J49 = cellValue(() => IFERROR(P332 + AH332 + H338, '-'))
  X332 = cellValue(() => IFERROR(AB130 * V162, '-'))
  AD332 = cellValue(() => IFERROR(AV130 * V162, '-'))
  AP332 = cellValue(() => IFERROR(AV130 * X162, '-'))
  H136 = cellValue(() => IFERROR(1 - (V130 + X130 + Z130 + AB130 + AV130), '-'))
  J136 = cellValue(() => IFERROR(H136 * 0.5833, '-'))
  AX130 = cellValue(() => IFERROR(J136, '-'))
  L338 = cellValue(() => IFERROR(AX130 * X162, '-'))
  P338 = cellValue(() => '-')
  L49 = cellValue(() => IFERROR(X332 + AP332 + L338 + P338 + AD332, '-'))
  L332 = cellValue(() => IFERROR(V130 * X162, '-'))
  V332 = cellValue(() => IFERROR(X130 * Z162, '-'))
  R162 = cellValue(() => IFERROR(V162 + X162 + Z162, '-'))
  L162 = cellValue(() => IFERROR(1 - R162, '-'))
  N162 = cellValue(() => IFERROR(L162 / 1.95, '-'))
  AB162 = cellValue(() => IFERROR(1 - (N162 + V162 + X162 + Z162), '-'))
  AN332 = cellValue(() => IFERROR(Z130 * AB162, '-'))
  N49 = cellValue(() => IFERROR(L332 + V332 + AN332, '-'))
  R332 = cellValue(() => IFERROR(V130 * Z162, '-'))
  AJ332 = cellValue(() => IFERROR(X130 * AB162, '-'))
  AV162 = cellValue(() => IFERROR(AB162 / 2, '-'))
  J338 = cellValue(() => IFERROR(Z130 * AV162, '-'))
  P49 = cellValue(() => IFERROR(R332 + AJ332 + J338, '-'))
  Z332 = cellValue(() => IFERROR(V130 * AB162, '-'))
  AF332 = cellValue(() => IFERROR(V130 * AV162, '-'))
  AR332 = cellValue(() => IFERROR(X130 * AV162, '-'))
  H168 = cellValue(() => IFERROR(1 - (V162 + X162 + Z162 + AB162 + AV162), '-'))
  J168 = cellValue(() => IFERROR(H168 * 0.5833, '-'))
  AX162 = cellValue(() => IFERROR(J168, '-'))
  AV332 = cellValue(() => IFERROR(V130 * AX162, '-'))
  N338 = cellValue(() => IFERROR(X130 * AX162, '-'))
  R338 = cellValue(() => '-')
  R49 = cellValue(() =>
    IFERROR(Z332 + AF332 + AR332 + AV332 + N338 + R338, '-')
  )
  AR49 = cellValue(() => AR31)
  AT49 = cellValue(() => AV31)
  BT50 = cellValue(() => IFERROR(ROUND(BT49, 0), '-'))
  BU50 = cellValue(() => IFERROR(ROUND(BU49, 0), '-'))
  H51 = cellValue(() => IF(H49 === '-', '-', 1 - H49))
  J51 = cellValue(() => IF(J49 === '-', '-', 1 - J49))
  L51 = cellValue(() => IF(L49 === '-', '-', 1 - L49))
  N51 = cellValue(() => IF(N49 === '-', '-', 1 - N49))
  P51 = cellValue(() => IF(P49 === '-', '-', 1 - P49))
  R51 = cellValue(() => IF(R49 === '-', '-', 1 - R49))
  AR51 = cellValue(() => IF(AR49 === '-', '-', 1 - AR49))
  AT51 = cellValue(() => IF(AT49 === '-', '-', 1 - AT49))
  H57 = cellValue(() => IFERROR(H16 + J16, '-'))
  J57 = cellValue(() => IFERROR(J16 + L16, '-'))
  L57 = cellValue(() => IFERROR(L16 + N16, '-'))
  N57 = cellValue(() => IFERROR(N16 + P16, '-'))
  P57 = cellValue(() => IFERROR(P16 + R16, '-'))
  R57 = cellValue(() => IFERROR(R16 + T16 - 2 / 100, '-'))
  T57 = cellValue(() => IFERROR(H16 + J16 + L16, '-'))
  V57 = cellValue(() => IFERROR(J16 + L16 + N16, '-'))
  X57 = cellValue(() => IFERROR(L16 + P16, '-'))
  Z57 = cellValue(() => IFERROR(N16 + P16 + R16, '-'))
  AB57 = cellValue(() => IFERROR(P16 + R16 + T16 - 2 / 100, '-'))
  AD57 = cellValue(() => IFERROR(H16 + J16 + L16 + N16, '-'))
  AF57 = cellValue(() => IFERROR(J16 + L16 + N16 + P16, '-'))
  AH57 = cellValue(() => IFERROR(L16 + N16 + P16 + R16, '-'))
  AJ57 = cellValue(() => IFERROR(N16 + P16 + R16 + T16 - 2 / 100, '-'))
  AL57 = cellValue(() => IFERROR(H16 + J16 + L16 + N16 + P16, '-'))
  AN57 = cellValue(() => IFERROR(J16 + L16 + N16 + P16 + R16, '-'))
  AP57 = cellValue(() => IFERROR(L16 + N16 + P16 + R16 + T16 - 2 / 100, '-'))
  AR57 = cellValue(() => IFERROR(L16 + N16 + P16 + R16 + T16, '-'))
  AT57 = cellValue(() => IFERROR(N16 + P16 + R16 + T16, '-'))
  AV57 = cellValue(() => IFERROR(P16 + R16 + T16, '-'))
  AX57 = cellValue(() => IFERROR(R16 + T16, '-'))
  H59 = cellValue(() => IF(H57 === '-', '-', 1 - H57))
  J59 = cellValue(() => IF(J57 === '-', '-', 1 - J57))
  L59 = cellValue(() => IF(L57 === '-', '-', 1 - L57))
  N59 = cellValue(() => IF(N57 === '-', '-', 1 - N57))
  P59 = cellValue(() => IF(P57 === '-', '-', 1 - P57))
  R59 = cellValue(() => IF(R57 === '-', '-', 1 - R57))
  T59 = cellValue(() => IF(T57 === '-', '-', 1 - T57))
  V59 = cellValue(() => IF(V57 === '-', '-', 1 - V57))
  X59 = cellValue(() => IF(X57 === '-', '-', 1 - X57))
  Z59 = cellValue(() => IF(Z57 === '-', '-', 1 - Z57))
  AB59 = cellValue(() => IF(AB57 === '-', '-', 1 - AB57))
  AD59 = cellValue(() => IF(AD57 === '-', '-', 1 - AD57))
  AF59 = cellValue(() => IF(AF57 === '-', '-', 1 - AF57))
  AH59 = cellValue(() => IF(AH57 === '-', '-', 1 - AH57))
  AJ59 = cellValue(() => IF(AJ57 === '-', '-', 1 - AJ57))
  AL59 = cellValue(() => IF(AL57 === '-', '-', 1 - AL57))
  AN59 = cellValue(() => IF(AN57 === '-', '-', 1 - AN57))
  AP59 = cellValue(() => IF(AP57 === '-', '-', 1 - AP57))
  AR59 = cellValue(() => IF(AR57 === '-', '-', 1 - AR57))
  AT59 = cellValue(() => IF(AT57 === '-', '-', 1 - AT57))
  AV59 = cellValue(() => IF(AV57 === '-', '-', 1 - AV57))
  AX59 = cellValue(() => IF(AX57 === '-', '-', 1 - AX57))
  H63 = cellValue(() => T16)
  J63 = cellValue(() => IFERROR(H63 / 3, '-'))
  N63 = cellValue(() => H16)
  P63 = cellValue(() => J16)
  R63 = cellValue(() => L16)
  T63 = cellValue(() => N16)
  V63 = cellValue(() => P16)
  X63 = cellValue(() => R16)
  Z63 = cellValue(() => IFERROR(H63 - J63, '-'))
  H65 = cellValue(() => IF(H63 === '-', '-', 1 - H63))
  J65 = cellValue(() => IF(J63 === '-', '-', 1 - J63))
  N65 = cellValue(() => IF(N63 === '-', '-', 1 - N63))
  P65 = cellValue(() => IF(P63 === '-', '-', 1 - P63))
  R65 = cellValue(() => IF(R63 === '-', '-', 1 - R63))
  T65 = cellValue(() => IF(T63 === '-', '-', 1 - T63))
  V65 = cellValue(() => IF(V63 === '-', '-', 1 - V63))
  X65 = cellValue(() => IF(X63 === '-', '-', 1 - X63))
  Z65 = cellValue(() => IF(Z63 === '-', '-', 1 - Z63))
  BT67 = cellValue(() => IFERROR(BT45 * BT65, '-'))
  BU67 = cellValue(() => IFERROR(BT65 * BU45, '-'))
  BT68 = cellValue(() => IFERROR(ROUND(BT67, 0), '-'))
  BU68 = cellValue(() => IFERROR(ROUND(BU67, 0), '-'))
  H69 = cellValue(() => V16)
  J69 = cellValue(() => X16)
  L69 = cellValue(() => IFERROR((36.97 / 100) * H69, '-'))
  N69 = cellValue(() => IFERROR(100 / 100 - L69, '-'))
  P69 = cellValue(() => IFERROR((49.37 / 100) * H69, '-'))
  R69 = cellValue(() => IFERROR(100 / 100 - P69, '-'))
  BT70 = cellValue(() => IFERROR(BU65 * BT45, '-'))
  BU70 = cellValue(() => IFERROR(BU65 * BU45, '-'))
  H71 = cellValue(() => IF(H69 === '-', '-', 1 - H69))
  J71 = cellValue(() => IF(J69 === '-', '-', 1 - J69))
  L71 = cellValue(() => IF(L69 === '-', '-', 1 - L69))
  N71 = cellValue(() => IF(N69 === '-', '-', 1 - N69))
  P71 = cellValue(() => IF(P69 === '-', '-', 1 - P69))
  R71 = cellValue(() => IF(R69 === '-', '-', 1 - R69))
  BT71 = cellValue(() => IFERROR(ROUND(BT70, 0), '-'))
  BU71 = cellValue(() => IFERROR(ROUND(BU70, 0), '-'))
  H75 = cellValue(() => B16)
  J75 = cellValue(() => IFERROR(D16, '-'))
  L75 = cellValue(() => F16)
  Z87 = cellValue(() =>
    IFERROR(
      H16 +
        J16 * (1 - 45 / 100) +
        L16 * (1 - 45 / 100) ** 2 +
        N16 * (1 - 45 / 100) ** 3 +
        P16 * (1 - 45 / 100) ** 4 +
        R16 * (1 - 45 / 100) ** 5 +
        T16 * 0.5,
      '-'
    )
  )
  H87 = cellValue(() => IFERROR(100 / 100 - Z87, '-'))
  N75 = cellValue(() => IFERROR(H87, '-'))
  Z93 = cellValue(() =>
    IFERROR(
      H16 +
        J16 * (1 - 55 / 100) +
        L16 * (1 - 55 / 100) ** 2 +
        N16 * (1 - 55 / 100) ** 3 +
        P16 * (1 - 55 / 100) ** 4 +
        R16 * (1 - 55 / 100) ** 5 +
        T16 * 0.4,
      '-'
    )
  )
  H93 = cellValue(() => IFERROR(1 - Z93, '-'))
  R75 = cellValue(() => IFERROR((Z87 + H93) / 2, '-'))
  H144 = cellValue(() => IFERROR(H130 * 0.7, '-'))
  V75 = cellValue(() => IFERROR(H144, '-'))
  H174 = cellValue(() => IFERROR(H162 * 0.7, '-'))
  X75 = cellValue(() => IFERROR(H174, '-'))
  P144 = cellValue(() => IFERROR(1 - H144, '-'))
  H150 = cellValue(() => IFERROR(H144 * 1.035, '-'))
  Z75 = cellValue(() => IFERROR((P144 + H150) / 2, '-'))
  P174 = cellValue(() => IFERROR(1 - H174, '-'))
  H180 = cellValue(() => IFERROR(H174 * 1.035, '-'))
  AB75 = cellValue(() => IFERROR((P174 + H180) / 2, '-'))
  H77 = cellValue(() => IF(H75 === '-', '-', 1 - H75))
  J77 = cellValue(() => IF(J75 === '-', '-', 1 - J75))
  L77 = cellValue(() => IF(L75 === '-', '-', 1 - L75))
  N77 = cellValue(() => IF(N75 === '-', '-', 1 - N75))
  R77 = cellValue(() => IF(R75 === '-', '-', 1 - R75))
  V77 = cellValue(() => IF(V75 === '-', '-', 1 - V75))
  X77 = cellValue(() => IF(X75 === '-', '-', 1 - X75))
  Z77 = cellValue(() => IF(Z75 === '-', '-', 1 - Z75))
  AB77 = cellValue(() => IF(AB75 === '-', '-', 1 - AB75))
  H81 = cellValue(() => IFERROR(H75, '-'))
  J81 = cellValue(() => IFERROR(L75, '-'))
  H83 = cellValue(() => IF(H81 === '-', '-', 1 - H81))
  J83 = cellValue(() => IF(J81 === '-', '-', 1 - J81))
  AB87 = cellValue(() =>
    IFERROR(
      J16 * (45 / 100) +
        L16 * (2 * (45 / 100) * (1 - 45 / 100)) +
        N16 * (3 * (45 / 100) * (1 - 45 / 100) ** 2) +
        P16 * (4 * (45 / 100) * (1 - 45 / 100) ** 3) +
        R16 * (5 * (45 / 100) * (1 - 45 / 100) ** 4) +
        T16 * 0.3,
      '-'
    )
  )
  J87 = cellValue(() => IFERROR(100 / 100 - Z87 - AB87, '-'))
  AD87 = cellValue(() =>
    IFERROR(
      L16 * (45 / 100) ** 2 +
        N16 * (3 * (45 / 100) ** 2 * (1 - 45 / 100)) +
        P16 * (6 * (45 / 100) ** 2 * (1 - 45 / 100) ** 2) +
        R16 * (10 * (45 / 100) ** 2 * (1 - 45 / 100) ** 3) +
        T16 * 0.15,
      '-'
    )
  )
  L87 = cellValue(() => IFERROR(1 - (Z87 + AB87 + AD87), '-'))
  AF87 = cellValue(() =>
    IFERROR(
      N16 * (45 / 100) ** 3 +
        P16 * (4 * (45 / 100) ** 3 * (1 - 45 / 100)) +
        R16 * (10 * (45 / 100) ** 3 * (1 - 45 / 100) ** 2) +
        T16 * 0.08,
      '-'
    )
  )
  N87 = cellValue(() => IFERROR(1 - (Z87 + AB87 + AD87 + AF87), '-'))
  P87 = cellValue(() => IFERROR(Z87 + AB87, '-'))
  R87 = cellValue(() => IFERROR(Z87 + AB87 + AD87, '-'))
  T87 = cellValue(() => IFERROR(AB87 + AD87, '-'))
  V87 = cellValue(() => IFERROR(AB87 + AD87 + AF87, '-'))
  X87 = cellValue(() => IFERROR(AD87 + AF87, '-'))
  AH87 = cellValue(() => IFERROR(100 / 100 - AB87, '-'))
  AJ87 = cellValue(() => IFERROR(100 / 100 - AD87, '-'))
  AL87 = cellValue(() => IFERROR(Z87, '-'))
  AN87 = cellValue(() => IFERROR(Z87 + AB87 + AD87 + AF87 + N87, '-'))
  H89 = cellValue(() => IF(H87 === '-', '-', 1 - H87))
  J89 = cellValue(() => IF(J87 === '-', '-', 1 - J87))
  L89 = cellValue(() => IF(L87 === '-', '-', 1 - L87))
  N89 = cellValue(() => IF(N87 === '-', '-', 1 - N87))
  P89 = cellValue(() => IF(P87 === '-', '-', 1 - P87))
  R89 = cellValue(() => IF(R87 === '-', '-', 1 - R87))
  T89 = cellValue(() => IF(T87 === '-', '-', 1 - T87))
  V89 = cellValue(() => IF(V87 === '-', '-', 1 - V87))
  X89 = cellValue(() => IF(X87 === '-', '-', 1 - X87))
  Z89 = cellValue(() => IF(Z87 === '-', '-', 1 - Z87))
  AB89 = cellValue(() => IF(AB87 === '-', '-', 1 - AB87))
  AD89 = cellValue(() => IF(AD87 === '-', '-', 1 - AD87))
  AF89 = cellValue(() => IF(AF87 === '-', '-', 1 - AF87))
  AH89 = cellValue(() => IF(AH87 === '-', '-', 1 - AH87))
  AJ89 = cellValue(() => IF(AJ87 === '-', '-', 1 - AJ87))
  AL89 = cellValue(() => IF(AL87 === '-', '-', 1 - AL87))
  AB93 = cellValue(() =>
    IFERROR(
      J16 * (55 / 100) +
        L16 * (2 * (55 / 100) * (1 - 55 / 100)) +
        N16 * (3 * (55 / 100) * (1 - 55 / 100) ** 2) +
        P16 * (4 * (55 / 100) * (1 - 55 / 100) ** 3) +
        R16 * (5 * (55 / 100) * (1 - 55 / 100) ** 4) +
        T16 * 0.35,
      '-'
    )
  )
  J93 = cellValue(() => IFERROR(1 - Z93 - AB93, '-'))
  AD93 = cellValue(() =>
    IFERROR(
      L16 * (55 / 100) ** 2 +
        N16 * (3 * (55 / 100) ** 2 * (1 - 55 / 100)) +
        P16 * (6 * (55 / 100) ** 2 * (1 - 55 / 100) ** 2) +
        R16 * (10 * (55 / 100) ** 2 * (1 - 55 / 100) ** 3) +
        T16 * 0.18,
      '-'
    )
  )
  L93 = cellValue(() => IFERROR(1 - (Z93 + AB93 + AD93), '-'))
  AF93 = cellValue(() =>
    IFERROR(
      N16 * (55 / 100) ** 3 +
        P16 * (4 * (55 / 100) ** 3 * (1 - 55 / 100)) +
        R16 * (10 * (55 / 100) ** 3 * (1 - 55 / 100) ** 2) +
        T16 * 0.1,
      '-'
    )
  )
  N93 = cellValue(() => IFERROR(1 - (Z93 + AB93 + AD93 + AF93), '-'))
  P93 = cellValue(() => IFERROR(Z93 + AB93, '-'))
  R93 = cellValue(() => IFERROR(Z93 + AB93 + AD93, '-'))
  T93 = cellValue(() => IFERROR(AB93 + AD93, '-'))
  V93 = cellValue(() => IFERROR(AB93 + AD93 + AF93, '-'))
  X93 = cellValue(() => IFERROR(AD93 + AF93, '-'))
  AN93 = cellValue(() => IFERROR(Z93 + AB93 + AD93 + AF93 + N93, '-'))
  AH93 = cellValue(() =>
    IF(
      AN93 === '-',
      '-',
      IF(
        OR(100 / 100 - AB93 < 0 / 100, 100 / 100 - AB93 > 100 / 100),
        '-',
        IFERROR(100 / 100 - AB93, '-')
      )
    )
  )
  AJ93 = cellValue(() => IFERROR(1 - AD93, '-'))
  AL93 = cellValue(() => IFERROR(Z93, '-'))
  H94 = cellValue(() => IFERROR(1 - Z93, '-'))
  J94 = cellValue(() => IFERROR(1 - Z93 - AB93, '-'))
  L94 = cellValue(() => IFERROR(1 - (Z93 + AB93 + AD93), '-'))
  N94 = cellValue(() => IFERROR(1 - (Z93 + AB93 + AD93 + AF93), '-'))
  P94 = cellValue(() => IFERROR(Z93 + AB93, '-'))
  R94 = cellValue(() => IFERROR(Z93 + AB93 + AD93, '-'))
  T94 = cellValue(() => IFERROR(AB93 + AD93, '-'))
  V94 = cellValue(() => IFERROR(AB93 + AD93 + AF93, '-'))
  X94 = cellValue(() => IFERROR(AD93 + AF93, '-'))
  Z94 = cellValue(() =>
    IFERROR(
      H16 +
        J16 * (1 - 55 / 100) +
        L16 * (1 - 55 / 100) ** 2 +
        N16 * (1 - 55 / 100) ** 3 +
        P16 * (1 - 55 / 100) ** 4 +
        R16 * (1 - 55 / 100) ** 5 +
        T16 * 0.4,
      '-'
    )
  )
  AB94 = cellValue(() =>
    IFERROR(
      J16 * (55 / 100) +
        L16 * (2 * (55 / 100) * (1 - 55 / 100)) +
        N16 * (3 * (55 / 100) * (1 - 55 / 100) ** 2) +
        P16 * (4 * (55 / 100) * (1 - 55 / 100) ** 3) +
        R16 * (5 * (55 / 100) * (1 - 55 / 100) ** 4) +
        T16 * 0.35,
      '-'
    )
  )
  AD94 = cellValue(() =>
    IFERROR(
      L16 * (55 / 100) ** 2 +
        N16 * (3 * (55 / 100) ** 2 * (1 - 55 / 100)) +
        P16 * (6 * (55 / 100) ** 2 * (1 - 55 / 100) ** 2) +
        R16 * (10 * (55 / 100) ** 2 * (1 - 55 / 100) ** 3) +
        T16 * 0.18,
      '-'
    )
  )
  AF94 = cellValue(() =>
    IFERROR(
      N16 * (55 / 100) ** 3 +
        P16 * (4 * (55 / 100) ** 3 * (1 - 55 / 100)) +
        R16 * (10 * (55 / 100) ** 3 * (1 - 55 / 100) ** 2) +
        T16 * 0.1,
      '-'
    )
  )
  AH94 = cellValue(() =>
    IF(
      AN93 === '-',
      '-',
      IF(
        OR(100 / 100 - AB93 < 0 / 100, 100 / 100 - AB93 > 100 / 100),
        '-',
        IFERROR(100 / 100 - AB93, '-')
      )
    )
  )
  AJ94 = cellValue(() => IFERROR(1 - AD93, '-'))
  AL94 = cellValue(() => IFERROR(Z93, '-'))
  H96 = cellValue(() => IF(H94 === '-', '-', 1 - H94))
  J96 = cellValue(() => IF(J94 === '-', '-', 1 - J94))
  L96 = cellValue(() => IF(L94 === '-', '-', 1 - L94))
  N96 = cellValue(() => IF(N94 === '-', '-', 1 - N94))
  P96 = cellValue(() => IF(P94 === '-', '-', 1 - P94))
  R96 = cellValue(() => IF(R94 === '-', '-', 1 - R94))
  T96 = cellValue(() => IF(T94 === '-', '-', 1 - T94))
  V96 = cellValue(() => IF(V94 === '-', '-', 1 - V94))
  X96 = cellValue(() => IF(X94 === '-', '-', 1 - X94))
  Z96 = cellValue(() => IF(Z94 === '-', '-', 1 - Z94))
  AB96 = cellValue(() => IF(AB94 === '-', '-', 1 - AB94))
  AD96 = cellValue(() => IF(AD94 === '-', '-', 1 - AD94))
  AF96 = cellValue(() => IF(AF94 === '-', '-', 1 - AF94))
  AH96 = cellValue(() => IF(AH94 === '-', '-', 1 - AH94))
  AJ96 = cellValue(() => IF(AJ94 === '-', '-', 1 - AJ94))
  AL96 = cellValue(() => IF(AL94 === '-', '-', 1 - AL94))
  H100 = cellValue(() => IFERROR(H87 * AR57, '-'))
  J100 = cellValue(() => IFERROR(H87 * AH12, '-'))
  L100 = cellValue(() => IFERROR(H87 * H94, '-'))
  P100 = cellValue(() => IFERROR(H87 * J93, '-'))
  T100 = cellValue(() => IFERROR(H87 * L94, '-'))
  X100 = cellValue(() => IFERROR(H87 * P94, '-'))
  AB100 = cellValue(() => IFERROR(P87 * R94, '-'))
  AF100 = cellValue(() => IFERROR(H87 * T94, '-'))
  AJ100 = cellValue(() => IFERROR(H87 * V94, '-'))
  AN100 = cellValue(() => IFERROR(H87 * X94, '-'))
  AR100 = cellValue(() => IFERROR(H87 * X93, '-'))
  AV100 = cellValue(() => IFERROR(P87 * J93, '-'))
  H102 = cellValue(() => IF(H100 === '-', '-', 1 - H100))
  J102 = cellValue(() => IF(J100 === '-', '-', 1 - J100))
  L102 = cellValue(() => IF(L100 === '-', '-', 1 - L100))
  P102 = cellValue(() => IF(P100 === '-', '-', 1 - P100))
  T102 = cellValue(() => IF(T100 === '-', '-', 1 - T100))
  X102 = cellValue(() => IF(X100 === '-', '-', 1 - X100))
  AB102 = cellValue(() => IF(AB100 === '-', '-', 1 - AB100))
  AF102 = cellValue(() => IF(AF100 === '-', '-', 1 - AF100))
  AJ102 = cellValue(() => IF(AJ100 === '-', '-', 1 - AJ100))
  AN102 = cellValue(() => IF(AN100 === '-', '-', 1 - AN100))
  AR102 = cellValue(() => IF(AR100 === '-', '-', 1 - AR100))
  AV102 = cellValue(() => IF(AV100 === '-', '-', 1 - AV100))
  H106 = cellValue(() => IFERROR(P87 * P94, '-'))
  L106 = cellValue(() => IFERROR(P87 * (Z94 + AB94 + AD94 + AF94), '-'))
  P106 = cellValue(() => IFERROR(P87 * T94, '-'))
  T106 = cellValue(() => P87)
  X106 = cellValue(() => IFERROR(P87 * X94, '-'))
  AB106 = cellValue(() => IFERROR(J87 * H94, '-'))
  AF106 = cellValue(() => IFERROR(J87 * J93, '-'))
  AJ106 = cellValue(() => IFERROR(J87 * L94, '-'))
  AN106 = cellValue(() => IFERROR(J87 * N94, '-'))
  AR106 = cellValue(() => IFERROR(J87 * P94, '-'))
  AV106 = cellValue(() => IFERROR(J87 * X94, '-'))
  H108 = cellValue(() => IF(H106 === '-', '-', 1 - H106))
  L108 = cellValue(() => IF(L106 === '-', '-', 1 - L106))
  P108 = cellValue(() => IF(P106 === '-', '-', 1 - P106))
  T108 = cellValue(() => IF(T106 === '-', '-', 1 - T106))
  X108 = cellValue(() => IF(X106 === '-', '-', 1 - X106))
  AB108 = cellValue(() => IF(AB106 === '-', '-', 1 - AB106))
  AF108 = cellValue(() => IF(AF106 === '-', '-', 1 - AF106))
  AJ108 = cellValue(() => IF(AJ106 === '-', '-', 1 - AJ106))
  AN108 = cellValue(() => IF(AN106 === '-', '-', 1 - AN106))
  AR108 = cellValue(() => IF(AR106 === '-', '-', 1 - AR106))
  AV108 = cellValue(() => IF(AV106 === '-', '-', 1 - AV106))
  H112 = cellValue(() => IFERROR(R87 * J93, '-'))
  L112 = cellValue(() => IFERROR(R87 * P94, '-'))
  P112 = cellValue(() => IFERROR(R87 * R94, '-'))
  T112 = cellValue(() => IFERROR(R87 * (Z94 + AB94 + AD94 + AF94), '-'))
  X112 = cellValue(() => IFERROR(R87 * T94, '-'))
  AB112 = cellValue(() => IFERROR(R94 * V94, '-'))
  AF112 = cellValue(() => IFERROR(R87 * X94, '-'))
  AJ112 = cellValue(() => IFERROR(T87 * H94, '-'))
  AN112 = cellValue(() => IFERROR(T87 * J93, '-'))
  AR112 = cellValue(() => IFERROR(T87 * P94, '-'))
  AV112 = cellValue(() => IFERROR(T87 * R94, '-'))
  H114 = cellValue(() => IF(H112 === '-', '-', 1 - H112))
  L114 = cellValue(() => IF(L112 === '-', '-', 1 - L112))
  P114 = cellValue(() => IF(P112 === '-', '-', 1 - P112))
  T114 = cellValue(() => IF(T112 === '-', '-', 1 - T112))
  X114 = cellValue(() => IF(X112 === '-', '-', 1 - X112))
  AB114 = cellValue(() => IF(AB112 === '-', '-', 1 - AB112))
  AF114 = cellValue(() => IF(AF112 === '-', '-', 1 - AF112))
  AJ114 = cellValue(() => IF(AJ112 === '-', '-', 1 - AJ112))
  AN114 = cellValue(() => IF(AN112 === '-', '-', 1 - AN112))
  AR114 = cellValue(() => IF(AR112 === '-', '-', 1 - AR112))
  AV114 = cellValue(() => IF(AV112 === '-', '-', 1 - AV112))
  H118 = cellValue(() => IFERROR(T87 * (Z94 + AB94 + AD94 + AF94), '-'))
  L118 = cellValue(() => IFERROR(T87 * L94, '-'))
  P118 = cellValue(() => IFERROR(T87 * R87, '-'))
  T118 = cellValue(() => IFERROR(V87 * L94, '-'))
  X118 = cellValue(() => IFERROR(V87 * H94, '-'))
  AB118 = cellValue(() => IFERROR(V87 * J93, '-'))
  AF118 = cellValue(() => IFERROR(V87 * T94, '-'))
  AJ118 = cellValue(() => IFERROR(V87 * V94, '-'))
  AN118 = cellValue(() => IFERROR(X87 * H94, '-'))
  AR118 = cellValue(() => IFERROR(X87 * J93, '-'))
  AV118 = cellValue(() => IFERROR(X87 * L94, '-'))
  H120 = cellValue(() => IF(H118 === '-', '-', 1 - H118))
  L120 = cellValue(() => IF(L118 === '-', '-', 1 - L118))
  P120 = cellValue(() => IF(P118 === '-', '-', 1 - P118))
  T120 = cellValue(() => IF(T118 === '-', '-', 1 - T118))
  X120 = cellValue(() => IF(X118 === '-', '-', 1 - X118))
  AB120 = cellValue(() => IF(AB118 === '-', '-', 1 - AB118))
  AF120 = cellValue(() => IF(AF118 === '-', '-', 1 - AF118))
  AJ120 = cellValue(() => IF(AJ118 === '-', '-', 1 - AJ118))
  AN120 = cellValue(() => IF(AN118 === '-', '-', 1 - AN118))
  AR120 = cellValue(() => IF(AR118 === '-', '-', 1 - AR118))
  AV120 = cellValue(() => IF(AV118 === '-', '-', 1 - AV118))
  H124 = cellValue(() => IFERROR(X87 * N94, '-'))
  L124 = cellValue(() => IFERROR(X87 * P94, '-'))
  P124 = cellValue(() => IFERROR(X87 * R94, '-'))
  T124 = cellValue(() => IFERROR(X87 * V94, '-'))
  X124 = cellValue(() => IFERROR(X87 * T94, '-'))
  AB124 = cellValue(() => IFERROR(X87 * X94, '-'))
  AF124 = cellValue(() => IFERROR(J87 * AV57, '-'))
  AJ124 = cellValue(() => IFERROR(J93 * AV57, '-'))
  H126 = cellValue(() => IF(H124 === '-', '-', 1 - H124))
  L126 = cellValue(() => IF(L124 === '-', '-', 1 - L124))
  P126 = cellValue(() => IF(P124 === '-', '-', 1 - P124))
  T126 = cellValue(() => IF(T124 === '-', '-', 1 - T124))
  X126 = cellValue(() => IF(X124 === '-', '-', 1 - X124))
  AB126 = cellValue(() => IF(AB124 === '-', '-', 1 - AB124))
  AF126 = cellValue(() => IF(AF124 === '-', '-', 1 - AF124))
  AJ126 = cellValue(() => IF(AJ124 === '-', '-', 1 - AJ124))
  P130 = cellValue(() => IFERROR(V130 + X130, '-'))
  J130 = cellValue(() => IFERROR(1 - P130, '-'))
  T130 = cellValue(() => IFERROR(1 - N130, '-'))
  AD130 = cellValue(() => IFERROR(X130 + Z130, '-'))
  AF130 = cellValue(() => IFERROR(X130 + Z130 + AB130, '-'))
  AH130 = cellValue(() => IFERROR(Z130 + AB130, '-'))
  L136 = cellValue(() => IFERROR(H136 * 0.25, '-'))
  N136 = cellValue(() => IFERROR(H136 * 0.16667, '-'))
  AJ134 = cellValue(() => IFERROR(X130 + V130 + L136 + N136 + J136, '-'))
  AJ130 = cellValue(() => IFERROR(1 - AJ134, '-'))
  AL134 = cellValue(() => IFERROR(V130 + X130 + L136 + N136, '-'))
  AL130 = cellValue(() => IFERROR(1 - AL134, '-'))
  AN134 = cellValue(() => IFERROR(V130 + X130 + N136, '-'))
  AN130 = cellValue(() => IFERROR(1 - AN134, '-'))
  AP134 = cellValue(() => IFERROR(V130 + X130 + Z130 + J136 + L136 + N136, '-'))
  AP130 = cellValue(() => IFERROR(1 - AP134, '-'))
  AR134 = cellValue(() => IFERROR(V130 + X130 + Z130 + L136 + N136, '-'))
  AR130 = cellValue(() => IFERROR(1 - AR134, '-'))
  AT134 = cellValue(() => IFERROR(V130 + X130 + Z130 + AB130 + N136, '-'))
  AT130 = cellValue(() => IFERROR(1 - AT134, '-'))
  H132 = cellValue(() => IF(H130 === '-', '-', 1 - H130))
  J132 = cellValue(() => IF(J130 === '-', '-', 1 - J130))
  L132 = cellValue(() => IF(L130 === '-', '-', 1 - L130))
  N132 = cellValue(() => IF(N130 === '-', '-', 1 - N130))
  P132 = cellValue(() => IF(P130 === '-', '-', 1 - P130))
  R132 = cellValue(() => IF(R130 === '-', '-', 1 - R130))
  T132 = cellValue(() => IF(T130 === '-', '-', 1 - T130))
  V132 = cellValue(() => IF(V130 === '-', '-', 1 - V130))
  X132 = cellValue(() => IF(X130 === '-', '-', 1 - X130))
  Z132 = cellValue(() => IF(Z130 === '-', '-', 1 - Z130))
  AB132 = cellValue(() => IF(AB130 === '-', '-', 1 - AB130))
  AD132 = cellValue(() => IF(AD130 === '-', '-', 1 - AD130))
  AF132 = cellValue(() => IF(AF130 === '-', '-', 1 - AF130))
  AH132 = cellValue(() => IF(AH130 === '-', '-', 1 - AH130))
  AJ132 = cellValue(() => IF(AJ130 === '-', '-', 1 - AJ130))
  AL132 = cellValue(() => IF(AL130 === '-', '-', 1 - AL130))
  AN132 = cellValue(() => IF(AN130 === '-', '-', 1 - AN130))
  AP132 = cellValue(() => IF(AP130 === '-', '-', 1 - AP130))
  AR132 = cellValue(() => IF(AR130 === '-', '-', 1 - AR130))
  AT132 = cellValue(() => IF(AT130 === '-', '-', 1 - AT130))
  AV132 = cellValue(() => IF(AV130 === '-', '-', 1 - AV130))
  AX132 = cellValue(() => IF(AX130 === '-', '-', 1 - AX130))
  J138 = cellValue(() => IF(J136 === '-', '-', 1 - J136))
  L138 = cellValue(() => IF(L136 === '-', '-', 1 - L136))
  N138 = cellValue(() => IF(N136 === '-', '-', 1 - N136))
  J144 = cellValue(() => IFERROR(H144 * 0.275, '-'))
  R144 = cellValue(() => IFERROR(1 - J144 - P144, '-'))
  L144 = cellValue(() => IFERROR(J144 * 0.2, '-'))
  T144 = cellValue(() => IFERROR(1 - L144 - P144 - R144, '-'))
  N144 = cellValue(() =>
    IF(
      L144 === '-',
      '-',
      IF(L144 - 3.3 / 100 < 0 / 100, 0 / 100, L144 - 3.3 / 100)
    )
  )
  AD144 = cellValue(() => IFERROR(1 - N144 - P144 - R144 - T144, '-'))
  AF142 = cellValue(() => IFERROR(P144 + R144 + T144 + AD144, '-'))
  V144 = cellValue(() => IFERROR(P144 + R144, '-'))
  X144 = cellValue(() => IFERROR(R144 + T144, '-'))
  Z144 = cellValue(() => IFERROR(J144 - N144, '-'))
  AB144 = cellValue(() => IFERROR(H144, '-'))
  H146 = cellValue(() => IF(H144 === '-', '-', 1 - H144))
  J146 = cellValue(() => IF(J144 === '-', '-', 1 - J144))
  L146 = cellValue(() => IF(L144 === '-', '-', 1 - L144))
  N146 = cellValue(() => IF(N144 === '-', '-', 1 - N144))
  P146 = cellValue(() => IF(P144 === '-', '-', 1 - P144))
  R146 = cellValue(() => IF(R144 === '-', '-', 1 - R144))
  T146 = cellValue(() => IF(T144 === '-', '-', 1 - T144))
  V146 = cellValue(() => IF(V144 === '-', '-', 1 - V144))
  X146 = cellValue(() => IF(X144 === '-', '-', 1 - X144))
  Z146 = cellValue(() => IF(Z144 === '-', '-', 1 - Z144))
  AB146 = cellValue(() => IF(AB144 === '-', '-', 1 - AB144))
  AD146 = cellValue(() => IF(AD144 === '-', '-', 1 - AD144))
  P150 = cellValue(() => IFERROR(1 - H150, '-'))
  J150 = cellValue(() => IFERROR(J144 * 1.035, '-'))
  R150 = cellValue(() => IFERROR(1 - J150 - P150, '-'))
  L150 = cellValue(() => IFERROR(L144 * 1.6, '-'))
  T150 = cellValue(() => IFERROR(1 - L150 - P150 - R150, '-'))
  N150 = cellValue(() =>
    IF(
      OR(N144 + 1 / 100 < 0 / 100, N144 + 1 / 100 > 100 / 100),
      '-',
      IFERROR(N144 + 1 / 100, '-')
    )
  )
  AD150 = cellValue(() => IFERROR(1 - N150 - P150 - R150 - T150, '-'))
  AF148 = cellValue(() => IFERROR(P150 + R150 + T150 + AD150, '-'))
  V150 = cellValue(() => IFERROR(P150 + R150, '-'))
  X150 = cellValue(() => IFERROR(R150 + T150, '-'))
  Z150 = cellValue(() => IFERROR(J150 - N150, '-'))
  AB150 = cellValue(() => IFERROR(H150, '-'))
  H152 = cellValue(() => IF(H150 === '-', '-', 1 - H150))
  J152 = cellValue(() => IF(J150 === '-', '-', 1 - J150))
  L152 = cellValue(() => IF(L150 === '-', '-', 1 - L150))
  N152 = cellValue(() => IF(N150 === '-', '-', 1 - N150))
  P152 = cellValue(() => IF(P150 === '-', '-', 1 - P150))
  R152 = cellValue(() => IF(R150 === '-', '-', 1 - R150))
  T152 = cellValue(() => IF(T150 === '-', '-', 1 - T150))
  V152 = cellValue(() => IF(V150 === '-', '-', 1 - V150))
  X152 = cellValue(() => IF(X150 === '-', '-', 1 - X150))
  Z152 = cellValue(() => IF(Z150 === '-', '-', 1 - Z150))
  AB152 = cellValue(() => IF(AB150 === '-', '-', 1 - AB150))
  AD152 = cellValue(() => IF(AD150 === '-', '-', 1 - AD150))
  H156 = cellValue(() => IFERROR(H144 * J130, '-'))
  L156 = cellValue(() => IFERROR(H144 * L130, '-'))
  P156 = cellValue(() => IFERROR(H144 * J150, '-'))
  T156 = cellValue(() => IFERROR(J144 * H150, '-'))
  X156 = cellValue(() => IFERROR(J144 * J150, '-'))
  AB156 = cellValue(() => IFERROR(V144 * V150, '-'))
  AF156 = cellValue(() => IFERROR(V144 * (V150 + T150), '-'))
  AJ156 = cellValue(() => IFERROR((V144 + T144) * V150, '-'))
  AN156 = cellValue(() => IFERROR((V144 + T144) * (V150 + T150), '-'))
  AR156 = cellValue(() => IFERROR(R144 * N130, '-'))
  H158 = cellValue(() => IF(H156 === '-', '-', 1 - H156))
  L158 = cellValue(() => IF(L156 === '-', '-', 1 - L156))
  P158 = cellValue(() => IF(P156 === '-', '-', 1 - P156))
  T158 = cellValue(() => IF(T156 === '-', '-', 1 - T156))
  X158 = cellValue(() => IF(X156 === '-', '-', 1 - X156))
  AB158 = cellValue(() => IF(AB156 === '-', '-', 1 - AB156))
  AF158 = cellValue(() => IF(AF156 === '-', '-', 1 - AF156))
  AJ158 = cellValue(() => IF(AJ156 === '-', '-', 1 - AJ156))
  AN158 = cellValue(() => IF(AN156 === '-', '-', 1 - AN156))
  AR158 = cellValue(() => IF(AR156 === '-', '-', 1 - AR156))
  P162 = cellValue(() => IFERROR(V162 + X162, '-'))
  J162 = cellValue(() => IFERROR(1 - P162, '-'))
  T162 = cellValue(() => IFERROR(1 - N162, '-'))
  AD162 = cellValue(() => IFERROR(X162 + Z162, '-'))
  AF162 = cellValue(() => IFERROR(X162 + Z162 + AB162, '-'))
  AH162 = cellValue(() => IFERROR(Z162 + AB162, '-'))
  L168 = cellValue(() => IFERROR(H168 * 0.25, '-'))
  N168 = cellValue(() => IFERROR(H168 * 0.16667, '-'))
  AJ166 = cellValue(() => IFERROR(X162 + V162 + L168 + N168 + J168, '-'))
  AJ162 = cellValue(() => IFERROR(1 - AJ166, '-'))
  AL166 = cellValue(() => IFERROR(V162 + X162 + L168 + N168, '-'))
  AN166 = cellValue(() => IFERROR(V162 + X162 + N168, '-'))
  AL162 = cellValue(() => IFERROR(1 - AL166, '-'))
  AN162 = cellValue(() => IFERROR(1 - AN166, '-'))
  AP166 = cellValue(() => IFERROR(V162 + X162 + Z162 + J168 + L168 + N168, '-'))
  AP162 = cellValue(() => IFERROR(1 - AP166, '-'))
  AR166 = cellValue(() => IFERROR(V162 + X162 + Z162 + L168 + N168, '-'))
  AR162 = cellValue(() => IFERROR(1 - AR166, '-'))
  AT166 = cellValue(() => IFERROR(V162 + X162 + Z162 + AB162 + N168, '-'))
  AT162 = cellValue(() => IFERROR(1 - AT166, '-'))
  H164 = cellValue(() => IF(H162 === '-', '-', 1 - H162))
  J164 = cellValue(() => IF(J162 === '-', '-', 1 - J162))
  L164 = cellValue(() => IF(L162 === '-', '-', 1 - L162))
  N164 = cellValue(() => IF(N162 === '-', '-', 1 - N162))
  P164 = cellValue(() => IF(P162 === '-', '-', 1 - P162))
  R164 = cellValue(() => IF(R162 === '-', '-', 1 - R162))
  T164 = cellValue(() => IF(T162 === '-', '-', 1 - T162))
  V164 = cellValue(() => IF(V162 === '-', '-', 1 - V162))
  X164 = cellValue(() => IF(X162 === '-', '-', 1 - X162))
  Z164 = cellValue(() => IF(Z162 === '-', '-', 1 - Z162))
  AB164 = cellValue(() => IF(AB162 === '-', '-', 1 - AB162))
  AD164 = cellValue(() => IF(AD162 === '-', '-', 1 - AD162))
  AF164 = cellValue(() => IF(AF162 === '-', '-', 1 - AF162))
  AH164 = cellValue(() => IF(AH162 === '-', '-', 1 - AH162))
  AJ164 = cellValue(() => IF(AJ162 === '-', '-', 1 - AJ162))
  AL164 = cellValue(() => IF(AL162 === '-', '-', 1 - AL162))
  AN164 = cellValue(() => IF(AN162 === '-', '-', 1 - AN162))
  AP164 = cellValue(() => IF(AP162 === '-', '-', 1 - AP162))
  AR164 = cellValue(() => IF(AR162 === '-', '-', 1 - AR162))
  AT164 = cellValue(() => IF(AT162 === '-', '-', 1 - AT162))
  AV164 = cellValue(() => IF(AV162 === '-', '-', 1 - AV162))
  AX164 = cellValue(() => IF(AX162 === '-', '-', 1 - AX162))
  J170 = cellValue(() => IF(J168 === '-', '-', 1 - J168))
  L170 = cellValue(() => IF(L168 === '-', '-', 1 - L168))
  N170 = cellValue(() => IF(N168 === '-', '-', 1 - N168))
  J174 = cellValue(() => IFERROR(H174 * 0.275, '-'))
  R174 = cellValue(() => IFERROR(1 - J174 - P174, '-'))
  L174 = cellValue(() => IFERROR(J174 * 0.2, '-'))
  T174 = cellValue(() => IFERROR(1 - L174 - P174 - R174, '-'))
  N174 = cellValue(() =>
    IF(J174 === '-', '-', IF(L174 - 3 / 100 < 0 / 100, 0 / 100, L174 - 3 / 100))
  )
  AD174 = cellValue(() => IFERROR(1 - N174 - P174 - R174 - T174, '-'))
  AF172 = cellValue(() => IFERROR(P174 + R174 + T174 + AD174, '-'))
  V174 = cellValue(() => IFERROR(P174 + R174, '-'))
  X174 = cellValue(() => IFERROR(R174 + T174, '-'))
  Z174 = cellValue(() => IFERROR(J174 - N174, '-'))
  AB174 = cellValue(() => IFERROR(H180, '-'))
  H176 = cellValue(() => IF(H174 === '-', '-', 1 - H174))
  J176 = cellValue(() => IF(J174 === '-', '-', 1 - J174))
  L176 = cellValue(() => IF(L174 === '-', '-', 1 - L174))
  N176 = cellValue(() => IF(N174 === '-', '-', 1 - N174))
  P176 = cellValue(() => IF(P174 === '-', '-', 1 - P174))
  R176 = cellValue(() => IF(R174 === '-', '-', 1 - R174))
  T176 = cellValue(() => IF(T174 === '-', '-', 1 - T174))
  V176 = cellValue(() => IF(V174 === '-', '-', 1 - V174))
  X176 = cellValue(() => IF(X174 === '-', '-', 1 - X174))
  Z176 = cellValue(() => IF(Z174 === '-', '-', 1 - Z174))
  AB176 = cellValue(() => IF(AB174 === '-', '-', 1 - AB174))
  AD176 = cellValue(() => IF(AD174 === '-', '-', 1 - AD174))
  P180 = cellValue(() => IFERROR(1 - H180, '-'))
  J180 = cellValue(() => IFERROR(J174 * 1.035, '-'))
  R180 = cellValue(() => IFERROR(1 - J180 - P180, '-'))
  L180 = cellValue(() => IFERROR(L174 * 1.6, '-'))
  T180 = cellValue(() => IFERROR(1 - L180 - P180 - R180, '-'))
  N180 = cellValue(() =>
    IF(
      OR(N174 + 1 / 100 < 0 / 100, N174 + 1 / 100 > 100 / 100),
      '-',
      IFERROR(N174 + 1 / 100, '-')
    )
  )
  AD180 = cellValue(() => IFERROR(1 - N180 - P180 - R180 - T180, '-'))
  AF178 = cellValue(() => IFERROR(P180 + R180 + T180 + AD180, '-'))
  V180 = cellValue(() => IFERROR(P180 + R180, '-'))
  X180 = cellValue(() => IFERROR(R180 + T180, '-'))
  Z180 = cellValue(() => IFERROR(J180 - N180, '-'))
  AB180 = cellValue(() => IFERROR(H180, '-'))
  H182 = cellValue(() => IF(H180 === '-', '-', 1 - H180))
  J182 = cellValue(() => IF(J180 === '-', '-', 1 - J180))
  L182 = cellValue(() => IF(L180 === '-', '-', 1 - L180))
  N182 = cellValue(() => IF(N180 === '-', '-', 1 - N180))
  P182 = cellValue(() => IF(P180 === '-', '-', 1 - P180))
  R182 = cellValue(() => IF(R180 === '-', '-', 1 - R180))
  T182 = cellValue(() => IF(T180 === '-', '-', 1 - T180))
  V182 = cellValue(() => IF(V180 === '-', '-', 1 - V180))
  X182 = cellValue(() => IF(X180 === '-', '-', 1 - X180))
  Z182 = cellValue(() => IF(Z180 === '-', '-', 1 - Z180))
  AB182 = cellValue(() => IF(AB180 === '-', '-', 1 - AB180))
  AD182 = cellValue(() => IF(AD180 === '-', '-', 1 - AD180))
  H186 = cellValue(() => IFERROR(H174 * J162, '-'))
  L186 = cellValue(() => IFERROR(H174 * L162, '-'))
  P186 = cellValue(() => IFERROR(H174 * J180, '-'))
  T186 = cellValue(() => IFERROR(J174 * H180, '-'))
  X186 = cellValue(() => IFERROR(J174 * J180, '-'))
  AB186 = cellValue(() => IFERROR(V174 * V180, '-'))
  AF186 = cellValue(() => IFERROR(V174 * (V180 + T180), '-'))
  AJ186 = cellValue(() => IFERROR((V174 + T174) * V180, '-'))
  AN186 = cellValue(() => IFERROR((V174 + T174) * (V180 + T180), '-'))
  AR186 = cellValue(() => IFERROR(R174 * N162, '-'))
  H188 = cellValue(() => IF(H186 === '-', '-', 1 - H186))
  L188 = cellValue(() => IF(L186 === '-', '-', 1 - L186))
  P188 = cellValue(() => IF(P186 === '-', '-', 1 - P186))
  T188 = cellValue(() => IF(T186 === '-', '-', 1 - T186))
  X188 = cellValue(() => IF(X186 === '-', '-', 1 - X186))
  AB188 = cellValue(() => IF(AB186 === '-', '-', 1 - AB186))
  AF188 = cellValue(() => IF(AF186 === '-', '-', 1 - AF186))
  AJ188 = cellValue(() => IF(AJ186 === '-', '-', 1 - AJ186))
  AN188 = cellValue(() => IF(AN186 === '-', '-', 1 - AN186))
  AR188 = cellValue(() => IF(AR186 === '-', '-', 1 - AR186))
  H192 = cellValue(() => IFERROR(V16 * (N16 + P16 + R16 + T16), '-'))
  J192 = cellValue(() => IFERROR(V16 * (P16 + R16 + T16), '-'))
  L192 = cellValue(() => IFERROR(J130 * J162, '-'))
  N192 = cellValue(() => IFERROR(V16 * J130, '-'))
  P192 = cellValue(() => IFERROR(V16 * J162, '-'))
  R192 = cellValue(() => IFERROR(V16 * L57, '-'))
  T192 = cellValue(() => IFERROR(X16 * (N16 + P16 + R16 + T16), '-'))
  H194 = cellValue(() => IF(H192 === '-', '-', 1 - H192))
  J194 = cellValue(() => IF(J192 === '-', '-', 1 - J192))
  L194 = cellValue(() => IF(L192 === '-', '-', 1 - L192))
  N194 = cellValue(() => IF(N192 === '-', '-', 1 - N192))
  P194 = cellValue(() => IF(P192 === '-', '-', 1 - P192))
  R194 = cellValue(() => IF(R192 === '-', '-', 1 - R192))
  T194 = cellValue(() => IF(T192 === '-', '-', 1 - T192))
  J198 = cellValue(() => V130)
  H198 = cellValue(() => IFERROR(1 - J198, '-'))
  H200 = cellValue(() => IF(H198 === '-', '-', 1 - H198))
  J200 = cellValue(() => IF(J198 === '-', '-', 1 - J198))
  J204 = cellValue(() => V162)
  H204 = cellValue(() => IFERROR(1 - J204, '-'))
  H206 = cellValue(() => IF(H204 === '-', '-', 1 - H204))
  J206 = cellValue(() => IF(J204 === '-', '-', 1 - J204))
  H210 = cellValue(() => IF(!EQUALS(D8, 100 / 100), '-', 45 / 100))
  J210 = cellValue(() => IF(!EQUALS(D8, 100 / 100), '-', 15 / 100))
  L210 = cellValue(() => IF(!EQUALS(D8, 100 / 100), '-', 40 / 100))
  H212 = cellValue(() => IF(H210 === '-', '-', 1 - H210))
  J212 = cellValue(() => IF(J210 === '-', '-', 1 - J210))
  L212 = cellValue(() => IF(L210 === '-', '-', 1 - L210))
  J215 = cellValue(() => IF(Z25 === '-', '-', AD25 * J25))
  L215 = cellValue(() => IF(AD25 === '-', '-', AD25 * H25))
  T215 = cellValue(() => IF(AJ25 === '-', '-', Z25 * J25))
  V215 = cellValue(() => IF(AN25 === '-', '-', Z25 * L25))
  H218 = cellValue(() => IFERROR(H25 * Z25, '-'))
  J218 = cellValue(() =>
    IF(H218 === '-', '-', IF(Z25 * J25 < Z25 * L25, Z25 * L25, Z25 * J25))
  )
  L218 = cellValue(() =>
    IF(H218 === '-', '-', IF(Z25 * J25 < Z25 * L25, Z25 * J25, Z25 * L25))
  )
  N218 = cellValue(() => IFERROR(AB25 * H25, '-'))
  P218 = cellValue(() => IFERROR(J25 * AB25, '-'))
  R218 = cellValue(() => IFERROR(AB25 * L25, '-'))
  T218 = cellValue(() =>
    IF(R218 === '-', '-', IF(AD25 * H25 < AD25 * J25, AD25 * H25, AD25 * J25))
  )
  V218 = cellValue(() =>
    IF(H218 === '-', '-', IF(AD25 * H25 > AD25 * J25, AD25 * H25, AD25 * J25))
  )
  X218 = cellValue(() =>
    IFERROR(1 - H218 - J218 - L218 - N218 - P218 - R218 - T218 - V218, '-')
  )
  H220 = cellValue(() => IF(H218 === '-', '-', 1 - H218))
  J220 = cellValue(() => IF(J218 === '-', '-', 1 - J218))
  L220 = cellValue(() => IF(L218 === '-', '-', 1 - L218))
  N220 = cellValue(() => IF(N218 === '-', '-', 1 - N218))
  P220 = cellValue(() => IF(P218 === '-', '-', 1 - P218))
  R220 = cellValue(() => IF(R218 === '-', '-', 1 - R218))
  T220 = cellValue(() => IF(T218 === '-', '-', 1 - T218))
  V220 = cellValue(() => IF(V218 === '-', '-', 1 - V218))
  X220 = cellValue(() => IF(X218 === '-', '-', 1 - X218))
  H224 = cellValue(() => IFERROR(H218 + J218, '-'))
  J224 = cellValue(() => IFERROR(J218 + L218, '-'))
  L224 = cellValue(() => IFERROR(H218 + L218, '-'))
  N224 = cellValue(() => IFERROR(T218 + V218, '-'))
  P224 = cellValue(() => IFERROR(V218 + X218, '-'))
  R224 = cellValue(() => IFERROR(T218 + X218, '-'))
  T224 = cellValue(() => IFERROR(N218 + P218, '-'))
  V224 = cellValue(() => IFERROR(P218 + R218, '-'))
  X224 = cellValue(() => IFERROR(N218 + R218, '-'))
  Z224 = cellValue(() => IFERROR(H218 + N218, '-'))
  AB224 = cellValue(() => IFERROR(J218 + P218, '-'))
  AD224 = cellValue(() => IFERROR(L218 + R218, '-'))
  AF224 = cellValue(() => IFERROR(P218 + V218, '-'))
  AH224 = cellValue(() => IFERROR(R218 + P218, '-'))
  AJ224 = cellValue(() => IFERROR(R218 + X218, '-'))
  AL224 = cellValue(() => IFERROR(H218 + T218, '-'))
  AN224 = cellValue(() => IFERROR(J218 + V218, '-'))
  AP224 = cellValue(() => IFERROR(L218 + X218, '-'))
  AR224 = cellValue(() => IFERROR(H218 + J218 + N218 + P218, '-'))
  AT224 = cellValue(() => IFERROR(J218 + L218 + P218 + R218, '-'))
  AV224 = cellValue(() => IFERROR(H218 + L218 + N218 + R218, '-'))
  AX224 = cellValue(() => IFERROR(N218 + P218 + T218 + V218, '-'))
  H226 = cellValue(() => IF(H224 === '-', '-', 1 - H224))
  J226 = cellValue(() => IF(J224 === '-', '-', 1 - J224))
  L226 = cellValue(() => IF(L224 === '-', '-', 1 - L224))
  N226 = cellValue(() => IF(N224 === '-', '-', 1 - N224))
  P226 = cellValue(() => IF(P224 === '-', '-', 1 - P224))
  R226 = cellValue(() => IF(R224 === '-', '-', 1 - R224))
  T226 = cellValue(() => IF(T224 === '-', '-', 1 - T224))
  V226 = cellValue(() => IF(V224 === '-', '-', 1 - V224))
  X226 = cellValue(() => IF(X224 === '-', '-', 1 - X224))
  Z226 = cellValue(() => IF(Z224 === '-', '-', 1 - Z224))
  AB226 = cellValue(() => IF(AB224 === '-', '-', 1 - AB224))
  AD226 = cellValue(() => IF(AD224 === '-', '-', 1 - AD224))
  AF226 = cellValue(() => IF(AF224 === '-', '-', 1 - AF224))
  AH226 = cellValue(() => IF(AH224 === '-', '-', 1 - AH224))
  AJ226 = cellValue(() => IF(AJ224 === '-', '-', 1 - AJ224))
  AL226 = cellValue(() => IF(AL224 === '-', '-', 1 - AL224))
  AN226 = cellValue(() => IF(AN224 === '-', '-', 1 - AN224))
  AP226 = cellValue(() => IF(AP224 === '-', '-', 1 - AP224))
  AR226 = cellValue(() => IF(AR224 === '-', '-', 1 - AR224))
  AT226 = cellValue(() => IF(AT224 === '-', '-', 1 - AT224))
  AV226 = cellValue(() => IF(AV224 === '-', '-', 1 - AV224))
  AX226 = cellValue(() => IF(AX224 === '-', '-', 1 - AX224))
  H230 = cellValue(() => IFERROR(P218 + R218 + V218 + X218, '-'))
  J230 = cellValue(() => IFERROR(R218 + N218 + T218 + X218, '-'))
  L230 = cellValue(() => IFERROR(H218 + J218 + T218 + V218, '-'))
  N230 = cellValue(() => IFERROR(J218 + L218 + V218 + X218, '-'))
  P230 = cellValue(() => IFERROR(H218 + L218 + T218 + X218, '-'))
  H232 = cellValue(() => IF(H230 === '-', '-', 1 - H230))
  J232 = cellValue(() => IF(J230 === '-', '-', 1 - J230))
  L232 = cellValue(() => IF(L230 === '-', '-', 1 - L230))
  N232 = cellValue(() => IF(N230 === '-', '-', 1 - N230))
  P232 = cellValue(() => IF(P230 === '-', '-', 1 - P230))
  H238 = cellValue(() => J49)
  J238 = cellValue(() => IFERROR(H49, '-'))
  L238 = cellValue(() => P49)
  H240 = cellValue(() => IF(H238 === '-', '-', 1 - H238))
  J240 = cellValue(() => IF(J238 === '-', '-', 1 - J238))
  L240 = cellValue(() => IF(L238 === '-', '-', 1 - L238))
  H244 = cellValue(() => L49)
  J244 = cellValue(() => J49)
  L244 = cellValue(() => R49)
  H246 = cellValue(() => IF(H244 === '-', '-', 1 - H244))
  J246 = cellValue(() => IF(J244 === '-', '-', 1 - J244))
  L246 = cellValue(() => IF(L244 === '-', '-', 1 - L244))
  H252 = cellValue(() => IFERROR(B16 * J94, '-'))
  J252 = cellValue(() => IFERROR(B16 * L130, '-'))
  L252 = cellValue(() => IFERROR(B16 * AH12, '-'))
  N252 = cellValue(() => IFERROR(B16 * AV57, '-'))
  P252 = cellValue(() => IFERROR(B16 * AX57, '-'))
  R252 = cellValue(() => IFERROR(B16 * H87, '-'))
  T252 = cellValue(() => IFERROR(B16 * J87, '-'))
  V252 = cellValue(() => IFERROR(B16 * H94, '-'))
  X252 = cellValue(() => IFERROR(B16 * J93, '-'))
  Z252 = cellValue(() => IFERROR(B16 * H87 * H94, '-'))
  AD252 = cellValue(() => IFERROR(B16 * AF12, '-'))
  AF252 = cellValue(() => IFERROR(B16 * AD57, '-'))
  AH252 = cellValue(() => IFERROR(B16 * AL57, '-'))
  AJ252 = cellValue(() => IFERROR(B16 * L57, '-'))
  AL252 = cellValue(() => IFERROR(B16 * X57, '-'))
  AN252 = cellValue(() => IFERROR(B16 * AH57, '-'))
  AP252 = cellValue(() => IFERROR(B16 * AP57, '-'))
  AR252 = cellValue(() => IFERROR(B16 * N57, '-'))
  AT252 = cellValue(() => IFERROR(B16 * Z57, '-'))
  AV252 = cellValue(() => IFERROR(B16 * AJ57, '-'))
  AX252 = cellValue(() => IFERROR(B16 * X87, '-'))
  H254 = cellValue(() => IF(H252 === '-', '-', 1 - H252))
  J254 = cellValue(() => IF(J252 === '-', '-', 1 - J252))
  L254 = cellValue(() => IF(L252 === '-', '-', 1 - L252))
  N254 = cellValue(() => IF(N252 === '-', '-', 1 - N252))
  P254 = cellValue(() => IF(P252 === '-', '-', 1 - P252))
  R254 = cellValue(() => IF(R252 === '-', '-', 1 - R252))
  T254 = cellValue(() => IF(T252 === '-', '-', 1 - T252))
  V254 = cellValue(() => IF(V252 === '-', '-', 1 - V252))
  X254 = cellValue(() => IF(X252 === '-', '-', 1 - X252))
  Z254 = cellValue(() => IF(Z252 === '-', '-', 1 - Z252))
  AD254 = cellValue(() => IF(AD252 === '-', '-', 1 - AD252))
  AF254 = cellValue(() => IF(AF252 === '-', '-', 1 - AF252))
  AH254 = cellValue(() => IF(AH252 === '-', '-', 1 - AH252))
  AJ254 = cellValue(() => IF(AJ252 === '-', '-', 1 - AJ252))
  AL254 = cellValue(() => IF(AL252 === '-', '-', 1 - AL252))
  AN254 = cellValue(() => IF(AN252 === '-', '-', 1 - AN252))
  AP254 = cellValue(() => IF(AP252 === '-', '-', 1 - AP252))
  AR254 = cellValue(() => IF(AR252 === '-', '-', 1 - AR252))
  AT254 = cellValue(() => IF(AT252 === '-', '-', 1 - AT252))
  AV254 = cellValue(() => IF(AV252 === '-', '-', 1 - AV252))
  AX254 = cellValue(() => IF(AX252 === '-', '-', 1 - AX252))
  H258 = cellValue(() => IFERROR(F16 * J162, '-'))
  J258 = cellValue(() => IFERROR(F16 * L162, '-'))
  L258 = cellValue(() => IFERROR(F16 * AH12, '-'))
  N258 = cellValue(() => IFERROR(F16 * AV57, '-'))
  P258 = cellValue(() => IFERROR(F16 * AX57, '-'))
  R258 = cellValue(() => IFERROR(F16 * H87, '-'))
  T258 = cellValue(() => B16)
  V258 = cellValue(() => IFERROR(B16 * J94, '-'))
  X258 = cellValue(() => IFERROR(F16 * J94, '-'))
  Z258 = cellValue(() => IFERROR(F16 * H87 * H94, '-'))
  AD258 = cellValue(() => IFERROR(F16 * AF12, '-'))
  AF258 = cellValue(() => IFERROR(F16 * AD57, '-'))
  AH258 = cellValue(() => IFERROR(F16 * AL57, '-'))
  AJ258 = cellValue(() => IFERROR(F16 * L57, '-'))
  AL258 = cellValue(() => IFERROR(F16 * X57, '-'))
  AN258 = cellValue(() => IFERROR(F16 * AH57, '-'))
  AP258 = cellValue(() => IFERROR(F16 * AP57, '-'))
  AR258 = cellValue(() => IFERROR(F16 * N57, '-'))
  AT258 = cellValue(() => IFERROR(F16 * Z57, '-'))
  AV258 = cellValue(() => IFERROR(F16 * AJ57, '-'))
  AX258 = cellValue(() => IFERROR(F16 * X94, '-'))
  H260 = cellValue(() => IF(H258 === '-', '-', 1 - H258))
  J260 = cellValue(() => IF(J258 === '-', '-', 1 - J258))
  L260 = cellValue(() => IF(L258 === '-', '-', 1 - L258))
  N260 = cellValue(() => IF(N258 === '-', '-', 1 - N258))
  P260 = cellValue(() => IF(P258 === '-', '-', 1 - P258))
  R260 = cellValue(() => IF(R258 === '-', '-', 1 - R258))
  T260 = cellValue(() => IF(T258 === '-', '-', 1 - T258))
  V260 = cellValue(() => IF(V258 === '-', '-', 1 - V258))
  X260 = cellValue(() => IF(X258 === '-', '-', 1 - X258))
  Z260 = cellValue(() => IF(Z258 === '-', '-', 1 - Z258))
  AD260 = cellValue(() => IF(AD258 === '-', '-', 1 - AD258))
  AF260 = cellValue(() => IF(AF258 === '-', '-', 1 - AF258))
  AH260 = cellValue(() => IF(AH258 === '-', '-', 1 - AH258))
  AJ260 = cellValue(() => IF(AJ258 === '-', '-', 1 - AJ258))
  AL260 = cellValue(() => IF(AL258 === '-', '-', 1 - AL258))
  AN260 = cellValue(() => IF(AN258 === '-', '-', 1 - AN258))
  AP260 = cellValue(() => IF(AP258 === '-', '-', 1 - AP258))
  AR260 = cellValue(() => IF(AR258 === '-', '-', 1 - AR258))
  AT260 = cellValue(() => IF(AT258 === '-', '-', 1 - AT258))
  AV260 = cellValue(() => IF(AV258 === '-', '-', 1 - AV258))
  AX260 = cellValue(() => IF(AX258 === '-', '-', 1 - AX258))
  H264 = cellValue(() => IFERROR(D16 * X87, '-'))
  J264 = cellValue(() => IFERROR(D16 * AR57, '-'))
  N264 = cellValue(() => IFERROR(D16 * AH12, '-'))
  P264 = cellValue(() => IFERROR(D16 * AF12, '-'))
  R264 = cellValue(() => IFERROR(B16 * H210, '-'))
  T264 = cellValue(() => IFERROR(B16 * J210, '-'))
  V264 = cellValue(() => IFERROR(B16 * L210, '-'))
  X264 = cellValue(() => IFERROR(F16 * H210, '-'))
  Z264 = cellValue(() => IFERROR(F16 * J210, '-'))
  AB264 = cellValue(() => IFERROR(F16 * L210, '-'))
  H266 = cellValue(() => IF(H264 === '-', '-', 1 - H264))
  J266 = cellValue(() => IF(J264 === '-', '-', 1 - J264))
  N266 = cellValue(() => IF(N264 === '-', '-', 1 - N264))
  P266 = cellValue(() => IF(P264 === '-', '-', 1 - P264))
  R266 = cellValue(() => IF(R264 === '-', '-', 1 - R264))
  T266 = cellValue(() => IF(T264 === '-', '-', 1 - T264))
  V266 = cellValue(() => IF(V264 === '-', '-', 1 - V264))
  X266 = cellValue(() => IF(X264 === '-', '-', 1 - X264))
  Z266 = cellValue(() => IF(Z264 === '-', '-', 1 - Z264))
  AB266 = cellValue(() => IF(AB264 === '-', '-', 1 - AB264))
  H270 = cellValue(() => IFERROR(H25 * V16, '-'))
  J270 = cellValue(() => IFERROR(D16 * V16, '-'))
  L270 = cellValue(() => IFERROR(F16 * V16, '-'))
  H272 = cellValue(() => IF(H270 === '-', '-', 1 - H270))
  J272 = cellValue(() => IF(J270 === '-', '-', 1 - J270))
  L272 = cellValue(() => IF(L270 === '-', '-', 1 - L270))
  H276 = cellValue(() => IFERROR(H31 * AR57, '-'))
  J276 = cellValue(() => IFERROR(H31 * AH12, '-'))
  L276 = cellValue(() => IFERROR(H31 * AV57, '-'))
  N276 = cellValue(() => IFERROR(H31 * AF12, '-'))
  P276 = cellValue(() => IFERROR(H31 * AD57, '-'))
  R276 = cellValue(() => IFERROR(H31 * L57, '-'))
  T276 = cellValue(() => IFERROR(H31 * P87, '-'))
  V276 = cellValue(() => IFERROR(H31 * J87, '-'))
  X276 = cellValue(() => IFERROR(H31 * J130, '-'))
  Z276 = cellValue(() => IFERROR(H31 * J57, '-'))
  AB276 = cellValue(() => IFERROR(H31 * V57, '-'))
  AD276 = cellValue(() => IFERROR(H31 * X57, '-'))
  AF276 = cellValue(() => IFERROR(H31 * AH57, '-'))
  AH276 = cellValue(() => IFERROR(H31 * Z57, '-'))
  AJ276 = cellValue(() => IFERROR(H31 * AJ57, '-'))
  AL276 = cellValue(() => IFERROR(H31 * AB57, '-'))
  AN276 = cellValue(() => IFERROR(H31 * AB57, '-'))
  AP276 = cellValue(() => IFERROR(L31 * AR57, '-'))
  AR276 = cellValue(() => IFERROR(L31 * AV57, '-'))
  AS276 = cellValue(() => IFERROR(L31 * H57, '-'))
  AT276 = cellValue(() => IFERROR(L31 * AF12, '-'))
  AV276 = cellValue(() => IFERROR(L31 * AD57, '-'))
  AX276 = cellValue(() => IFERROR(L31 * L57, '-'))
  H278 = cellValue(() => IF(H276 === '-', '-', 1 - H276))
  J278 = cellValue(() => IF(J276 === '-', '-', 1 - J276))
  L278 = cellValue(() => IF(L276 === '-', '-', 1 - L276))
  N278 = cellValue(() => IF(N276 === '-', '-', 1 - N276))
  P278 = cellValue(() => IF(P276 === '-', '-', 1 - P276))
  R278 = cellValue(() => IF(R276 === '-', '-', 1 - R276))
  T278 = cellValue(() => IF(T276 === '-', '-', 1 - T276))
  V278 = cellValue(() => IF(V276 === '-', '-', 1 - V276))
  X278 = cellValue(() => IF(X276 === '-', '-', 1 - X276))
  Z278 = cellValue(() => IF(Z276 === '-', '-', 1 - Z276))
  AB278 = cellValue(() => IF(AB276 === '-', '-', 1 - AB276))
  AD278 = cellValue(() => IF(AD276 === '-', '-', 1 - AD276))
  AF278 = cellValue(() => IF(AF276 === '-', '-', 1 - AF276))
  AH278 = cellValue(() => IF(AH276 === '-', '-', 1 - AH276))
  AJ278 = cellValue(() => IF(AJ276 === '-', '-', 1 - AJ276))
  AL278 = cellValue(() => IF(AL276 === '-', '-', 1 - AL276))
  AN278 = cellValue(() => IF(AN276 === '-', '-', 1 - AN276))
  AP278 = cellValue(() => IF(AP276 === '-', '-', 1 - AP276))
  AR278 = cellValue(() => IF(AR276 === '-', '-', 1 - AR276))
  AT278 = cellValue(() => IF(AT276 === '-', '-', 1 - AT276))
  AV278 = cellValue(() => IF(AV276 === '-', '-', 1 - AV276))
  AX278 = cellValue(() => IF(AX276 === '-', '-', 1 - AX276))
  H282 = cellValue(() => IFERROR(L31 * AD57, '-'))
  J282 = cellValue(() => IFERROR(L31 * L57, '-'))
  L282 = cellValue(() => IFERROR(L31 * P87, '-'))
  P282 = cellValue(() => L31)
  R282 = cellValue(() => IFERROR(L31 * J162, '-'))
  T282 = cellValue(() => IFERROR(L31 * J57, '-'))
  V282 = cellValue(() => IFERROR(L31 * V57, '-'))
  X282 = cellValue(() => IFERROR(L31 * X57, '-'))
  Z282 = cellValue(() => IFERROR(L31 * V57, '-'))
  AB282 = cellValue(() => IFERROR(L31 * X57, '-'))
  AD282 = cellValue(() => IFERROR(L31 * AH57, '-'))
  AF282 = cellValue(() => IFERROR(L31 * Z57, '-'))
  AH282 = cellValue(() => IFERROR(L31 * AJ57, '-'))
  AJ282 = cellValue(() => IFERROR(L31 * AB57, '-'))
  AL282 = cellValue(() => IFERROR(J31 * AR57, '-'))
  AN282 = cellValue(() => IFERROR(J31 * AH12, '-'))
  AP282 = cellValue(() => IFERROR(J31 * AF12, '-'))
  AR282 = cellValue(() => IFERROR(J31 * AD57, '-'))
  AT282 = cellValue(() => IFERROR(J31 * L57, '-'))
  AV282 = cellValue(() => IFERROR(H31 * V16, '-'))
  AX282 = cellValue(() => IFERROR(J31 * V16, '-'))
  H284 = cellValue(() => IF(H282 === '-', '-', 1 - H282))
  J284 = cellValue(() => IF(J282 === '-', '-', 1 - J282))
  L284 = cellValue(() => IF(L282 === '-', '-', 1 - L282))
  P284 = cellValue(() => IF(P282 === '-', '-', 1 - P282))
  R284 = cellValue(() => IF(R282 === '-', '-', 1 - R282))
  T284 = cellValue(() => IF(T282 === '-', '-', 1 - T282))
  V284 = cellValue(() => IF(V282 === '-', '-', 1 - V282))
  X284 = cellValue(() => IF(X282 === '-', '-', 1 - X282))
  Z284 = cellValue(() => IF(Z282 === '-', '-', 1 - Z282))
  AB284 = cellValue(() => IF(AB282 === '-', '-', 1 - AB282))
  AD284 = cellValue(() => IF(AD282 === '-', '-', 1 - AD282))
  AF284 = cellValue(() => IF(AF282 === '-', '-', 1 - AF282))
  AH284 = cellValue(() => IF(AH282 === '-', '-', 1 - AH282))
  AJ284 = cellValue(() => IF(AJ282 === '-', '-', 1 - AJ282))
  AL284 = cellValue(() => IF(AL282 === '-', '-', 1 - AL282))
  AN284 = cellValue(() => IF(AN282 === '-', '-', 1 - AN282))
  AP284 = cellValue(() => IF(AP282 === '-', '-', 1 - AP282))
  AR284 = cellValue(() => IF(AR282 === '-', '-', 1 - AR282))
  AT284 = cellValue(() => IF(AT282 === '-', '-', 1 - AT282))
  AV284 = cellValue(() => IF(AV282 === '-', '-', 1 - AV282))
  AX284 = cellValue(() => IF(AX282 === '-', '-', 1 - AX282))
  H288 = cellValue(() => IFERROR(L31 * V16, '-'))
  J288 = cellValue(() => IFERROR(H31 * H210, '-'))
  L288 = cellValue(() => IFERROR(H31 * J210, '-'))
  N288 = cellValue(() => IFERROR(H31 * L210, '-'))
  P288 = cellValue(() => IFERROR(L31 * H210, '-'))
  R288 = cellValue(() => IFERROR(L31 * J210, '-'))
  T288 = cellValue(() => IFERROR(L31 * L210, '-'))
  V288 = cellValue(() => IFERROR(L31 * H210, '-'))
  X288 = cellValue(() => IFERROR(L31 * J210, '-'))
  Z288 = cellValue(() => IFERROR(L31 * L210, '-'))
  AB288 = cellValue(() => IFERROR(J31 * H210, '-'))
  AD288 = cellValue(() => IFERROR(J31 * J210, '-'))
  AF288 = cellValue(() => IFERROR(J31 * L210, '-'))
  H290 = cellValue(() => IF(H288 === '-', '-', 1 - H288))
  J290 = cellValue(() => IF(J288 === '-', '-', 1 - J288))
  L290 = cellValue(() => IF(L288 === '-', '-', 1 - L288))
  N290 = cellValue(() => IF(N288 === '-', '-', 1 - N288))
  P290 = cellValue(() => IF(P288 === '-', '-', 1 - P288))
  R290 = cellValue(() => IF(R288 === '-', '-', 1 - R288))
  T290 = cellValue(() => IF(T288 === '-', '-', 1 - T288))
  V290 = cellValue(() => IF(V288 === '-', '-', 1 - V288))
  X290 = cellValue(() => IF(X288 === '-', '-', 1 - X288))
  Z290 = cellValue(() => IF(Z288 === '-', '-', 1 - Z288))
  AB290 = cellValue(() => IF(AB288 === '-', '-', 1 - AB288))
  AD290 = cellValue(() => IF(AD288 === '-', '-', 1 - AD288))
  AF290 = cellValue(() => IF(AF288 === '-', '-', 1 - AF288))
  H294 = cellValue(() => IFERROR((B16 + AH12) / 2, '-'))
  J294 = cellValue(() => IFERROR((B16 + AV57) / 2, '-'))
  L294 = cellValue(() => IFERROR((B16 + V16) / 2, '-'))
  N294 = cellValue(() => IFERROR((F16 + AH12) / 2, '-'))
  P294 = cellValue(() => IFERROR((F16 + AV57) / 2, '-'))
  R294 = cellValue(() => IFERROR((F16 + V16) / 2, '-'))
  T294 = cellValue(() => IFERROR((N130 + N162) / 2, '-'))
  V294 = cellValue(() => IFERROR((B16 + J87) / 2, '-'))
  X294 = cellValue(() => IFERROR((F16 + J94) / 2, '-'))
  Z294 = cellValue(() => IFERROR((H218 + N218) / 2, '-'))
  AB294 = cellValue(() => IFERROR((H218 + P218) / 2, '-'))
  AD294 = cellValue(() => IFERROR((H218 + X218) / 2, '-'))
  AF294 = cellValue(() => IFERROR((J87 + J94) / 2, '-'))
  AJ294 = cellValue(() => IFERROR((L69 + R69) / 2, '-'))
  AL294 = cellValue(() => IFERROR((N69 + P69) / 2, '-'))
  AN294 = cellValue(() => IFERROR((L69 + P69) / 2, '-'))
  H296 = cellValue(() => IF(H294 === '-', '-', 1 - H294))
  J296 = cellValue(() => IF(J294 === '-', '-', 1 - J294))
  L296 = cellValue(() => IF(L294 === '-', '-', 1 - L294))
  N296 = cellValue(() => IF(N294 === '-', '-', 1 - N294))
  P296 = cellValue(() => IF(P294 === '-', '-', 1 - P294))
  R296 = cellValue(() => IF(R294 === '-', '-', 1 - R294))
  T296 = cellValue(() => IF(T294 === '-', '-', 1 - T294))
  V296 = cellValue(() => IF(V294 === '-', '-', 1 - V294))
  X296 = cellValue(() => IF(X294 === '-', '-', 1 - X294))
  Z296 = cellValue(() => IF(Z294 === '-', '-', 1 - Z294))
  AB296 = cellValue(() => IF(AB294 === '-', '-', 1 - AB294))
  AD296 = cellValue(() => IF(AD294 === '-', '-', 1 - AD294))
  AF296 = cellValue(() => IF(AF294 === '-', '-', 1 - AF294))
  AJ296 = cellValue(() => IF(AJ294 === '-', '-', 1 - AJ294))
  AL296 = cellValue(() => IF(AL294 === '-', '-', 1 - AL294))
  AN296 = cellValue(() => IF(AN294 === '-', '-', 1 - AN294))
  H300 = cellValue(() => IFERROR(Z25 * L69, '-'))
  J300 = cellValue(() => IFERROR(AB25 * L69, '-'))
  L300 = cellValue(() => IFERROR(AD25 * L69, '-'))
  N300 = cellValue(() => IFERROR(Z25 * N69, '-'))
  P300 = cellValue(() => IFERROR(Z25 * N69, '-'))
  R300 = cellValue(() => IFERROR(AD25 * N69, '-'))
  T300 = cellValue(() => IFERROR(AR25 * P69, '-'))
  X300 = cellValue(() => IFERROR(AT25 * P69, '-'))
  Z300 = cellValue(() => IFERROR(AV25 * P69, '-'))
  AB300 = cellValue(() => IFERROR(AR25 * R69, '-'))
  AD300 = cellValue(() => IFERROR(AT25 * R69, '-'))
  AF300 = cellValue(() => IFERROR(AV25 * R69, '-'))
  AH300 = cellValue(() => IFERROR(L69 * R69, '-'))
  AJ300 = cellValue(() => IFERROR(N69 * R69, '-'))
  AN300 = cellValue(() => IFERROR(L69 * P69, '-'))
  AP300 = cellValue(() => IFERROR(H69 * L87, '-'))
  AR300 = cellValue(() => IFERROR(H69 * L94, '-'))
  AT300 = cellValue(() => IFERROR(P69 * L93, '-'))
  AV300 = cellValue(() => IFERROR(P69 * L87, '-'))
  H302 = cellValue(() => IF(H300 === '-', '-', 1 - H300))
  J302 = cellValue(() => IF(J300 === '-', '-', 1 - J300))
  L302 = cellValue(() => IF(L300 === '-', '-', 1 - L300))
  N302 = cellValue(() => IF(N300 === '-', '-', 1 - N300))
  P302 = cellValue(() => IF(P300 === '-', '-', 1 - P300))
  R302 = cellValue(() => IF(R300 === '-', '-', 1 - R300))
  T302 = cellValue(() => IF(T300 === '-', '-', 1 - T300))
  X302 = cellValue(() => IF(X300 === '-', '-', 1 - X300))
  Z302 = cellValue(() => IF(Z300 === '-', '-', 1 - Z300))
  AB302 = cellValue(() => IF(AB300 === '-', '-', 1 - AB300))
  AD302 = cellValue(() => IF(AD300 === '-', '-', 1 - AD300))
  AF302 = cellValue(() => IF(AF300 === '-', '-', 1 - AF300))
  AH302 = cellValue(() => IF(AH300 === '-', '-', 1 - AH300))
  AJ302 = cellValue(() => IF(AJ300 === '-', '-', 1 - AJ300))
  AN302 = cellValue(() => IF(AN300 === '-', '-', 1 - AN300))
  AP302 = cellValue(() => IF(AP300 === '-', '-', 1 - AP300))
  AR302 = cellValue(() => IF(AR300 === '-', '-', 1 - AR300))
  AT302 = cellValue(() => IF(AT300 === '-', '-', 1 - AT300))
  AV302 = cellValue(() => IF(AV300 === '-', '-', 1 - AV300))
  H306 = cellValue(() => IFERROR(H218 * H69, '-'))
  J306 = cellValue(() => IFERROR(H218 * J69, '-'))
  L306 = cellValue(() => IFERROR(H218 * AR57, '-'))
  N306 = cellValue(() => IFERROR(H218 * AH12, '-'))
  P306 = cellValue(() => IFERROR(H218 * AV57, '-'))
  R306 = cellValue(() => IFERROR(H218 * J87, '-'))
  T306 = cellValue(() => IFERROR(H218 * J94, '-'))
  V306 = cellValue(() => IFERROR(H218 * T57, '-'))
  X306 = cellValue(() => IFERROR(H218 * AD57, '-'))
  Z306 = cellValue(() => IFERROR(H218 * L57, '-'))
  AB306 = cellValue(() => IFERROR(H218 * X57, '-'))
  AD306 = cellValue(() => IFERROR(H218 * AH57, '-'))
  AF306 = cellValue(() => IFERROR(H218 * N57, '-'))
  AH306 = cellValue(() => IFERROR(H218 * Z57, '-'))
  AJ306 = cellValue(() => IFERROR(H218 * AJ57, '-'))
  AL306 = cellValue(() => IFERROR(H218 * H238, '-'))
  AN306 = cellValue(() => IFERROR(X218 * H69, '-'))
  AP306 = cellValue(() => IFERROR(X218 * J69, '-'))
  AR306 = cellValue(() => IFERROR(X218 * AR57, '-'))
  AT306 = cellValue(() => IFERROR(X218 * AH12, '-'))
  AV306 = cellValue(() => IFERROR(X218 * AV57, '-'))
  AX306 = cellValue(() => IFERROR(X218 * J87, '-'))
  H308 = cellValue(() => IF(H306 === '-', '-', 1 - H306))
  J308 = cellValue(() => IF(J306 === '-', '-', 1 - J306))
  L308 = cellValue(() => IF(L306 === '-', '-', 1 - L306))
  N308 = cellValue(() => IF(N306 === '-', '-', 1 - N306))
  P308 = cellValue(() => IF(P306 === '-', '-', 1 - P306))
  R308 = cellValue(() => IF(R306 === '-', '-', 1 - R306))
  T308 = cellValue(() => IF(T306 === '-', '-', 1 - T306))
  V308 = cellValue(() => IF(V306 === '-', '-', 1 - V306))
  X308 = cellValue(() => IF(X306 === '-', '-', 1 - X306))
  Z308 = cellValue(() => IF(Z306 === '-', '-', 1 - Z306))
  AB308 = cellValue(() => IF(AB306 === '-', '-', 1 - AB306))
  AD308 = cellValue(() => IF(AD306 === '-', '-', 1 - AD306))
  AF308 = cellValue(() => IF(AF306 === '-', '-', 1 - AF306))
  AH308 = cellValue(() => IF(AH306 === '-', '-', 1 - AH306))
  AJ308 = cellValue(() => IF(AJ306 === '-', '-', 1 - AJ306))
  AL308 = cellValue(() => IF(AL306 === '-', '-', 1 - AL306))
  AN308 = cellValue(() => IF(AN306 === '-', '-', 1 - AN306))
  AP308 = cellValue(() => IF(AP306 === '-', '-', 1 - AP306))
  AR308 = cellValue(() => IF(AR306 === '-', '-', 1 - AR306))
  AT308 = cellValue(() => IF(AT306 === '-', '-', 1 - AT306))
  AV308 = cellValue(() => IF(AV306 === '-', '-', 1 - AV306))
  AX308 = cellValue(() => IF(AX306 === '-', '-', 1 - AX306))
  H312 = cellValue(() => IFERROR(X218 * J94, '-'))
  J312 = cellValue(() => IFERROR(X218 * AF12, '-'))
  L312 = cellValue(() => IFERROR(X218 * AD57, '-'))
  N312 = cellValue(() => IFERROR(X218 * L57, '-'))
  P312 = cellValue(() => IFERROR(X218 * X57, '-'))
  R312 = cellValue(() => IFERROR(X218 * AH57, '-'))
  T312 = cellValue(() => IFERROR(X218 * N57, '-'))
  V312 = cellValue(() => IFERROR(X218 * Z57, '-'))
  X312 = cellValue(() => IFERROR(X218 * AJ57, '-'))
  Z312 = cellValue(() => IFERROR(X218 * L244, '-'))
  AB312 = cellValue(() => IFERROR(N218 * V16, '-'))
  AD312 = cellValue(() => IFERROR(N218 * J69, '-'))
  AF312 = cellValue(() => IFERROR(N218 * AR57, '-'))
  AH312 = cellValue(() => IFERROR(N218 * AH12, '-'))
  AJ312 = cellValue(() => IFERROR(N218 * AV57, '-'))
  AL312 = cellValue(() => IFERROR(N218 * J87, '-'))
  AN312 = cellValue(() => IFERROR(N218 * J94, '-'))
  AP312 = cellValue(() => IFERROR(N218 * H57, '-'))
  AR312 = cellValue(() => IFERROR(N218 * T57, '-'))
  AT312 = cellValue(() => IFERROR(N218 * AD57, '-'))
  AV312 = cellValue(() => IFERROR(N218 * L57, '-'))
  AX312 = cellValue(() => IFERROR(N218 * X57, '-'))
  H314 = cellValue(() => IF(H312 === '-', '-', 1 - H312))
  J314 = cellValue(() => IF(J312 === '-', '-', 1 - J312))
  L314 = cellValue(() => IF(L312 === '-', '-', 1 - L312))
  N314 = cellValue(() => IF(N312 === '-', '-', 1 - N312))
  P314 = cellValue(() => IF(P312 === '-', '-', 1 - P312))
  R314 = cellValue(() => IF(R312 === '-', '-', 1 - R312))
  T314 = cellValue(() => IF(T312 === '-', '-', 1 - T312))
  V314 = cellValue(() => IF(V312 === '-', '-', 1 - V312))
  X314 = cellValue(() => IF(X312 === '-', '-', 1 - X312))
  Z314 = cellValue(() => IF(Z312 === '-', '-', 1 - Z312))
  AB314 = cellValue(() => IF(AB312 === '-', '-', 1 - AB312))
  AD314 = cellValue(() => IF(AD312 === '-', '-', 1 - AD312))
  AF314 = cellValue(() => IF(AF312 === '-', '-', 1 - AF312))
  AH314 = cellValue(() => IF(AH312 === '-', '-', 1 - AH312))
  AJ314 = cellValue(() => IF(AJ312 === '-', '-', 1 - AJ312))
  AL314 = cellValue(() => IF(AL312 === '-', '-', 1 - AL312))
  AN314 = cellValue(() => IF(AN312 === '-', '-', 1 - AN312))
  AP314 = cellValue(() => IF(AP312 === '-', '-', 1 - AP312))
  AR314 = cellValue(() => IF(AR312 === '-', '-', 1 - AR312))
  AT314 = cellValue(() => IF(AT312 === '-', '-', 1 - AT312))
  AV314 = cellValue(() => IF(AV312 === '-', '-', 1 - AV312))
  AX314 = cellValue(() => IF(AX312 === '-', '-', 1 - AX312))
  H318 = cellValue(() => IFERROR(N218 * AH57, '-'))
  J318 = cellValue(() => IFERROR(N218 * N57, '-'))
  L318 = cellValue(() => IFERROR(N218 * Z57, '-'))
  N318 = cellValue(() => IFERROR(N218 * AJ57, '-'))
  P318 = cellValue(() => IFERROR(N218 * H238, '-'))
  R318 = cellValue(() => IFERROR(R218 * H69, '-'))
  T318 = cellValue(() => IFERROR(R218 * J69, '-'))
  V318 = cellValue(() => IFERROR(R218 * J162, '-'))
  X318 = cellValue(() => IFERROR(R218 * AH12, '-'))
  Z318 = cellValue(() => IFERROR(R218 * AV57, '-'))
  AB318 = cellValue(() => IFERROR(R218 * J87, '-'))
  AD318 = cellValue(() => IFERROR(R218 * J94, '-'))
  AH318 = cellValue(() => IFERROR(R218 * H57, '-'))
  AJ318 = cellValue(() => IFERROR(R218 * T57, '-'))
  AL318 = cellValue(() => IFERROR(P218 * AD57, '-'))
  AN318 = cellValue(() => IFERROR(R218 * L57, '-'))
  AP318 = cellValue(() => IFERROR(R218 * X57, '-'))
  AR318 = cellValue(() => IFERROR(R218 * AH57, '-'))
  AT318 = cellValue(() => IFERROR(R218 * N57, '-'))
  AV318 = cellValue(() => IFERROR(P218 * Z57, '-'))
  AX318 = cellValue(() => IFERROR(R218 * AJ57, '-'))
  H320 = cellValue(() => IF(H318 === '-', '-', 1 - H318))
  J320 = cellValue(() => IF(J318 === '-', '-', 1 - J318))
  L320 = cellValue(() => IF(L318 === '-', '-', 1 - L318))
  N320 = cellValue(() => IF(N318 === '-', '-', 1 - N318))
  P320 = cellValue(() => IF(P318 === '-', '-', 1 - P318))
  R320 = cellValue(() => IF(R318 === '-', '-', 1 - R318))
  T320 = cellValue(() => IF(T318 === '-', '-', 1 - T318))
  V320 = cellValue(() => IF(V318 === '-', '-', 1 - V318))
  X320 = cellValue(() => IF(X318 === '-', '-', 1 - X318))
  Z320 = cellValue(() => IF(Z318 === '-', '-', 1 - Z318))
  AB320 = cellValue(() => IF(AB318 === '-', '-', 1 - AB318))
  AH320 = cellValue(() => IF(AH318 === '-', '-', 1 - AH318))
  AJ320 = cellValue(() => IF(AJ318 === '-', '-', 1 - AJ318))
  AL320 = cellValue(() => IF(AL318 === '-', '-', 1 - AL318))
  AN320 = cellValue(() => IF(AN318 === '-', '-', 1 - AN318))
  AP320 = cellValue(() => IF(AP318 === '-', '-', 1 - AP318))
  AR320 = cellValue(() => IF(AR318 === '-', '-', 1 - AR318))
  AT320 = cellValue(() => IF(AT318 === '-', '-', 1 - AT318))
  AV320 = cellValue(() => IF(AV318 === '-', '-', 1 - AV318))
  AX320 = cellValue(() => IF(AX318 === '-', '-', 1 - AX318))
  H324 = cellValue(() => IFERROR(R218 * L244, '-'))
  J324 = cellValue(() => IFERROR(P218 * J162, '-'))
  L324 = cellValue(() => IFERROR(P218 * AH12, '-'))
  N324 = cellValue(() => IFERROR(P218 * AF12, '-'))
  P324 = cellValue(() => IFERROR(L218 * AX57, '-'))
  R324 = cellValue(() => IFERROR(T218 * AX57, '-'))
  H326 = cellValue(() => IF(H324 === '-', '-', 1 - H324))
  J326 = cellValue(() => IF(J324 === '-', '-', 1 - J324))
  L326 = cellValue(() => IF(L324 === '-', '-', 1 - L324))
  N326 = cellValue(() => IF(N324 === '-', '-', 1 - N324))
  P326 = cellValue(() => IF(P324 === '-', '-', 1 - P324))
  R326 = cellValue(() => IF(R324 === '-', '-', 1 - R324))
  H332 = cellValue(() => N63)
  N332 = cellValue(() => IFERROR(X130 * X162, '-'))
  AB332 = cellValue(() => IFERROR(Z130 * Z162, '-'))
  AT332 = cellValue(() => IFERROR(AX130 * V162, '-'))
  AX332 = cellValue(() => IFERROR(AB130 * AB162, '-'))
  H334 = cellValue(() => IF(H332 === '-', '-', 1 - H332))
  J334 = cellValue(() => IF(J332 === '-', '-', 1 - J332))
  L334 = cellValue(() => IF(L332 === '-', '-', 1 - L332))
  N334 = cellValue(() => IF(N332 === '-', '-', 1 - N332))
  P334 = cellValue(() => IF(P332 === '-', '-', 1 - P332))
  R334 = cellValue(() => IF(R332 === '-', '-', 1 - R332))
  T334 = cellValue(() => IF(T332 === '-', '-', 1 - T332))
  V334 = cellValue(() => IF(V332 === '-', '-', 1 - V332))
  X334 = cellValue(() => IF(X332 === '-', '-', 1 - X332))
  Z334 = cellValue(() => IF(Z332 === '-', '-', 1 - Z332))
  AB334 = cellValue(() => IF(AB332 === '-', '-', 1 - AB332))
  AD334 = cellValue(() => IF(AD332 === '-', '-', 1 - AD332))
  AF334 = cellValue(() => IF(AF332 === '-', '-', 1 - AF332))
  AH334 = cellValue(() => IF(AH332 === '-', '-', 1 - AH332))
  AJ334 = cellValue(() => IF(AJ332 === '-', '-', 1 - AJ332))
  AL334 = cellValue(() => IF(AL332 === '-', '-', 1 - AL332))
  AN334 = cellValue(() => IF(AN332 === '-', '-', 1 - AN332))
  AP334 = cellValue(() => IF(AP332 === '-', '-', 1 - AP332))
  AR334 = cellValue(() => IF(AR332 === '-', '-', 1 - AR332))
  AT334 = cellValue(() => IF(AT332 === '-', '-', 1 - AT332))
  AV334 = cellValue(() => IF(AV332 === '-', '-', 1 - AV332))
  AX334 = cellValue(() => IF(AX332 === '-', '-', 1 - AX332))
  AH336 = cellValue(() => IFERROR(AH332 + AJ332, '-'))
  AJ336 = cellValue(() => AH336)
  AL336 = cellValue(() => IFERROR(AL332 + AN332, '-'))
  AN336 = cellValue(() => AL336)
  AP336 = cellValue(() => IFERROR(AP332 + AR332, '-'))
  AR336 = cellValue(() => AP336)
  AH337 = cellValue(() => IFERROR(CE7, '-'))
  AJ337 = cellValue(() => AH337)
  AL337 = cellValue(() => AH337)
  AN337 = cellValue(() => AJ337)
  AP337 = cellValue(() => AH337)
  AR337 = cellValue(() => AJ337)
  T338 = cellValue(() =>
    IFERROR(
      100 / 100 -
        SUM(
          [H338, I338, J338, K338, L338, M338, N338, O338, P338, Q338, R338],
          [
            H332,
            I332,
            J332,
            K332,
            L332,
            M332,
            N332,
            O332,
            P332,
            Q332,
            R332,
            S332,
            T332,
            U332,
            V332,
            W332,
            X332,
            Y332,
            Z332,
            AA332,
            AB332,
            AC332,
            AD332,
            AE332,
            AF332,
            AG332,
            AH332,
            AI332,
            AJ332,
            AK332,
            AL332,
            AM332,
            AN332,
            AO332,
            AP332,
            AQ332,
            AR332,
            AS332,
            AT332,
            AU332,
            AV332,
            AW332,
            AX332,
          ]
        ),
      '-'
    )
  )
  AH338 = cellValue(() => IFERROR(1 - AH337, '-'))
  AJ338 = cellValue(() => AH338)
  AL338 = cellValue(() => 1 - AL337)
  AN338 = cellValue(() => AL338)
  AP338 = cellValue(() => 1 - AP337)
  AR338 = cellValue(() => AP338)
  AH339 = cellValue(() => IFERROR(AH336 * AH337, '-'))
  AJ339 = cellValue(() => IFERROR(AJ336 * AJ338, '-'))
  AL339 = cellValue(() => IFERROR(AL336 * AL337, '-'))
  AN339 = cellValue(() => IFERROR(AN336 * AN338, '-'))
  AP339 = cellValue(() => IFERROR(AP336 * AP337, '-'))
  AR339 = cellValue(() => IFERROR(AR336 * AR338, '-'))
  H340 = cellValue(() => IF(H338 === '-', '-', 1 - H338))
  J340 = cellValue(() => IF(J338 === '-', '-', 1 - J338))
  L340 = cellValue(() => IF(L338 === '-', '-', 1 - L338))
  N340 = cellValue(() => IF(N338 === '-', '-', 1 - N338))
  P340 = cellValue(() => IF(P338 === '-', '-', 1 - P338))
  R340 = cellValue(() => IF(R338 === '-', '-', 1 - R338))
  T340 = cellValue(() => IF(T338 === '-', '-', 1 - T338))
  AH340 = cellValue(() => IFERROR(1 - AH339, '-'))
  AJ340 = cellValue(() => IFERROR(1 - AJ339, '-'))
  AL340 = cellValue(() => IFERROR(1 - AL339, '-'))
  AN340 = cellValue(() => IFERROR(1 - AN339, '-'))
  AP340 = cellValue(() => IFERROR(1 - AP339, '-'))
  AR340 = cellValue(() => IFERROR(1 - AR339, '-'))
  H344 = cellValue(() => IFERROR(P144 * P174, '-'))
  J344 = cellValue(() => IFERROR(R144 * P174, '-'))
  L344 = cellValue(() => IFERROR(P144 * R174, '-'))
  N344 = cellValue(() => IFERROR(R144 * R174, '-'))
  P344 = cellValue(() => IFERROR(T144 * P174, '-'))
  R344 = cellValue(() => IFERROR(P144 * T174, '-'))
  T344 = cellValue(() => IFERROR(T144 * R174, '-'))
  V344 = cellValue(() => IFERROR(X130 * Z162, '-'))
  X344 = cellValue(() => IFERROR(AB130 * P174, '-'))
  Z344 = cellValue(() => IFERROR(P144 * AD174, '-'))
  AB344 = cellValue(() => IFERROR(T144 * T174, '-'))
  AD344 = cellValue(() => IFERROR(AD144 * R174, '-'))
  AF344 = cellValue(() => IFERROR(R144 * AD174, '-'))
  AH344 = cellValue(() => IFERROR(AD144 * T174, '-'))
  AJ344 = cellValue(() => IFERROR(T144 * AD174, '-'))
  AL344 = cellValue(() => IFERROR(AD144 * AD174, '-'))
  AN344 = cellValue(() =>
    IF(
      SUM([
        H344,
        I344,
        J344,
        K344,
        L344,
        M344,
        N344,
        O344,
        P344,
        Q344,
        R344,
        S344,
        T344,
        U344,
        V344,
        W344,
        X344,
        Y344,
        Z344,
        AA344,
        AB344,
        AC344,
        AD344,
        AE344,
        AF344,
        AG344,
        AH344,
        AI344,
        AJ344,
        AK344,
        AL344,
      ]) <
        0 / 100,
      100 / 100 -
        SUM([
          H344,
          I344,
          J344,
          K344,
          L344,
          M344,
          N344,
          O344,
          P344,
          Q344,
          R344,
          S344,
          T344,
          U344,
          V344,
          W344,
          X344,
          Y344,
          Z344,
          AA344,
          AB344,
          AC344,
          AD344,
          AE344,
          AF344,
          AG344,
          AH344,
          AI344,
          AJ344,
          AK344,
          AL344,
        ]),
      SUM([
        H344,
        I344,
        J344,
        K344,
        L344,
        M344,
        N344,
        O344,
        P344,
        Q344,
        R344,
        S344,
        T344,
        U344,
        V344,
        W344,
        X344,
        Y344,
        Z344,
        AA344,
        AB344,
        AC344,
        AD344,
        AE344,
        AF344,
        AG344,
        AH344,
        AI344,
        AJ344,
        AK344,
        AL344,
      ]) -
        100 / 100
    )
  )
  H346 = cellValue(() => IF(H344 === '-', '-', 1 - H344))
  J346 = cellValue(() => IF(J344 === '-', '-', 1 - J344))
  L346 = cellValue(() => IF(L344 === '-', '-', 1 - L344))
  N346 = cellValue(() => IF(N344 === '-', '-', 1 - N344))
  P346 = cellValue(() => IF(P344 === '-', '-', 1 - P344))
  R346 = cellValue(() => IF(R344 === '-', '-', 1 - R344))
  T346 = cellValue(() => IF(T344 === '-', '-', 1 - T344))
  V346 = cellValue(() => IF(V344 === '-', '-', 1 - V344))
  X346 = cellValue(() => IF(X344 === '-', '-', 1 - X344))
  Z346 = cellValue(() => IF(Z344 === '-', '-', 1 - Z344))
  AB346 = cellValue(() => IF(AB344 === '-', '-', 1 - AB344))
  AD346 = cellValue(() => IF(AD344 === '-', '-', 1 - AD344))
  AF346 = cellValue(() => IF(AF344 === '-', '-', 1 - AF344))
  AH346 = cellValue(() => IF(AH344 === '-', '-', 1 - AH344))
  AJ346 = cellValue(() => IF(AJ344 === '-', '-', 1 - AJ344))
  AL346 = cellValue(() => IF(AL344 === '-', '-', 1 - AL344))
  AN346 = cellValue(() => IF(AN344 === '-', '-', 1 - AN344))
  H348 = cellValue(() => IFERROR(H338 + J338, '-'))
  J348 = cellValue(() => H348)
  L348 = cellValue(() => IFERROR(L338 + N338, '-'))
  N348 = cellValue(() => L348)
  AF348 = cellValue(() => IFERROR(AF344 + AH344, '-'))
  AH348 = cellValue(() => AF348)
  H349 = cellValue(() => AH337)
  J349 = cellValue(() => H349)
  L349 = cellValue(() => AH337)
  N349 = cellValue(() => L349)
  AF349 = cellValue(() => AH337)
  AH349 = cellValue(() => AF349)
  H350 = cellValue(() => 1 - H349)
  J350 = cellValue(() => H350)
  L350 = cellValue(() => 1 - L349)
  N350 = cellValue(() => L350)
  AF350 = cellValue(() => 1 - AF349)
  AH350 = cellValue(() => AF350)
  H351 = cellValue(() => IFERROR(H348 * H349, '-'))
  J351 = cellValue(() => IFERROR(J348 * J350, '-'))
  L351 = cellValue(() => IFERROR(L348 * L349, '-'))
  N351 = cellValue(() => IFERROR(N348 * N350, '-'))
  AF351 = cellValue(() => IFERROR(AF348 * AF349, '-'))
  AH351 = cellValue(() => IFERROR(AH348 * AH350, '-'))
  H352 = cellValue(() => IFERROR(1 - H351, '-'))
  J352 = cellValue(() => IFERROR(1 - J351, '-'))
  L352 = cellValue(() => IFERROR(1 - L351, '-'))
  N352 = cellValue(() => IFERROR(1 - N351, '-'))
  AF352 = cellValue(() => IFERROR(1 - AF351, '-'))
  AH352 = cellValue(() => IFERROR(1 - AH351, '-'))

  return {
    B3,
    D3,
    F3,
    H3,
    J3,
    L3,
    N3,
    BT3,
    BU3,
    J7,
    K7,
    L7,
    M7,
    N7,
    O7,
    P7,
    Q7,
    R7,
    S7,
    T7,
    U7,
    V7,
    W7,
    X7,
    Y7,
    Z7,
    AA7,
    AB7,
    AC7,
    AD7,
    AE7,
    AF7,
    AG7,
    AH7,
    AI7,
    AJ7,
    AK7,
    AL7,
    AM7,
    AN7,
    AO7,
    AP7,
    AQ7,
    AR7,
    AS7,
    AT7,
    AU7,
    AV7,
    AW7,
    AX7,
    AY7,
    AZ7,
    BA7,
    BB7,
    BC7,
    BD7,
    BE7,
    BF7,
    BG7,
    BH7,
    BI7,
    BJ7,
    BK7,
    BL7,
    BM7,
    BN7,
    BO7,
    BP7,
    BQ7,
    BR7,
    BS7,
    BT7,
    BU7,
    BV7,
    BW7,
    BX7,
    BY7,
    BZ7,
    CA7,
    CB7,
    CC7,
    CD7,
    CE7,
    CF7,
    B8,
    D8,
    F8,
    BT11,
    BU11,
    BV11,
    BW11,
    BX11,
    BY11,
    BZ11,
    Z12,
    AB12,
    AD12,
    AF12,
    AH12,
    AJ12,
    AP12,
    AT12,
    BA12,
    BB12,
    BC12,
    BD12,
    BE12,
    BT12,
    BU12,
    BV12,
    BW12,
    BX12,
    BY12,
    BZ12,
    CA12,
    CB12,
    CE12,
    BA13,
    BB13,
    BT13,
    BU13,
    BV13,
    BW13,
    BX13,
    BY13,
    BZ13,
    CA13,
    CB13,
    CE13,
    AJ14,
    AP14,
    AT14,
    BA14,
    BT14,
    BU14,
    BV14,
    BW14,
    BX14,
    BY14,
    BZ14,
    CA14,
    CH14,
    AJ15,
    B16,
    D16,
    F16,
    H16,
    J16,
    L16,
    N16,
    P16,
    R16,
    T16,
    V16,
    X16,
    AJ16,
    AP16,
    AT16,
    BT16,
    BU16,
    BV16,
    BW16,
    BX16,
    BY16,
    BZ16,
    CA16,
    CB16,
    CE16,
    CH16,
    BT17,
    BU17,
    BV17,
    BW17,
    BX17,
    BY17,
    BZ17,
    CB17,
    BC19,
    BD19,
    BE19,
    BF19,
    BG19,
    BH19,
    BI19,
    BJ19,
    BK19,
    BL19,
    BM19,
    BN19,
    BO19,
    BP19,
    BQ19,
    BT19,
    BU19,
    BV19,
    BW19,
    BX19,
    BY19,
    BZ19,
    CE19,
    BT20,
    BU20,
    BV20,
    BW20,
    BX20,
    BY20,
    BZ20,
    CB20,
    CE21,
    BT22,
    BU22,
    BV22,
    BW22,
    BX22,
    BY22,
    BZ22,
    CA22,
    CE22,
    BH23,
    CH23,
    BI24,
    H25,
    J25,
    L25,
    R25,
    T25,
    V25,
    X25,
    Z25,
    AB25,
    AD25,
    AI25,
    AJ25,
    AL25,
    AN25,
    AP25,
    AR25,
    AT25,
    AV25,
    AX25,
    CE25,
    CH25,
    H27,
    J27,
    L27,
    Z27,
    AB27,
    AD27,
    AR27,
    AT27,
    AV27,
    BT28,
    BU28,
    BV28,
    BW28,
    BX28,
    CE28,
    BT30,
    BU30,
    H31,
    J31,
    L31,
    Z31,
    AB31,
    AD31,
    AR31,
    AT31,
    AV31,
    H33,
    J33,
    L33,
    Z33,
    AB33,
    AD33,
    AR33,
    AT33,
    AV33,
    BT36,
    BU36,
    BV36,
    H37,
    J37,
    L37,
    N37,
    Z37,
    AB37,
    AR37,
    AT37,
    BT37,
    BU37,
    BV37,
    BW37,
    BX37,
    H39,
    J39,
    L39,
    N39,
    Z39,
    AB39,
    AR39,
    AT39,
    BT39,
    BU39,
    BV39,
    BW39,
    BY39,
    BT42,
    H43,
    J43,
    L43,
    AR43,
    AT43,
    H45,
    J45,
    L45,
    AR45,
    AT45,
    BT45,
    BU45,
    H49,
    J49,
    L49,
    N49,
    P49,
    R49,
    AR49,
    AT49,
    BT49,
    BU49,
    BT50,
    BU50,
    H51,
    J51,
    L51,
    N51,
    P51,
    R51,
    AR51,
    AT51,
    BT52,
    H57,
    J57,
    L57,
    N57,
    P57,
    R57,
    T57,
    V57,
    X57,
    Z57,
    AB57,
    AD57,
    AF57,
    AH57,
    AJ57,
    AL57,
    AN57,
    AP57,
    AR57,
    AT57,
    AV57,
    AX57,
    H59,
    J59,
    L59,
    N59,
    P59,
    R59,
    T59,
    V59,
    X59,
    Z59,
    AB59,
    AD59,
    AF59,
    AH59,
    AJ59,
    AL59,
    AN59,
    AP59,
    AR59,
    AT59,
    AV59,
    AX59,
    H63,
    J63,
    N63,
    P63,
    R63,
    T63,
    V63,
    X63,
    Z63,
    H65,
    J65,
    N65,
    P65,
    R65,
    T65,
    V65,
    X65,
    Z65,
    BT65,
    BU65,
    BT67,
    BU67,
    BT68,
    BU68,
    H69,
    J69,
    L69,
    N69,
    P69,
    R69,
    BT70,
    BU70,
    H71,
    J71,
    L71,
    N71,
    P71,
    R71,
    BT71,
    BU71,
    H75,
    J75,
    L75,
    N75,
    R75,
    V75,
    X75,
    Z75,
    AB75,
    H77,
    J77,
    L77,
    N77,
    R77,
    V77,
    X77,
    Z77,
    AB77,
    H81,
    J81,
    H83,
    J83,
    H87,
    J87,
    L87,
    N87,
    P87,
    R87,
    T87,
    V87,
    X87,
    Z87,
    AB87,
    AD87,
    AF87,
    AH87,
    AJ87,
    AL87,
    AN87,
    H89,
    J89,
    L89,
    N89,
    P89,
    R89,
    T89,
    V89,
    X89,
    Z89,
    AB89,
    AD89,
    AF89,
    AH89,
    AJ89,
    AL89,
    H93,
    J93,
    L93,
    N93,
    P93,
    R93,
    T93,
    V93,
    X93,
    Z93,
    AB93,
    AD93,
    AF93,
    AH93,
    AJ93,
    AL93,
    AN93,
    H94,
    J94,
    L94,
    N94,
    P94,
    R94,
    T94,
    V94,
    X94,
    Z94,
    AB94,
    AD94,
    AF94,
    AH94,
    AJ94,
    AL94,
    H96,
    J96,
    L96,
    N96,
    P96,
    R96,
    T96,
    V96,
    X96,
    Z96,
    AB96,
    AD96,
    AF96,
    AH96,
    AJ96,
    AL96,
    H100,
    J100,
    L100,
    P100,
    T100,
    X100,
    AB100,
    AF100,
    AJ100,
    AN100,
    AR100,
    AV100,
    H102,
    J102,
    L102,
    P102,
    T102,
    X102,
    AB102,
    AF102,
    AJ102,
    AN102,
    AR102,
    AV102,
    H106,
    L106,
    P106,
    T106,
    X106,
    AB106,
    AF106,
    AJ106,
    AN106,
    AR106,
    AV106,
    H108,
    L108,
    P108,
    T108,
    X108,
    AB108,
    AF108,
    AJ108,
    AN108,
    AR108,
    AV108,
    H112,
    L112,
    P112,
    T112,
    X112,
    AB112,
    AF112,
    AJ112,
    AN112,
    AR112,
    AV112,
    H114,
    L114,
    P114,
    T114,
    X114,
    AB114,
    AF114,
    AJ114,
    AN114,
    AR114,
    AV114,
    H118,
    L118,
    P118,
    T118,
    X118,
    AB118,
    AF118,
    AJ118,
    AN118,
    AR118,
    AV118,
    H120,
    L120,
    P120,
    T120,
    X120,
    AB120,
    AF120,
    AJ120,
    AN120,
    AR120,
    AV120,
    H124,
    L124,
    P124,
    T124,
    X124,
    AB124,
    AF124,
    AJ124,
    H126,
    L126,
    P126,
    T126,
    X126,
    AB126,
    AF126,
    AJ126,
    H130,
    J130,
    L130,
    N130,
    P130,
    R130,
    T130,
    V130,
    X130,
    Z130,
    AB130,
    AD130,
    AF130,
    AH130,
    AJ130,
    AL130,
    AN130,
    AP130,
    AR130,
    AT130,
    AV130,
    AX130,
    H132,
    J132,
    L132,
    N132,
    P132,
    R132,
    T132,
    V132,
    X132,
    Z132,
    AB132,
    AD132,
    AF132,
    AH132,
    AJ132,
    AL132,
    AN132,
    AP132,
    AR132,
    AT132,
    AV132,
    AX132,
    AJ134,
    AL134,
    AN134,
    AP134,
    AR134,
    AT134,
    H136,
    J136,
    L136,
    N136,
    J138,
    L138,
    N138,
    AF142,
    H144,
    J144,
    L144,
    N144,
    P144,
    R144,
    T144,
    V144,
    X144,
    Z144,
    AB144,
    AD144,
    H146,
    J146,
    L146,
    N146,
    P146,
    R146,
    T146,
    V146,
    X146,
    Z146,
    AB146,
    AD146,
    AF148,
    H150,
    J150,
    L150,
    N150,
    P150,
    R150,
    T150,
    V150,
    X150,
    Z150,
    AB150,
    AD150,
    H152,
    J152,
    L152,
    N152,
    P152,
    R152,
    T152,
    V152,
    X152,
    Z152,
    AB152,
    AD152,
    H156,
    L156,
    P156,
    T156,
    X156,
    AB156,
    AF156,
    AJ156,
    AN156,
    AR156,
    H158,
    L158,
    P158,
    T158,
    X158,
    AB158,
    AF158,
    AJ158,
    AN158,
    AR158,
    H162,
    J162,
    L162,
    N162,
    P162,
    R162,
    T162,
    V162,
    X162,
    Z162,
    AB162,
    AD162,
    AF162,
    AH162,
    AJ162,
    AL162,
    AN162,
    AP162,
    AR162,
    AT162,
    AV162,
    AX162,
    H164,
    J164,
    L164,
    N164,
    P164,
    R164,
    T164,
    V164,
    X164,
    Z164,
    AB164,
    AD164,
    AF164,
    AH164,
    AJ164,
    AL164,
    AN164,
    AP164,
    AR164,
    AT164,
    AV164,
    AX164,
    AJ166,
    AL166,
    AN166,
    AP166,
    AR166,
    AT166,
    H168,
    J168,
    L168,
    N168,
    J170,
    L170,
    N170,
    AF172,
    H174,
    J174,
    L174,
    N174,
    P174,
    R174,
    T174,
    V174,
    X174,
    Z174,
    AB174,
    AD174,
    H176,
    J176,
    L176,
    N176,
    P176,
    R176,
    T176,
    V176,
    X176,
    Z176,
    AB176,
    AD176,
    AF178,
    H180,
    J180,
    L180,
    N180,
    P180,
    R180,
    T180,
    V180,
    X180,
    Z180,
    AB180,
    AD180,
    H182,
    J182,
    L182,
    N182,
    P182,
    R182,
    T182,
    V182,
    X182,
    Z182,
    AB182,
    AD182,
    H186,
    L186,
    P186,
    T186,
    X186,
    AB186,
    AF186,
    AJ186,
    AN186,
    AR186,
    H188,
    L188,
    P188,
    T188,
    X188,
    AB188,
    AF188,
    AJ188,
    AN188,
    AR188,
    H192,
    J192,
    L192,
    N192,
    P192,
    R192,
    T192,
    H194,
    J194,
    L194,
    N194,
    P194,
    R194,
    T194,
    H198,
    J198,
    H200,
    J200,
    H204,
    J204,
    H206,
    J206,
    H210,
    J210,
    L210,
    H212,
    J212,
    L212,
    J215,
    L215,
    T215,
    V215,
    H218,
    J218,
    L218,
    N218,
    P218,
    R218,
    T218,
    V218,
    X218,
    H220,
    J220,
    L220,
    N220,
    P220,
    R220,
    T220,
    V220,
    X220,
    H224,
    J224,
    L224,
    N224,
    P224,
    R224,
    T224,
    V224,
    X224,
    Z224,
    AB224,
    AD224,
    AF224,
    AH224,
    AJ224,
    AL224,
    AN224,
    AP224,
    AR224,
    AT224,
    AV224,
    AX224,
    H226,
    J226,
    L226,
    N226,
    P226,
    R226,
    T226,
    V226,
    X226,
    Z226,
    AB226,
    AD226,
    AF226,
    AH226,
    AJ226,
    AL226,
    AN226,
    AP226,
    AR226,
    AT226,
    AV226,
    AX226,
    H230,
    J230,
    L230,
    N230,
    P230,
    H232,
    J232,
    L232,
    N232,
    P232,
    H238,
    J238,
    L238,
    H240,
    J240,
    L240,
    H244,
    J244,
    L244,
    H246,
    J246,
    L246,
    H252,
    J252,
    L252,
    N252,
    P252,
    R252,
    T252,
    V252,
    X252,
    Z252,
    AD252,
    AF252,
    AH252,
    AJ252,
    AL252,
    AN252,
    AP252,
    AR252,
    AT252,
    AV252,
    AX252,
    H254,
    J254,
    L254,
    N254,
    P254,
    R254,
    T254,
    V254,
    X254,
    Z254,
    AD254,
    AF254,
    AH254,
    AJ254,
    AL254,
    AN254,
    AP254,
    AR254,
    AT254,
    AV254,
    AX254,
    H258,
    J258,
    L258,
    N258,
    P258,
    R258,
    T258,
    V258,
    X258,
    Z258,
    AD258,
    AF258,
    AH258,
    AJ258,
    AL258,
    AN258,
    AP258,
    AR258,
    AT258,
    AV258,
    AX258,
    H260,
    J260,
    L260,
    N260,
    P260,
    R260,
    T260,
    V260,
    X260,
    Z260,
    AD260,
    AF260,
    AH260,
    AJ260,
    AL260,
    AN260,
    AP260,
    AR260,
    AT260,
    AV260,
    AX260,
    H264,
    J264,
    N264,
    P264,
    R264,
    T264,
    V264,
    X264,
    Z264,
    AB264,
    H266,
    J266,
    N266,
    P266,
    R266,
    T266,
    V266,
    X266,
    Z266,
    AB266,
    H270,
    J270,
    L270,
    H272,
    J272,
    L272,
    H276,
    J276,
    L276,
    N276,
    P276,
    R276,
    T276,
    V276,
    X276,
    Z276,
    AB276,
    AD276,
    AF276,
    AH276,
    AJ276,
    AL276,
    AN276,
    AP276,
    AR276,
    AS276,
    AT276,
    AV276,
    AX276,
    H278,
    J278,
    L278,
    N278,
    P278,
    R278,
    T278,
    V278,
    X278,
    Z278,
    AB278,
    AD278,
    AF278,
    AH278,
    AJ278,
    AL278,
    AN278,
    AP278,
    AR278,
    AT278,
    AV278,
    AX278,
    H282,
    J282,
    L282,
    P282,
    R282,
    T282,
    V282,
    X282,
    Z282,
    AB282,
    AD282,
    AF282,
    AH282,
    AJ282,
    AL282,
    AN282,
    AP282,
    AR282,
    AT282,
    AV282,
    AX282,
    H284,
    J284,
    L284,
    P284,
    R284,
    T284,
    V284,
    X284,
    Z284,
    AB284,
    AD284,
    AF284,
    AH284,
    AJ284,
    AL284,
    AN284,
    AP284,
    AR284,
    AT284,
    AV284,
    AX284,
    H288,
    J288,
    L288,
    N288,
    P288,
    R288,
    T288,
    V288,
    X288,
    Z288,
    AB288,
    AD288,
    AF288,
    H290,
    J290,
    L290,
    N290,
    P290,
    R290,
    T290,
    V290,
    X290,
    Z290,
    AB290,
    AD290,
    AF290,
    H294,
    J294,
    L294,
    N294,
    P294,
    R294,
    T294,
    V294,
    X294,
    Z294,
    AB294,
    AD294,
    AF294,
    AJ294,
    AL294,
    AN294,
    H296,
    J296,
    L296,
    N296,
    P296,
    R296,
    T296,
    V296,
    X296,
    Z296,
    AB296,
    AD296,
    AF296,
    AJ296,
    AL296,
    AN296,
    H300,
    J300,
    L300,
    N300,
    P300,
    R300,
    T300,
    X300,
    Z300,
    AB300,
    AD300,
    AF300,
    AH300,
    AJ300,
    AN300,
    AP300,
    AR300,
    AT300,
    AV300,
    H302,
    J302,
    L302,
    N302,
    P302,
    R302,
    T302,
    X302,
    Z302,
    AB302,
    AD302,
    AF302,
    AH302,
    AJ302,
    AN302,
    AP302,
    AR302,
    AT302,
    AV302,
    H306,
    J306,
    L306,
    N306,
    P306,
    R306,
    T306,
    V306,
    X306,
    Z306,
    AB306,
    AD306,
    AF306,
    AH306,
    AJ306,
    AL306,
    AN306,
    AP306,
    AR306,
    AT306,
    AV306,
    AX306,
    H308,
    J308,
    L308,
    N308,
    P308,
    R308,
    T308,
    V308,
    X308,
    Z308,
    AB308,
    AD308,
    AF308,
    AH308,
    AJ308,
    AL308,
    AN308,
    AP308,
    AR308,
    AT308,
    AV308,
    AX308,
    H312,
    J312,
    L312,
    N312,
    P312,
    R312,
    T312,
    V312,
    X312,
    Z312,
    AB312,
    AD312,
    AF312,
    AH312,
    AJ312,
    AL312,
    AN312,
    AP312,
    AR312,
    AT312,
    AV312,
    AX312,
    H314,
    J314,
    L314,
    N314,
    P314,
    R314,
    T314,
    V314,
    X314,
    Z314,
    AB314,
    AD314,
    AF314,
    AH314,
    AJ314,
    AL314,
    AN314,
    AP314,
    AR314,
    AT314,
    AV314,
    AX314,
    H318,
    J318,
    L318,
    N318,
    P318,
    R318,
    T318,
    V318,
    X318,
    Z318,
    AB318,
    AD318,
    AH318,
    AJ318,
    AL318,
    AN318,
    AP318,
    AR318,
    AT318,
    AV318,
    AX318,
    H320,
    J320,
    L320,
    N320,
    P320,
    R320,
    T320,
    V320,
    X320,
    Z320,
    AB320,
    AH320,
    AJ320,
    AL320,
    AN320,
    AP320,
    AR320,
    AT320,
    AV320,
    AX320,
    H324,
    J324,
    L324,
    N324,
    P324,
    R324,
    H326,
    J326,
    L326,
    N326,
    P326,
    R326,
    H332,
    I332,
    J332,
    K332,
    L332,
    M332,
    N332,
    O332,
    P332,
    Q332,
    R332,
    S332,
    T332,
    U332,
    V332,
    W332,
    X332,
    Y332,
    Z332,
    AA332,
    AB332,
    AC332,
    AD332,
    AE332,
    AF332,
    AG332,
    AH332,
    AI332,
    AJ332,
    AK332,
    AL332,
    AM332,
    AN332,
    AO332,
    AP332,
    AQ332,
    AR332,
    AS332,
    AT332,
    AU332,
    AV332,
    AW332,
    AX332,
    H334,
    J334,
    L334,
    N334,
    P334,
    R334,
    T334,
    V334,
    X334,
    Z334,
    AB334,
    AD334,
    AF334,
    AH334,
    AJ334,
    AL334,
    AN334,
    AP334,
    AR334,
    AT334,
    AV334,
    AX334,
    AH336,
    AJ336,
    AL336,
    AN336,
    AP336,
    AR336,
    AH337,
    AJ337,
    AL337,
    AN337,
    AP337,
    AR337,
    H338,
    I338,
    J338,
    K338,
    L338,
    M338,
    N338,
    O338,
    P338,
    Q338,
    R338,
    T338,
    AH338,
    AJ338,
    AL338,
    AN338,
    AP338,
    AR338,
    AH339,
    AJ339,
    AL339,
    AN339,
    AP339,
    AR339,
    H340,
    J340,
    L340,
    N340,
    P340,
    R340,
    T340,
    AH340,
    AJ340,
    AL340,
    AN340,
    AP340,
    AR340,
    H344,
    I344,
    J344,
    K344,
    L344,
    M344,
    N344,
    O344,
    P344,
    Q344,
    R344,
    S344,
    T344,
    U344,
    V344,
    W344,
    X344,
    Y344,
    Z344,
    AA344,
    AB344,
    AC344,
    AD344,
    AE344,
    AF344,
    AG344,
    AH344,
    AI344,
    AJ344,
    AK344,
    AL344,
    AN344,
    H346,
    J346,
    L346,
    N346,
    P346,
    R346,
    T346,
    V346,
    X346,
    Z346,
    AB346,
    AD346,
    AF346,
    AH346,
    AJ346,
    AL346,
    AN346,
    H348,
    J348,
    L348,
    N348,
    AF348,
    AH348,
    H349,
    J349,
    L349,
    N349,
    AF349,
    AH349,
    H350,
    J350,
    L350,
    N350,
    AF350,
    AH350,
    H351,
    J351,
    L351,
    N351,
    AF351,
    AH351,
    H352,
    J352,
    L352,
    N352,
    AF352,
    AH352,
  }
}

const RESULT_CELL_MAP = {
  goalsAndExactScores: {
    averageGoals: ['AJ12', 'AJ14', 'AJ16'],
    averageExactScore: ['AP12', 'AP14', 'AP16'],
    averageExactScoreDecimal: ['AT12', 'AT14', 'AT16'],
  },
  finalOutcome: {
    finalOutcome: ['H25', 'J25', 'L25'],
    doubleChance: ['H31', 'J31', 'L31'],
    doubleWin: ['H37', 'J37', 'L37', 'N37'],
    halftimeFulltime: ['H43', 'J43', 'L43'],
    winByMargin: ['H49', 'J49', 'L49', 'N49', 'P49', 'R49'],
    firstHalf: ['Z25', 'AB25', 'AD25'],
    doubleChanceFirstHalf: ['Z31', 'AB31', 'AD31'],
    superWin: ['Z37', 'AB37'],
    secondHalf: ['AR25', 'AT25', 'AV25'],
    doubleChanceSecondHalf: ['AR31', 'AT31', 'AV31'],
    winner: ['AR37', 'AT37'],
    winnerFirstHalf: ['AR43', 'AT43'],
    winnerSecondHalf: ['AR49', 'AT49'],
  },
  goalsByTeam: {
    homeGoalsMix: [
      'H186',
      'L186',
      'P186',
      'T186',
      'X186',
      'AB186',
      'AF186',
      'AJ186',
      'AN186',
      'AR186',
    ],
  },
  halftimeEnd: {
    halftimeEnd: [
      'H218',
      'J218',
      'L218',
      'N218',
      'P218',
      'R218',
      'T218',
      'V218',
      'X218',
      'H220',
      'X220',
      'N220',
      'P220',
      'R220',
      'L220',
      'J220',
      'T220',
      'V220',
    ],
    halftimeEndDoubleChance: [
      'H224',
      'J224',
      'L224',
      'N224',
      'P224',
      'R224',
      'T224',
      'V224',
      'X224',
      'Z224',
      'AB224',
      'AD224',
      'AF224',
      'AH224',
      'AJ224',
      'AL224',
      'AN224',
      'AP224',
      'AR224',
      'AT224',
      'AV224',
      'AX224',
      'H230',
      'J230',
      'L230',
      'N230',
      'P230',
    ],
  },
  handicaps: {
    handicapMinus1: ['H238', 'J238', 'L238'],
    handicapMinus2: ['H244', 'J244', 'L244'],
  },
  totalGoals: {
    goalRangeOf1: ['H57', 'J57', 'L57', 'N57', 'P57', 'R57'],
    goalRangeOf2: ['T57', 'V57', 'X57', 'Z57', 'AB57'],
    goalRangeOf3: ['AD57', 'AF57', 'AH57', 'AJ57'],
    goalRangeOf4: ['AL57', 'AN57', 'AP57'],
    goalPlus: ['AR57', 'AT57', 'AV57', 'AX57', 'H63', 'J63'],
    exactScore: ['N63', 'P63', 'R63', 'T63', 'V63', 'X63', 'Z63'],
    bothTeamsScore: ['H69', 'J69', 'L69', 'N69', 'P69', 'R69'],
    firstGoal: ['H75', 'J75', 'L75', 'N75', 'R75', 'V75', 'X75', 'Z75', 'AB75'],
    lastGoal: ['H81', 'J81'],
    totalGoalsFirstHalf: [
      'H87',
      'J87',
      'L87',
      'N87',
      'P87',
      'R87',
      'T87',
      'V87',
      'X87',
      'Z87',
      'AB87',
      'AD87',
      'AF87',
      'AH87',
      'AJ87',
      'AL87',
    ],
    totalGoalsSecondHalf: [
      'H93',
      'J93',
      'L93',
      'N93',
      'P93',
      'R93',
      'T93',
      'V93',
      'X93',
      'Z93',
      'AB93',
      'AD93',
      'AF93',
      'AH93',
      'AJ93',
      'AL93',
    ],
    goalSpreadOf1: [
      'H100',
      'J100',
      'L100',
      'P100',
      'T100',
      'X100',
      'AB100',
      'AF100',
      'AJ100',
      'AN100',
      'AV100',
      'H106',
      'L106',
      'P106',
      'T106',
      'X106',
      'AB106',
      'AF106',
      'AJ106',
      'AN106',
      'AR106',
      'AV106',
      'H112',
      'L112',
      'P112',
      'T112',
      'X112',
      'AB112',
      'AF112',
      'AJ112',
      'AN112',
      'AR112',
      'AV112',
      'H118',
      'L118',
      'P118',
      'T118',
      'X118',
      'AB118',
      'AF118',
      'AJ118',
      'AN118',
      'AR118',
      'AV118',
      'H124',
      'L124',
      'P124',
      'T124',
      'X124',
      'AB124',
      'AF124',
      'AJ124',
    ],
    homeGoals: [
      'H130',
      'J130',
      'L130',
      'N130',
      'P130',
      'R130',
      'T130',
      'V130',
      'X130',
      'Z130',
      'AB130',
      'AD130',
      'AF130',
      'AH130',
      'AJ130',
      'AL130',
      'AN130',
      'AP130',
      'AR130',
      'AT130',
      'AV130',
      'J136',
      'L136',
      'N136',
    ],
    homeGoalsFirstHalf: [
      'H144',
      'J144',
      'L144',
      'N144',
      'P144',
      'R144',
      'T144',
      'V144',
      'X144',
      'Z144',
      'AB144',
      'AD144',
    ],
    homeGoalsSecondHalf: [
      'H150',
      'J150',
      'L150',
      'N150',
      'P150',
      'R150',
      'T150',
      'V150',
      'X150',
      'Z150',
      'AB150',
      'AD150',
    ],
    homeGoalsHomeMix: [
      'H156',
      'L156',
      'P156',
      'T156',
      'X156',
      'AB156',
      'AF156',
      'AJ156',
      'AN156',
      'AR156',
    ],
    guestGoals: [
      'H162',
      'J162',
      'L162',
      'N162',
      'P162',
      'R162',
      'T162',
      'V162',
      'X162',
      'Z162',
      'AB162',
      'AD162',
      'AF162',
      'AH162',
      'AJ162',
      'AL162',
      'AN162',
      'AP162',
      'AR162',
      'AT162',
      'AV162',
      'J168',
      'L168',
      'N168',
    ],
    guestGoalsFirstHalf: [
      'H174',
      'J174',
      'L174',
      'N174',
      'P174',
      'R174',
      'T174',
      'V174',
      'X174',
      'Z174',
      'AB174',
      'AD174',
    ],
    guestGoalsSecondHalf: [
      'H180',
      'J180',
      'L180',
      'N180',
      'P180',
      'R180',
      'T180',
      'V180',
      'X180',
      'Z180',
      'AB180',
      'AD180',
    ],
    homeGoalsMix: [
      'H186',
      'L186',
      'P186',
      'T186',
      'X186',
      'AB186',
      'AF186',
      'AJ186',
      'AN186',
      'AR186',
    ],
    mixGG: ['H192', 'J192', 'L192', 'N192', 'P192', 'R192', 'T192'],
    scoreOrNoScoreHome: ['H198', 'J198'],
    scoreOrNoScoreAway: ['H204', 'J204'],
    moreGoalsIn: ['H210', 'J210', 'L210'],
  },
  mixGames: {
    finalOutcomeGoals: [
      'H252',
      'J252',
      'L252',
      'N252',
      'P252',
      'R252',
      'T252',
      'V252',
      'X252',
      'Z252',
      'AD252',
      'AF252',
      'AH252',
      'AJ252',
      'AL252',
      'AN252',
      'AP252',
      'AR252',
      'AT252',
      'AV252',
      'AX252',
      'H258',
      'J258',
      'L258',
      'N258',
      'P258',
      'R258',
      'T258',
      'X258',
      'Z258',
      'AD258',
      'AF258',
      'AH258',
      'AJ258',
      'AL258',
      'AN258',
      'AP258',
      'AR258',
      'AT258',
      'AV258',
      'AX258',
      'H264',
      'J264',
      'N264',
      'P264',
      'R264',
      'T264',
      'V264',
      'X264',
      'Z264',
      'AB264',
    ],
    finalOutcomeGG: ['H270', 'J270', 'L270'],
    mixDoubleChanceGoals: [
      'H276',
      'J276',
      'L276',
      'N276',
      'P276',
      'R276',
      'T276',
      'V276',
      'X276',
      'Z276',
      'AB276',
      'AD276',
      'AF276',
      'AH276',
      'AJ276',
      'AL276',
      'AP276',
      'AR276',
      'AS276',
      'AT276',
      'AV276',
      'AX276',
      'AB282',
      'L282',
      'P282',
      'R282',
      'T282',
      'V282',
      'AB282',
      'AD282',
      'AF282',
      'AH282',
      'AJ282',
      'AL282',
      'AN282',
      'AP282',
      'AR282',
      'AT282',
      'AV282',
      'AX282',
      'H288',
      'J288',
      'L288',
      'N288',
      'P288',
      'R288',
      'T288',
      'AB288',
      'AD288',
      'AF288',
    ],
    orOr: [
      'H294',
      'J294',
      'L294',
      'N294',
      'P294',
      'R294',
      'T294',
      'V294',
      'X294',
      'Z294',
      'AB294',
      'AD294',
      'AF294',
      'AJ294',
      'AL294',
      'AN294',
    ],
    mixGGandNEGG: [
      'H300',
      'J300',
      'L300',
      'N300',
      'P300',
      'R300',
      'T300',
      'X300',
      'Z300',
      'AB300',
      'AD300',
      'AF300',
      'AH300',
      'AJ300',
      'AN300',
      'AP300',
      'AR300',
      'AT300',
      'AV300',
    ],
    mixHalftimeGoals: [
      'H306',
      'J306',
      'L306',
      'N306',
      'P306',
      'R306',
      'T306',
      'V306',
      'X306',
      'Z306',
      'AB306',
      'AD306',
      'AF306',
      'AH306',
      'AJ306',
      'AL306',
      'AN306',
      'AP306',
      'AR306',
      'AT306',
      'AV306',
      'AX306',
      'H312',
      'J312',
      'L312',
      'N312',
      'P312',
      'R312',
      'T312',
      'V312',
      'X312',
      'Z312',
      'AB312',
      'AD312',
      'AF312',
      'AH312',
      'AJ312',
      'AL312',
      'AN312',
      'AP312',
      'AR312',
      'AT312',
      'AV312',
      'AX312',
      'H318',
      'J318',
      'L318',
      'N318',
      'P318',
      'R318',
      'T318',
      'V318',
      'X318',
      'Z318',
      'AB318',
      'AD318',
      'AH318',
      'AJ318',
      'AL318',
      'AN318',
      'AP318',
      'AR318',
      'AT318',
      'AV318',
      'AX318',
      'H324',
      'J324',
      'L324',
      'N324',
      'P324',
      'R324',
    ],
  },
  exactScore: {
    exactScore: [
      'H332',
      'J332',
      'L332',
      'N332',
      'P332',
      'R332',
      'T332',
      'V332',
      'X332',
      'Z332',
      'AB332',
      'AD332',
      'AF332',
      'AH332',
      'AJ332',
      'AL332',
      'AN332',
      'AP332',
      'AR332',
      'AT332',
      'AV332',
      'AX332',
      'H338',
      'J338',
      'L338',
      'N338',
      'T338',
    ],
    exactScoreFirstHalf: [
      'H344',
      'J344',
      'L344',
      'N344',
      'P344',
      'R344',
      'T344',
      'V344',
      'X344',
      'Z344',
      'AB344',
      'AD344',
      'AF344',
      'AH344',
      'AJ344',
      'AL344',
      'AN344',
    ],
  },
}

const parseInputNumber = (value) => {
  const number = Number(value)
  return Number.isFinite(number) && number > 0 ? number : null
}

const isInvalid = (value) =>
  value === '-' ||
  value === '' ||
  value === null ||
  value === undefined ||
  (typeof value === 'number' && !Number.isFinite(value))

const normalizeNumber = (value) => {
  if (typeof value === 'number') return Number.isFinite(value) ? value : NaN
  if (value === true) return 1
  if (value === false || isInvalid(value)) return 0
  const number = Number(String(value).replace(',', '.'))
  return Number.isFinite(number) ? number : 0
}

const flatten = (values) => values.flat(Infinity)

const SUM = (...values) =>
  flatten(values).reduce((sum, value) => sum + normalizeNumber(value), 0)

const AVERAGE = (...values) => {
  const numbers = flatten(values)
    .filter((value) => !isInvalid(value))
    .map(normalizeNumber)
    .filter(Number.isFinite)
  return numbers.length ? SUM(numbers) / numbers.length : NaN
}

const ROUND = (value, decimals = 0) => {
  const factor = 10 ** normalizeNumber(decimals)
  return Math.round(normalizeNumber(value) * factor) / factor
}

const LEFT = (value, chars = 1) =>
  String(value ?? '').slice(0, normalizeNumber(chars))

const N = (value) => normalizeNumber(value)
const OR = (...values) => values.some(Boolean)
const AND = (...values) => values.every(Boolean)
const IF = (condition, yesValue, noValue) => (condition ? yesValue : noValue)
const IFERROR = (value, fallback) => (isInvalid(value) ? fallback : value)
const EQUALS = (left, right) =>
  Math.abs(normalizeNumber(left) - normalizeNumber(right)) < 0.0000001

const cellValue = (calculateValue) => {
  try {
    const value = calculateValue()
    return isInvalid(value) ? '-' : value
  } catch (error) {
    return '-'
  }
}

const formatResultCell = (value, withPercent = true) => {
  if (!withPercent && typeof value === 'string') {
    const trimmedValue = value.trim()
    return trimmedValue && trimmedValue !== '-' ? trimmedValue : '-'
  }

  const numericValue =
    typeof value === 'string' && value.trim() !== ''
      ? Number(value.trim().replace(',', '.'))
      : value

  if (typeof value === 'string' && !Number.isFinite(numericValue)) return '-'
  if (!Number.isFinite(numericValue)) return '-'

  const displayValue = withPercent ? numericValue * 100 : numericValue
  if (!Number.isFinite(displayValue)) return '-'

  const roundedValue = Number(displayValue.toFixed(2))
  return roundedValue
}

const buildResults = (valuesByName) => {
  const results = {}

  Object.entries(RESULT_CELL_MAP).forEach(([sectionKey, section]) => {
    results[sectionKey] = {}

    Object.entries(section).forEach(([subKey, resultVariables]) => {
      const withPercent = sectionKey !== 'goalsAndExactScores'
      results[sectionKey][subKey] = resultVariables.map((variableName) =>
        variableName
          ? formatResultCell(valuesByName[variableName], withPercent)
          : '-'
      )
    })
  })

  return results
}

export const calculateFudbalSveIgre = ({ odds, totalGoals, bothTeams }) => {
  const inputs = [...(odds || []), ...(totalGoals || []), ...(bothTeams || [])]
  const allValid =
    inputs.length === 7 &&
    inputs.every((value) => parseInputNumber(value) !== null)

  if (!allValid) return null

  try {
    return buildResults(calculateWorkbookValues({ odds, totalGoals, bothTeams }))
  } catch (error) {
    return null
  }
}

export const isValidFudbalSveIgreInput = ({ odds, totalGoals, bothTeams }) =>
  [...(odds || []), ...(totalGoals || []), ...(bothTeams || [])].length === 7 &&
  [...(odds || []), ...(totalGoals || []), ...(bothTeams || [])].every(
    (value) => parseInputNumber(value) !== null
  )
